export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Time: { input: any; output: any; }
};

/** Not implemented yet */
export enum AddBlockAttachmentError {
  ADD_BLOCK_ATTACHMENT_ERRORED = 'ADD_BLOCK_ATTACHMENT_ERRORED',
  EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT = 'EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  /** Block was not found */
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

/** Attachment captured for a block */
export type AddBlockAttachmentInput = {
  /** A list of attachment inputs for this block. */
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  id: Scalars['ID']['input'];
};

/** Payload after adding attachment to an existing block */
export type AddBlockAttachmentPayload = {
  block?: Maybe<Block>;
  error?: Maybe<AddBlockAttachmentError>;
};

export enum AddBlockCommentError {
  ADD_BLOCK_COMMENT_ERRORED = 'ADD_BLOCK_COMMENT_ERRORED',
  COMMENT_TOO_LARGE = 'COMMENT_TOO_LARGE',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

/** Add Comments to an existing block */
export type AddBlockCommentInput = {
  blockId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
};

/** Block payload for adding a comment to a block */
export type AddBlockCommentPayload = {
  block?: Maybe<Block>;
  error?: Maybe<AddBlockCommentError>;
};

export enum AddCommodityAttachmentError {
  ADD_COMMODITY_ATTACHMENT_ERRORED = 'ADD_COMMODITY_ATTACHMENT_ERRORED',
  COMMODITY_NOT_FOUND = 'COMMODITY_NOT_FOUND',
  INVALID_COMMODITY_ID = 'INVALID_COMMODITY_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type AddCommodityAttachmentInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  commodityId: Scalars['ID']['input'];
};

export type AddCommodityAttachmentPayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<AddCommodityAttachmentError>;
};

export enum AddCrewChangeRequestError {
  ADD_CREW_CHANGE_REQUEST_MUTATION_ERRORED = 'ADD_CREW_CHANGE_REQUEST_MUTATION_ERRORED',
  ALREADY_REQUEST_PENDING_FOR_APPROVAL = 'ALREADY_REQUEST_PENDING_FOR_APPROVAL',
  CREW_DATA_NOT_FOUND = 'CREW_DATA_NOT_FOUND',
  EIS_ERROR = 'EIS_ERROR',
  INVALID_CREW = 'INVALID_CREW',
  INVALID_CREW_CHANGE_REQUEST = 'INVALID_CREW_CHANGE_REQUEST',
  INVALID_HIERARCHY = 'INVALID_HIERARCHY',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

export type AddCrewChangeRequestInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  destinationHierarchy: CrewChangeHierarchyInput;
  moveType: CrewChangeRequestMoveType;
  sourceHierarchy: CrewChangeHierarchyInput;
};

export type AddCrewChangeRequestPayload = {
  crewChangeRequest?: Maybe<CrewChangeRequest>;
  error?: Maybe<AddCrewChangeRequestError>;
};

export enum AddDataflowEntityMappingError {
  ADD_DATAFLOW_ENTITY_MAPPING_ERRORED = 'ADD_DATAFLOW_ENTITY_MAPPING_ERRORED',
  DUPLICATE_MAPPING_FOUND = 'DUPLICATE_MAPPING_FOUND',
  INVALID_ENTITY_REGISTRY = 'INVALID_ENTITY_REGISTRY',
  INVALID_PROJECT_ID = 'INVALID_PROJECT_ID',
  INVALID_RECEIVER_CODE_DATA_TYPE = 'INVALID_RECEIVER_CODE_DATA_TYPE',
  INVALID_SENDER_CODE_DATA_TYPE = 'INVALID_SENDER_CODE_DATA_TYPE'
}

export type AddDataflowEntityMappingInput = {
  dataflowDirection: DataflowDirection;
  isFilter?: InputMaybe<Scalars['Boolean']['input']>;
  isReceiverFieldKey?: InputMaybe<Scalars['Boolean']['input']>;
  isSenderFieldKey?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  projectsDataflowEntityRegistryId: Scalars['ID']['input'];
  receiverFieldDataType: Scalars['String']['input'];
  receiverFieldDescription?: InputMaybe<Scalars['String']['input']>;
  receiverFieldPath: Scalars['String']['input'];
  senderFieldDataType: Scalars['String']['input'];
  senderFieldDescription?: InputMaybe<Scalars['String']['input']>;
  senderFieldPath: Scalars['String']['input'];
};

export type AddDataflowEntityMappingPayload = {
  dataflowEntityMappings?: Maybe<Array<DataflowEntityMapping>>;
  errors?: Maybe<Array<AddDataflowEntityMappingsError>>;
};

export type AddDataflowEntityMappingsError = {
  DataflowEntityMappingErrorPayload?: Maybe<DataflowEntityMappingErrorPayload>;
  errorCodes?: Maybe<Array<AddDataflowEntityMappingError>>;
};

/** Error code while adding a default permission */
export enum AddDefaultPermissionError {
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

export type AddDefaultPermissionInput = {
  permissionScopeId: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

/** Payload returned on call to addDefaultPermission. */
export type AddDefaultPermissionPayload = {
  error?: Maybe<AddDefaultPermissionError>;
  permission: Array<DefaultRolePermission>;
};

export type AddEisArtifactInput = {
  /** LOB/App Code of Commodity */
  appCode: Scalars['String']['input'];
  /** Appplication Object Name */
  applicationObjectName: Scalars['String']['input'];
  /** Commodity type Id wrt EIS */
  eisEntityTypeId: Scalars['String']['input'];
  /** EIS mutation */
  mutation: Scalars['String']['input'];
  /** Source instance scope type, from DFTracking API */
  sourceInstanceScopeType?: InputMaybe<Scalars['String']['input']>;
  /** SubScope value, from DFTracking API */
  subScope?: InputMaybe<Scalars['String']['input']>;
  /** Target instance scope type, from DFTracking API */
  targetInstanceScopeType?: InputMaybe<Scalars['String']['input']>;
  /** EIS mutation variables */
  variables: Scalars['String']['input'];
};

export enum AddImportScheduleError {
  ERROR_SCHEDULING_IMPORT = 'ERROR_SCHEDULING_IMPORT',
  IMPORT_SCHEDULE_DISABLED = 'IMPORT_SCHEDULE_DISABLED',
  INVALID_SCHEDULE_DATETIME = 'INVALID_SCHEDULE_DATETIME',
  SCHEDULE_ALREADY_EXIST = 'SCHEDULE_ALREADY_EXIST'
}

export type AddImportScheduleInput = {
  importType: ImportType;
  scheduleDatetime: Scalars['Datetime']['input'];
};

export type AddImportSchedulePayload = {
  error?: Maybe<AddImportScheduleError>;
  importSchedule?: Maybe<ImportSchedule>;
};

export enum AddMilestoneAttachmentError {
  ADD_MILESTONE_ATTACHMENT_ERRORED = 'ADD_MILESTONE_ATTACHMENT_ERRORED',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type AddMilestoneAttachmentInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  commodityMilestoneId: Scalars['ID']['input'];
};

export type AddMilestoneAttachmentPayload = {
  error?: Maybe<AddMilestoneAttachmentError>;
  milestone?: Maybe<CommodityMilestone>;
};

export type AddProjectCommodityTypeInput = {
  /** Eis Artifact Input */
  artifact?: InputMaybe<AddEisArtifactInput>;
  /** Calculation Config */
  calculationConfig?: InputMaybe<Scalars['String']['input']>;
  isItrApplicable: Scalars['Boolean']['input'];
  lobCommodityCode: Scalars['String']['input'];
  lobCommodityTypeId: Scalars['String']['input'];
  lobTemplateCode: Scalars['String']['input'];
  lobTemplateTypeId: Scalars['String']['input'];
  /** Commodity material tracking */
  materialTrackingTypeId?: InputMaybe<MaterialTrackingCode>;
  /** Commodity type display name */
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
  unitOfMeasure: UnitOfMeasure;
};

export type AddProjectMilestoneTypeInput = {
  projectCommodityTypeIds: Array<Scalars['ID']['input']>;
};

/** Error code while adding a project permission */
export enum AddProjectPermissionError {
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

export type AddProjectPermissionInput = {
  permissionScopeId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  roleId: Scalars['String']['input'];
  rolePermissionScopeId: Scalars['String']['input'];
};

/** Payload returned on call to addProjectPermission. */
export type AddProjectPermissionPayload = {
  error?: Maybe<AddProjectPermissionError>;
  permission: Array<ProjectRolePermission>;
};

export enum AddProjectReportError {
  ADD_REPORT_ERRORED = 'ADD_REPORT_ERRORED',
  MISSING_REPORT_NAME = 'MISSING_REPORT_NAME',
  MISSING_REPORT_POWERBI_URL = 'MISSING_REPORT_POWERBI_URL',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  REPORT_NAME_EXISTS = 'REPORT_NAME_EXISTS'
}

export type AddProjectReportInput = {
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  powerbiUrl: Scalars['String']['input'];
};

export type AddProjectReportPayload = {
  /** Error in add */
  error?: Maybe<AddProjectReportError>;
  /** Project Report details */
  projectReport?: Maybe<ProjectReport>;
};

export enum AddRoleError {
  NOT_FOUND = 'NOT_FOUND',
  ROLE_ALREADY_EXISTS = 'ROLE_ALREADY_EXISTS'
}

export type AddRoleInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sourceRoleId: Scalars['ID']['input'];
};

export type AddRolePayload = {
  error?: Maybe<AddRoleError>;
  role?: Maybe<AuthRole>;
};

export enum AddUserError {
  ADD_USER_ERRORED = 'ADD_USER_ERRORED',
  INVALID_DISCIPLINE_ID = 'INVALID_DISCIPLINE_ID',
  INVALID_LOB_EMPLOYEE_ID = 'INVALID_LOB_EMPLOYEE_ID',
  INVALID_ROLE_ID = 'INVALID_ROLE_ID',
  MISSING_USER_BECIMSID = 'MISSING_USER_BECIMSID',
  MISSING_USER_BUN = 'MISSING_USER_BUN',
  MISSING_USER_FIRST_NAME = 'MISSING_USER_FIRST_NAME',
  MISSING_USER_LAST_NAME = 'MISSING_USER_LAST_NAME',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  USER_NOT_SAVED = 'USER_NOT_SAVED'
}

export type AddUserInput = {
  /** BECIMS ID */
  becImsId?: InputMaybe<Scalars['String']['input']>;
  /** BUN of the user */
  bun: Scalars['String']['input'];
  /** Company Id */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** Facilities/Areas */
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Job Title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The user to assign roles to */
  lobEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  /** Middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** The roles to assign to the specified user */
  roleIds: Array<Scalars['ID']['input']>;
  /** The disciplines to assign to the specified user */
  workPackageDisciplineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AddUserPayload = {
  /** Error in add */
  error?: Maybe<AddUserError>;
  /** User details */
  user?: Maybe<User>;
};

export enum AddWeldAttachmentError {
  ADD_WELD_ATTACHMENT_ERRORED = 'ADD_WELD_ATTACHMENT_ERRORED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

export type AddWeldAttachmentInput = {
  attachmentMetadata: Array<AttachmentMetadataInput>;
  weldId: Scalars['ID']['input'];
};

export type AddWeldAttachmentPayload = {
  error?: Maybe<AddWeldAttachmentError>;
  weld?: Maybe<Weld>;
};

export enum AddWorkPackageAttachmentError {
  ADD_WORK_PACKAGE_ATTACHMENT_ERRORED = 'ADD_WORK_PACKAGE_ATTACHMENT_ERRORED',
  INVALID_WORK_PACKAGE_ID = 'INVALID_WORK_PACKAGE_ID',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  WORK_PACKAGE_NOT_FOUND = 'WORK_PACKAGE_NOT_FOUND'
}

export type AddWorkPackageAttachmentInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  workPackageId: Scalars['ID']['input'];
};

export type AddWorkPackageAttachmentPayload = {
  error?: Maybe<AddWorkPackageAttachmentError>;
  workPackage?: Maybe<WorkPackage>;
};

export type AffectedCrewPayload = {
  hierarchy: CrewChangePayload;
  personaTypeId: PersonaType;
};

export type AiPlanningInput = {
  /** CrewMemberId of the selected foreman */
  foremanId: Scalars['ID']['input'];
  /** CrewMemberId of the selected general foreman */
  generalForemanId: Scalars['ID']['input'];
  /** CrewMemberId of the selected superintendent */
  superintendentId: Scalars['ID']['input'];
};

export type AiPlanningPayload = {
  error?: Maybe<PlanningErrorCode>;
  planningAiRequestId?: Maybe<Scalars['ID']['output']>;
};

export type AppDataFormat = {
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Data format */
  format: Scalars['String']['output'];
  /** App data format type id */
  formatTypeId: AppDataFormatEnum;
  id: Scalars['ID']['output'];
};

export enum AppDataFormatEnum {
  /** Date format */
  DATE_FORMAT = 'DATE_FORMAT',
  /** Time format */
  TIME_FORMAT = 'TIME_FORMAT'
}

export enum AppEntityType {
  COMMODITY = 'COMMODITY',
  EMPLOYEE = 'EMPLOYEE',
  MILESTONE = 'MILESTONE',
  WORKPACKAGE = 'WORKPACKAGE'
}

export enum AppFeature {
  APPROVE_FIT_UP_INSPECTION = 'APPROVE_FIT_UP_INSPECTION',
  BOOK_BUILDER = 'BOOK_BUILDER',
  EXPIRING_ROD_REQUEST = 'EXPIRING_ROD_REQUEST',
  MAP_VIEW = 'MAP_VIEW',
  PLANNING_WEEK = 'PLANNING_WEEK',
  PRIORITY_WELD = 'PRIORITY_WELD',
  SHIFT_LOG = 'SHIFT_LOG'
}

export type AppModule = {
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  moduleTypeId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<AppPermission>;
};

export type AppPermission = {
  applicableScopes: Array<AppPermissionScope>;
  id: Scalars['ID']['output'];
  module: AppModule;
  name: Scalars['String']['output'];
  permissionId: Scalars['String']['output'];
};

export type AppPermissionScope = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AppTimeZone = {
  abbreviation: Scalars['String']['output'];
  displayText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDst: Scalars['Boolean']['output'];
  offset: Scalars['Float']['output'];
  timeZone: Scalars['String']['output'];
};

export type ApproveAllCrewChangeRequestsError = {
  crewChangeRequest: CrewChangeRequest;
  error: ApproveCrewChangeError;
};

export type ApproveAllCrewChangeRequestsPayload = {
  crewChangeRequests?: Maybe<Array<CrewChangeRequest>>;
  erroredCrewChangeRequests?: Maybe<Array<ApproveAllCrewChangeRequestsError>>;
};

export type ApproveAllMilestonesError = {
  errorCode?: Maybe<ApproveMilestoneError>;
  milestone?: Maybe<CommodityMilestone>;
};

/** Input object to use in approveAllMilestones Mutation. */
export type ApproveAllMilestonesInput = {
  commodityTypeId: Scalars['ID']['input'];
  itrRequired?: InputMaybe<Scalars['Boolean']['input']>;
  milestoneTypeId?: InputMaybe<Scalars['ID']['input']>;
  workPackageId: Scalars['ID']['input'];
};

export type ApproveAllMilestonesPayload = {
  erroredMilestones?: Maybe<Array<ApproveAllMilestonesError>>;
  milestones?: Maybe<Array<CommodityMilestone>>;
};

export enum ApproveCrewChangeError {
  APPROVE_CREW_CHANGE_ERRORED = 'APPROVE_CREW_CHANGE_ERRORED',
  INTEGRATION_CREW_CHANGE_ERROR = 'INTEGRATION_CREW_CHANGE_ERROR',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  REQUEST_IS_ALREADY_APPROVED = 'REQUEST_IS_ALREADY_APPROVED',
  REQUEST_IS_ALREADY_CANCELLED = 'REQUEST_IS_ALREADY_CANCELLED',
  REQUEST_IS_ALREADY_DECLINED = 'REQUEST_IS_ALREADY_DECLINED',
  REQUEST_NOT_FOUND = 'REQUEST_NOT_FOUND'
}

export type ApproveCrewChangeRequestPayload = {
  crewChangeRequest?: Maybe<CrewChangeRequest>;
  error?: Maybe<ApproveCrewChangeError>;
};

/** Available error for Approve Fitup */
export enum ApproveFitupError {
  APPROVE_FITUP_MILESTONE_ERRORED = 'APPROVE_FITUP_MILESTONE_ERRORED',
  EIS_ERROR = 'EIS_ERROR',
  INVALID_WELD = 'INVALID_WELD',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MILESTONE_NOT_CLAIMED = 'MILESTONE_NOT_CLAIMED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export enum ApproveFitupInspectionError {
  INVALID_WELD = 'INVALID_WELD',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

export type ApproveFitupPayload = {
  error?: Maybe<ApproveFitupError>;
  weld?: Maybe<Weld>;
};

/** Available error for approveMilestone */
export enum ApproveMilestoneError {
  APPROVE_MILESTONE_ERRORED = 'APPROVE_MILESTONE_ERRORED',
  EIS_ERROR = 'EIS_ERROR',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MILESTONE_NOT_CLAIMED = 'MILESTONE_NOT_CLAIMED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

/** Payload returned on call to approveMilestone. */
export type ApproveMilestonePayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<ApproveMilestoneError>;
  milestone?: Maybe<CommodityMilestone>;
  workPackage?: Maybe<WorkPackage>;
};

export enum ApproveWeldError {
  APPROVE_WELD_MILESTONE_ERRORED = 'APPROVE_WELD_MILESTONE_ERRORED',
  EIS_ERROR = 'EIS_ERROR',
  INVALID_WELD = 'INVALID_WELD',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MILESTONE_NOT_CLAIMED = 'MILESTONE_NOT_CLAIMED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NO_WELDER_FOUND = 'NO_WELDER_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type ApproveWeldFitupInspectionInput = {
  weldId: Scalars['ID']['input'];
};

export type ApproveWeldFitupInspectionPayload = {
  error?: Maybe<ApproveFitupInspectionError>;
  weld?: Maybe<Weld>;
};

export type ApproveWeldPayload = {
  error?: Maybe<ApproveWeldError>;
  weld?: Maybe<Weld>;
};

export type AssignCommoditiesInput = {
  input: Array<AssignCommodityInput>;
};

export enum AssignCommodityCrewMembersError {
  ASSIGN_COMMODITY_ERRORRED = 'ASSIGN_COMMODITY_ERRORRED',
  INVALID_COMMODITY_ID = 'INVALID_COMMODITY_ID',
  INVALID_CREW_MEMBER_ID = 'INVALID_CREW_MEMBER_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type AssignCommodityCrewMembersPayload = {
  commodities: Array<CommodityWrapper>;
  erroredCommodityAssignments?: Maybe<Array<CommodityAssignmentError>>;
};

export type AssignCommodityInput = {
  commodityId: Scalars['ID']['input'];
  crewMemberId?: InputMaybe<Scalars['ID']['input']>;
  personaType: PersonaType;
};

export enum AssignCrewMembersError {
  ASSIGN_CREW_MEMBER_ERRORED = 'ASSIGN_CREW_MEMBER_ERRORED',
  INVALID_ASSIGNEE_ID = 'INVALID_ASSIGNEE_ID',
  INVALID_WORK_PACKAGE_ID = 'INVALID_WORK_PACKAGE_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type AssignCrewMembersInput = {
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  assignedCrewMembers: Array<CrewMemberAssignmentInput>;
  deletePlan?: InputMaybe<Scalars['Boolean']['input']>;
  workPackageFilterInput?: InputMaybe<WorkPackageFilterInput>;
  workPackageIds: Array<Scalars['ID']['input']>;
};

export type AssignCrewMembersPayload = {
  erroredCrewMemberAssignments?: Maybe<Array<CrewMemberAssignmentError>>;
  erroredWorkPackages?: Maybe<Array<CrewMemberAssignmentWorkPackageError>>;
  unplannedMilestones?: Maybe<PlanningPayload>;
  workPackage?: Maybe<Array<Maybe<WorkPackage>>>;
};

export enum AssignTempCrewMemberError {
  INVALID_ASSIGNEE_ID = 'INVALID_ASSIGNEE_ID',
  INVALID_WORK_PACKAGE_ID = 'INVALID_WORK_PACKAGE_ID',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type AssignTempCrewMemberInput = {
  crewMemberId: Scalars['ID']['input'];
  workPackageId: Scalars['ID']['input'];
};

export type AssignTempCrewMemberPayload = {
  error?: Maybe<AssignTempCrewMemberError>;
  workPackage?: Maybe<WorkPackage>;
};

export enum AssignUnassignAssociatedCrewMembersError {
  ASSIGN_UNASSIGN_ASSOCIATED_CREW_MEMBERS_ERRORED = 'ASSIGN_UNASSIGN_ASSOCIATED_CREW_MEMBERS_ERRORED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

export type AssignUnassignAssociatedCrewMembersInput = {
  associatedCrewMembersIds: Array<Scalars['String']['input']>;
  crewMemberId: Scalars['String']['input'];
};

export type AssignUnassignAssociatedCrewMembersPayload = {
  associatedCrewMembers?: Maybe<AssociatedCrewMembers>;
  error?: Maybe<AssignUnassignAssociatedCrewMembersError>;
};

export enum AssignUnassignPriorityError {
  ASSIGN_UNASSIGN_PRIORITY_ERRORED = 'ASSIGN_UNASSIGN_PRIORITY_ERRORED',
  INVALID_COMMODITY_ID = 'INVALID_COMMODITY_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

export type AssignUnassignPriorityInput = {
  /** Commodity ID */
  commodityId: Scalars['ID']['input'];
  /** Assign / Unassign Priority for the weld */
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignUnassignPriorityPayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<AssignUnassignPriorityError>;
};

/** Error assigning user facilities */
export enum AssignUserFacilitiesError {
  NOT_FOUND = 'NOT_FOUND'
}

export type AssignUserFacilitiesInput = {
  /** The facilities to assign to the specified user */
  facilityIds: Array<Scalars['ID']['input']>;
  /** The user to assign facilities to */
  userId: Scalars['ID']['input'];
};

export type AssignUserFacilitiesPayload = {
  /** Assign user facilities error */
  error?: Maybe<AssignUserFacilitiesError>;
  /** List of facilities assigned to the user */
  userFacilities?: Maybe<Array<Maybe<Facility>>>;
};

export type AssignUserRolesInput = {
  /** The roles to assign to the specified user */
  roleIds: Array<Scalars['ID']['input']>;
  /** The user to assign roles to */
  userId: Scalars['ID']['input'];
};

export type AssignUserRolesPayload = {
  /** If any role ids were invalid they will be listed here */
  invalidRoleIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of roles assigned to the user */
  userRoles?: Maybe<Array<Maybe<AuthRole>>>;
};

export type AssignWeldCrewInput = {
  assignedCrewMembers: Array<CrewMemberAssignmentInput>;
  weldId: Scalars['ID']['input'];
};

export type AssignWeldCrewPayload = {
  erroredCrewMemberAssignments?: Maybe<Array<CrewMemberAssignmentError>>;
  weld?: Maybe<Array<Maybe<Weld>>>;
};

export enum AssignWeldForemanError {
  ASSIGN_WELD_FOREMAN_ERRORED = 'ASSIGN_WELD_FOREMAN_ERRORED',
  INVALID_COMMODITY_ID = 'INVALID_COMMODITY_ID',
  INVALID_FOREMAN_ID = 'INVALID_FOREMAN_ID',
  INVALID_WORKPACKAGE_ID = 'INVALID_WORKPACKAGE_ID',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type AssignWeldForemanInput = {
  weldForemanInput: Array<WeldForemanInput>;
  workPackageId: Scalars['ID']['input'];
};

export type AssignWeldForemanPayload = {
  commodity: Array<CommodityWrapper>;
  error?: Maybe<AssignWeldForemanError>;
};

export type AssociatedCrewMembers = {
  associatedCrewMembers: Array<CrewMember>;
  crewMember: CrewMember;
};

export type AssociatedCrewMembersInput = {
  crewMemberId: Scalars['String']['input'];
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
};

export type Attachment = {
  attachmentType: AttachmentType;
  createdAt: Scalars['Datetime']['output'];
  creator: CrewMember;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AttachmentMetadataInput = {
  attachmentId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
};

export enum AttachmentType {
  AUDIO = 'AUDIO',
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export enum AttendanceGraph {
  DOWN = 'DOWN',
  SAME = 'SAME',
  UP = 'UP'
}

/** List of specific permissions which are available in the application. */
export enum AuthPermission {
  ADD_ATTACHMENT_MILESTONE = 'ADD_ATTACHMENT_MILESTONE',
  ADD_ATTACHMENT_WELD = 'ADD_ATTACHMENT_WELD',
  ADD_EDIT_CREW_CHANGE = 'ADD_EDIT_CREW_CHANGE',
  APPROVE_DECLINE_CREW_CHANGE = 'APPROVE_DECLINE_CREW_CHANGE',
  APPROVE_UNAPPROVE_FITUP = 'APPROVE_UNAPPROVE_FITUP',
  APPROVE_UNAPPROVE_MILESTONE = 'APPROVE_UNAPPROVE_MILESTONE',
  APPROVE_UNAPPROVE_WELD = 'APPROVE_UNAPPROVE_WELD',
  ASSIGN_FIELD_WELD_ENGINEER = 'ASSIGN_FIELD_WELD_ENGINEER',
  ASSIGN_REASSIGN_STENCIL = 'ASSIGN_REASSIGN_STENCIL',
  ASSIGN_UNASSIGN_PRIORITY_WELD = 'ASSIGN_UNASSIGN_PRIORITY_WELD',
  ASSIGN_UNASSIGN_WELD_FOREMAN_COMMODITY = 'ASSIGN_UNASSIGN_WELD_FOREMAN_COMMODITY',
  ASSIGN_WELD_FOREMAN = 'ASSIGN_WELD_FOREMAN',
  CANCEL_CREW_CHANGE = 'CANCEL_CREW_CHANGE',
  CLAIM_UNCLAIM_MILESTONE = 'CLAIM_UNCLAIM_MILESTONE',
  CLAIM_UNCLAIM_WELD = 'CLAIM_UNCLAIM_WELD',
  CLOSE_ROD_REQUEST = 'CLOSE_ROD_REQUEST',
  COMMODITY_DOCUMENT_UPLOAD = 'COMMODITY_DOCUMENT_UPLOAD',
  CREATE_BLOCK = 'CREATE_BLOCK',
  CREATE_ROD_REQUEST = 'CREATE_ROD_REQUEST',
  CREATE_ROD_REQUEST_CADDY = 'CREATE_ROD_REQUEST_CADDY',
  CREATE_ROD_ROOM = 'CREATE_ROD_ROOM',
  DELETE_ATTACHMENT_MILESTONE = 'DELETE_ATTACHMENT_MILESTONE',
  DELETE_ATTACHMENT_WELD = 'DELETE_ATTACHMENT_WELD',
  DELETE_CADDY = 'DELETE_CADDY',
  DELETE_COMMODITY_DOCUMENT = 'DELETE_COMMODITY_DOCUMENT',
  DELETE_ROD_REQUEST = 'DELETE_ROD_REQUEST',
  DELETE_WORK_PACKAGE_DOCUMENT = 'DELETE_WORK_PACKAGE_DOCUMENT',
  DOWNLOAD_WEEKLY_WORK_LIST = 'DOWNLOAD_WEEKLY_WORK_LIST',
  EDIT_BLOCK = 'EDIT_BLOCK',
  EDIT_CREW_TIME_WORK_PACKAGE = 'EDIT_CREW_TIME_WORK_PACKAGE',
  EDIT_FIELD_ENGINEER_WORK_PACKAGE = 'EDIT_FIELD_ENGINEER_WORK_PACKAGE',
  EDIT_FOREMAN_WORK_PACKAGE = 'EDIT_FOREMAN_WORK_PACKAGE',
  EDIT_GENERAL_FOREMAN_WORK_PACKAGE = 'EDIT_GENERAL_FOREMAN_WORK_PACKAGE',
  EDIT_SCHEDULE_WORK_PACKAGE = 'EDIT_SCHEDULE_WORK_PACKAGE',
  EDIT_SUPERINTENDENT_WORK_PACKAGE = 'EDIT_SUPERINTENDENT_WORK_PACKAGE',
  ISSUE_CADDIES = 'ISSUE_CADDIES',
  MANAGE_AI_PLANNING = 'MANAGE_AI_PLANNING',
  MANAGE_PLANNING = 'MANAGE_PLANNING',
  MANAGE_PROJECT = 'MANAGE_PROJECT',
  PROGRESS_ROD_REQUEST_WELDS = 'PROGRESS_ROD_REQUEST_WELDS',
  PROJECT_CONFIGURATION = 'PROJECT_CONFIGURATION',
  REASSIGN_WELD_FOREMAN = 'REASSIGN_WELD_FOREMAN',
  REJECT_FITUP = 'REJECT_FITUP',
  REJECT_MILESTONE = 'REJECT_MILESTONE',
  REJECT_WELD = 'REJECT_WELD',
  REQUEST_FITUP = 'REQUEST_FITUP',
  RESOLVE_BLOCK = 'RESOLVE_BLOCK',
  RETURN_CADDIES = 'RETURN_CADDIES',
  SAVE_FEATURE_CONFIG = 'SAVE_FEATURE_CONFIG',
  SWITCH_PROJECT = 'SWITCH_PROJECT',
  UPDATE_CADDY = 'UPDATE_CADDY',
  UPDATE_ROD_REQUEST = 'UPDATE_ROD_REQUEST',
  UPDATE_ROD_ROOM = 'UPDATE_ROD_ROOM',
  VIEW_ADMIN_FEATURES = 'VIEW_ADMIN_FEATURES',
  VIEW_ADMIN_GENERAL = 'VIEW_ADMIN_GENERAL',
  VIEW_ADMIN_IMPORTS = 'VIEW_ADMIN_IMPORTS',
  VIEW_ADMIN_MODULES = 'VIEW_ADMIN_MODULES',
  VIEW_ADMIN_QUANTITY_REPORTING = 'VIEW_ADMIN_QUANTITY_REPORTING',
  VIEW_ADMIN_REPORTS = 'VIEW_ADMIN_REPORTS',
  VIEW_ADMIN_SYNC = 'VIEW_ADMIN_SYNC',
  VIEW_ADMIN_USERS = 'VIEW_ADMIN_USERS',
  VIEW_ADMIN_WORK_PACKAGES = 'VIEW_ADMIN_WORK_PACKAGES',
  VIEW_AI_ASSISTANT = 'VIEW_AI_ASSISTANT',
  VIEW_ALL_CREWS_PROGRESS = 'VIEW_ALL_CREWS_PROGRESS',
  VIEW_ALL_CREWS_STATS = 'VIEW_ALL_CREWS_STATS',
  VIEW_BLOCKS = 'VIEW_BLOCKS',
  VIEW_CREW_CHANGE = 'VIEW_CREW_CHANGE',
  VIEW_CREW_CHANGE_MODULE = 'VIEW_CREW_CHANGE_MODULE',
  VIEW_DASHBOARD_STATS_AND_CALCULATIONS = 'VIEW_DASHBOARD_STATS_AND_CALCULATIONS',
  VIEW_DEFAULT_DASHBOARD = 'VIEW_DEFAULT_DASHBOARD',
  VIEW_OTHER_USER_DASHBOARD = 'VIEW_OTHER_USER_DASHBOARD',
  VIEW_PLANNING = 'VIEW_PLANNING',
  VIEW_REPORT = 'VIEW_REPORT',
  VIEW_ROD_ROOM = 'VIEW_ROD_ROOM',
  VIEW_TIMESHEETS = 'VIEW_TIMESHEETS',
  WORK_PACKAGE_DOCUMENT_UPLOAD = 'WORK_PACKAGE_DOCUMENT_UPLOAD'
}

export type AuthPermissionScope = {
  id: Scalars['ID']['output'];
  /** Permission */
  permission: AppPermission;
  /** Scope associated to a permission */
  scope: AppPermissionScope;
};

/**
 * An AuthRole is a collection of permissions grouped and assigned by a given name.
 * These are configured per project.
 */
export type AuthRole = {
  /** Short name of the Role. For eg. Foreman has FM, General Foreman has GF */
  abbreviation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Name of the role */
  name: Scalars['String']['output'];
  /** Number of users associated this role */
  numUsers?: Maybe<Scalars['Int']['output']>;
  /**
   * List of all permissions(with scope) assigned to this user.
   * @deprecated This field is deprecated, use authPermissionScopes instead!
   */
  permissionScopes: Array<PermissionScope>;
  /** Auth Permission scopes */
  permissions: Array<AuthPermissionScope>;
  /** Project this role is created in  */
  project?: Maybe<Project>;
  /** Source role associated to this role */
  sourceRole?: Maybe<AuthRole>;
};

/** List of all the scopes available for auth permissions */
export enum AuthScope {
  ALL_AREA = 'ALL_AREA',
  ALL_COMMODITIES = 'ALL_COMMODITIES',
  ALL_CREW = 'ALL_CREW',
  ALL_WORK_PACKAGES = 'ALL_WORK_PACKAGES',
  ANY_CREW_ANY_HIERARCHY = 'ANY_CREW_ANY_HIERARCHY',
  ANY_REQUEST = 'ANY_REQUEST',
  APPLICATION = 'APPLICATION',
  EDIT = 'EDIT',
  FIELD_ENGINEER = 'FIELD_ENGINEER',
  FIELD_WELD_ENGINEER = 'FIELD_WELD_ENGINEER',
  FOREMAN = 'FOREMAN',
  MY_AREA = 'MY_AREA',
  MY_COMMODITIES = 'MY_COMMODITIES',
  MY_CREW = 'MY_CREW',
  MY_CREW_ANY_HIERARCHY = 'MY_CREW_ANY_HIERARCHY',
  MY_CREW_MY_HIERARCHY = 'MY_CREW_MY_HIERARCHY',
  MY_REQUEST = 'MY_REQUEST',
  MY_WORK_PACKAGES = 'MY_WORK_PACKAGES',
  NONE = 'NONE',
  SUPERINTENDENT = 'SUPERINTENDENT',
  SUPER_ADMIN = 'SUPER_ADMIN',
  YES = 'YES'
}

export type BacklogMilestones = {
  commodityMilestoneIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Impacted milestones */
  milestones: Array<CommodityMilestone>;
};


export type BacklogMilestonesMilestonesArgs = {
  input?: InputMaybe<PlanningBacklogMilestonesInput>;
};

export type Block = {
  attachment: Array<Attachment>;
  /** List of comments made about this block. */
  comments: Array<BlockComment>;
  commodityMilestoneIds: Array<Scalars['String']['output']>;
  /** Who created this block. */
  creator: CrewMember;
  /** The latest status to have been set for this block. */
  currentStatusI18n: BlockStatusCode;
  id: Scalars['ID']['output'];
  /** List of Commodities impacted by this block */
  impactedCommodities: Array<CommodityWrapper>;
  /** List of Milestones impacted by this block */
  impactedMilestones: Array<CommodityMilestone>;
  /** The history of status changes over time for this block. */
  statusHistory: Array<BlockStatus>;
  /** The Block Type is a configured list of block types. */
  type: BlockType;
  /** List of persisted attachment for this block. */
  workPackage: WorkPackage;
};

/** Discussion made by users against a block. Not implemented yet */
export type BlockComment = {
  comment: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: CrewMember;
  id: Scalars['ID']['output'];
};

export type BlockCreatedPayload = {
  affectedOwnerIds?: Maybe<Array<Scalars['ID']['output']>>;
  blockId: Scalars['ID']['output'];
  commodityIds: Array<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  workPackageId: Scalars['ID']['output'];
};

/** Not implemented yet */
export type BlockFilterInput = {
  assignedToMe: Scalars['Boolean']['input'];
  /** Filter by block statuses */
  filterByBlockStatuses?: InputMaybe<Array<BlockStatusCode>>;
  /** Array of block type ids */
  filterByBlockTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Array of Project commodity type ids */
  filterByCommodityTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by Facility Ids */
  filterByFacilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Array of milestone type ids */
  filterByMilestoneTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Sort Order by */
  orderBy?: InputMaybe<SortOrderByEnum>;
  /** Search by term */
  searchBy?: InputMaybe<BlockSearchByTerm>;
  /** Search text */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  /** Sort by term */
  sortBy: BlockSortByTerm;
  /** Search Work Package specific blocks */
  workPackageId?: InputMaybe<Scalars['String']['input']>;
};

export type BlockList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<Block>;
  total: Scalars['Int']['output'];
};

export enum BlockSearchByTerm {
  COMMODITY = 'COMMODITY',
  USER_NAME = 'USER_NAME',
  WP_NUMBER = 'WP_NUMBER'
}

export enum BlockSortByTerm {
  MILESTONE_HOURS = 'MILESTONE_HOURS',
  MOST_RECENT_UPDATE = 'MOST_RECENT_UPDATE'
}

export type BlockStats = {
  blockStats: Array<BlockTypeStats>;
  openBlocks: Scalars['Int']['output'];
  totalBlockedHours: Scalars['Int']['output'];
};

/** Defines who set this status and what they set it to. Not implemented yet. */
export type BlockStatus = {
  codeI18n: BlockStatusCode;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<CrewMember>;
  id: Scalars['ID']['output'];
};

/** Defines available statuses in Blocks workflow */
export enum BlockStatusCode {
  /** The initial status of a block. It still needs work done. */
  BLOCK_OPENED = 'BLOCK_OPENED',
  /** This block has been resolved and can be considered closed or complete. */
  BLOCK_RESOLVED = 'BLOCK_RESOLVED'
}

/** The block type defines the different high level types of blocks, ie Access/Information/Interference/Material/Tools */
export type BlockType = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  /** The key which can be used to lookup this block type from localization */
  title: Scalars['String']['output'];
};

export type BlockTypeStats = {
  blockType: BlockType;
  total: Scalars['Int']['output'];
};

export type BlockUpdatedPayload = {
  affectedOwnerIds?: Maybe<Array<Scalars['ID']['output']>>;
  blockId: Scalars['ID']['output'];
  commodityIds: Array<Maybe<Scalars['ID']['output']>>;
  projectId: Scalars['ID']['output'];
  workPackageId: Scalars['ID']['output'];
};

export type BulkRodRequestProgressInput = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  progressRodRequestWeldsInput: Array<ProgressRodRequestWeldsInput>;
  welderId: Scalars['ID']['input'];
};

export type BulkRodRequestProgressWeldsPayload = {
  rodRequestProgressPayload: ProgressRodRequestWeldsPayload;
};

export type Caddy = {
  /** Internal ID for Caddy */
  id: Scalars['ID']['output'];
  /** Label of Caddy */
  label: Scalars['String']['output'];
  /** Status of Caddy */
  status: CaddyStatusCode;
};

export type CaddyFillerMaterialDiameter = {
  /** Diameter */
  diameter: RodDiameter;
  /** Rod Heat or Lot Number */
  heatLotNumber: RodHeatOrLotNumber;
};

export type CaddyFilterInput = {
  /** Rod room id */
  rodRoomId: Scalars['String']['input'];
  /** Search Keyword */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  /** Caddy status */
  status?: InputMaybe<CaddyStatusCode>;
};

export type CaddyList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<Maybe<Caddy>>;
  total: Scalars['Int']['output'];
};

export type CaddyStatByStatus = {
  /** count by status */
  numStatus: Scalars['Int']['output'];
  /** Caddy status */
  status: CaddyStatusCode;
};

export enum CaddyStatusCode {
  /** Caddy is issued */
  ISSUED = 'ISSUED',
  /** Caddy is available */
  ONHAND = 'ONHAND'
}

export enum CaddyStatusFlag {
  IN_HOUSE = 'IN_HOUSE',
  ISSUED = 'ISSUED',
  ONHAND = 'ONHAND',
  RETURNED = 'RETURNED'
}

export type CaddyStatusStats = {
  /** Count */
  stats: Scalars['Int']['output'];
  /** Caddy Status */
  status: CaddyStatusFlag;
};

export type CaddyStatusStatsSummary = {
  /** Caddy Stats */
  caddySummary: Array<CaddyStatusStats>;
  /** Total caddies */
  numCaddies: Scalars['Int']['output'];
};

export type CaddySubscriptionPayload = {
  caddyIds: Array<Scalars['ID']['output']>;
};

export enum CancelCrewChangeError {
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  REQUEST_IS_ALREADY_APPROVED = 'REQUEST_IS_ALREADY_APPROVED',
  REQUEST_IS_ALREADY_CANCELLED = 'REQUEST_IS_ALREADY_CANCELLED',
  REQUEST_IS_ALREADY_DECLINED = 'REQUEST_IS_ALREADY_DECLINED',
  REQUEST_NOT_FOUND = 'REQUEST_NOT_FOUND'
}

export type CancelCrewChangeRequestPayload = {
  crewChangeRequest?: Maybe<CrewChangeRequest>;
  error?: Maybe<CancelCrewChangeError>;
};

export enum CancelFitupMilestoneError {
  CANCEL_FITUP_REQUEST_ERRORED = 'CANCEL_FITUP_REQUEST_ERRORED',
  FITUP_IS_CANCELED = 'FITUP_IS_CANCELED',
  INVALID_MILESTONE_ACTION = 'INVALID_MILESTONE_ACTION',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_CLAIMED = 'MILESTONE_IS_CLAIMED',
  MILESTONE_IS_LOCKED = 'MILESTONE_IS_LOCKED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type CancelFitupRequestPayload = {
  error?: Maybe<CancelFitupMilestoneError>;
  weld?: Maybe<Weld>;
};

export enum CancelImportScheduleError {
  ALREADY_CANCELLED = 'ALREADY_CANCELLED',
  CANCEL_IMPORT_SCHEDULE_ERRORED = 'CANCEL_IMPORT_SCHEDULE_ERRORED',
  NOT_FOUND = 'NOT_FOUND'
}

export type CancelImportScheduleInput = {
  id: Scalars['ID']['input'];
};

export type CancelImportSchedulePayload = {
  error?: Maybe<CancelImportScheduleError>;
  importSchedule?: Maybe<ImportSchedule>;
};

export type ClaimAllMilestonesError = {
  errorCode?: Maybe<ClaimMilestoneError>;
  milestone?: Maybe<CommodityMilestone>;
  previousMilestoneUnclaimed?: Maybe<CommodityMilestone>;
};

/** Input object to use in claimAllMilestones Mutation. */
export type ClaimAllMilestonesInput = {
  commodityTypeId: Scalars['ID']['input'];
  itrRequired?: InputMaybe<Scalars['Boolean']['input']>;
  milestoneTypeId?: InputMaybe<Scalars['ID']['input']>;
  workPackageId: Scalars['ID']['input'];
};

export type ClaimAllMilestonesPayload = {
  erroredMilestones?: Maybe<Array<ClaimAllMilestonesError>>;
  milestones?: Maybe<Array<CommodityMilestone>>;
};

export enum ClaimApproveWeldError {
  CLAIM_APPROVE_WELD_MILESTONE_ERRORED = 'CLAIM_APPROVE_WELD_MILESTONE_ERRORED',
  EIS_ERROR = 'EIS_ERROR',
  INVALID_STENCILS = 'INVALID_STENCILS',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_ALREADY_CLAIMED = 'MILESTONE_IS_ALREADY_CLAIMED',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  STENCILS_NOT_PROVIDED = 'STENCILS_NOT_PROVIDED',
  WELD_PROCEDURE_NOT_FROM_APPLICABLE_LIST = 'WELD_PROCEDURE_NOT_FROM_APPLICABLE_LIST'
}

export type ClaimApproveWeldInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  commodityMilestoneId: Scalars['ID']['input'];
  /** The location in latitude and longitude where this was welded. This is not mandatory right now but will be when we do ArcStryker. */
  location?: InputMaybe<CommodityLocationInput>;
  /** An optional comment on where weld is located on the job site. */
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Ids of the welders that participated in the welding. */
  stencilIds: Array<Scalars['ID']['input']>;
  /** Which weld procedure was used for installation. Must match one of the applicable weld procedures of the weld. */
  weldProcedureIds: Array<Scalars['ID']['input']>;
};

export type ClaimApproveWeldPayload = {
  error?: Maybe<ClaimApproveWeldError>;
  weld?: Maybe<Weld>;
};

/** Available error for claimMilestone */
export enum ClaimMilestoneError {
  ASSOCIATED_WELDS_NOT_APPROVED = 'ASSOCIATED_WELDS_NOT_APPROVED',
  CLAIM_MILESTONE_ERRORED = 'CLAIM_MILESTONE_ERRORED',
  EIS_ERROR = 'EIS_ERROR',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_ALREADY_CLAIMED = 'MILESTONE_IS_ALREADY_CLAIMED',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  PREVIOUS_MILESTONE_NOT_CLAIMED_YET = 'PREVIOUS_MILESTONE_NOT_CLAIMED_YET',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type ClaimMilestoneInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  commodityMilestoneId: Scalars['ID']['input'];
  itrRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Payload returned on call to claimMilestone. */
export type ClaimMilestonePayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<ClaimMilestoneError>;
  milestone?: Maybe<CommodityMilestone>;
  previousMilestoneUnclaimed?: Maybe<CommodityMilestone>;
  workPackage?: Maybe<WorkPackage>;
};

export enum ClaimWeldError {
  CLAIM_WELD_MILESTONE_ERRORED = 'CLAIM_WELD_MILESTONE_ERRORED',
  EIS_ERROR = 'EIS_ERROR',
  INVALID_STENCILS = 'INVALID_STENCILS',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_ALREADY_CLAIMED = 'MILESTONE_IS_ALREADY_CLAIMED',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  PREVIOUS_MILESTONE_NOT_CLAIMED_YET = 'PREVIOUS_MILESTONE_NOT_CLAIMED_YET',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  STENCILS_NOT_PROVIDED = 'STENCILS_NOT_PROVIDED',
  WELD_PROCEDURE_NOT_FROM_APPLICABLE_LIST = 'WELD_PROCEDURE_NOT_FROM_APPLICABLE_LIST'
}

export type ClaimWeldInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  commodityMilestoneId: Scalars['ID']['input'];
  /** The location in latitude and longitude where this was welded. This is not mandatory right now but will be when we do ArcStryker. */
  location?: InputMaybe<CommodityLocationInput>;
  /** An optional comment on where weld is located on the job site. */
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Ids of the welders that participated in the welding. */
  stencilIds: Array<Scalars['ID']['input']>;
  /** Which weld procedure was used for installation. Must match one of the applicable weld procedures of the weld. */
  weldProcedureIds: Array<Scalars['ID']['input']>;
};

export type ClaimWeldPayload = {
  error?: Maybe<ClaimWeldError>;
  weld?: Maybe<Weld>;
};

export type CloseRodRequestByStencilIdError = {
  errorCode: CloseRodRequestByStencilIdErrorCode;
  rodRequest?: Maybe<RodRequest>;
};

/** Error code while closing a rod request */
export enum CloseRodRequestByStencilIdErrorCode {
  ALL_ISSUED_CADDIES_NOT_RETURNED = 'ALL_ISSUED_CADDIES_NOT_RETURNED',
  CLOSE_ROD_REQUEST_ERRORED = 'CLOSE_ROD_REQUEST_ERRORED',
  INVALID_ROD_REQUEST_ID = 'INVALID_ROD_REQUEST_ID',
  INVALID_STENCIL_ID = 'INVALID_STENCIL_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NO_ROD_REQUEST_FOUND = 'NO_ROD_REQUEST_FOUND',
  ROD_REQUEST_ALREADY_CLOSED = 'ROD_REQUEST_ALREADY_CLOSED',
  ROD_REQUEST_ALREADY_DELETED = 'ROD_REQUEST_ALREADY_DELETED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  WELD_PROGRESS_NOT_CAPTURED = 'WELD_PROGRESS_NOT_CAPTURED'
}

/** Input details required for closing bulk rod request */
export type CloseRodRequestByStencilIdInput = {
  /** Rod Request closed by */
  closedByUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Rod Request Id */
  rodRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Rod Request stencil id */
  stencilId: Scalars['ID']['input'];
};

/** Closed Bulk Rod Request response payload */
export type CloseRodRequestByStencilIdPayload = {
  erroredRodRequests?: Maybe<Array<CloseRodRequestByStencilIdError>>;
  rodRequests?: Maybe<Array<RodRequest>>;
};

/** Error code while closing a rod request */
export enum CloseRodRequestErrorCode {
  ALL_ISSUED_CADDIES_NOT_RETURNED = 'ALL_ISSUED_CADDIES_NOT_RETURNED',
  CLOSE_ROD_REQUEST_ERRORED = 'CLOSE_ROD_REQUEST_ERRORED',
  COMMENT_TOO_LARGE = 'COMMENT_TOO_LARGE',
  INVALID_ROD_REQUEST_ID = 'INVALID_ROD_REQUEST_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  ROD_REQUEST_ALREADY_CLOSED = 'ROD_REQUEST_ALREADY_CLOSED',
  ROD_REQUEST_ALREADY_DELETED = 'ROD_REQUEST_ALREADY_DELETED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

/** Input details required for closing a rod request */
export type CloseRodRequestInput = {
  /** Rod Request closed by */
  closedByUserId: Scalars['ID']['input'];
  /** Closing Comments */
  comments: Scalars['String']['input'];
  /** Rod Request Id */
  rodRequestId: Scalars['ID']['input'];
};

/** Closed Rod Request response payload */
export type CloseRodRequestPayload = {
  error?: Maybe<CloseRodRequestErrorCode>;
  rodRequest?: Maybe<RodRequest>;
};

export type CommoditiesUpdatedPayload = {
  affectedOwnerIds: Array<Scalars['ID']['output']>;
  commodityIds: Array<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  weldsCurrentStatus?: Maybe<Array<Maybe<WeldStatusInfo>>>;
};

export enum CommodityAssignActivityType {
  ASSIGNED = 'ASSIGNED',
  UNASSIGNED = 'UNASSIGNED'
}

export type CommodityAssignee = {
  assignee?: Maybe<CrewMember>;
  personaType?: Maybe<PersonaType>;
};

export type CommodityAssignmentError = {
  commodityId: Scalars['ID']['output'];
  crewMemberId?: Maybe<Scalars['ID']['output']>;
  error: AssignCommodityCrewMembersError;
  persona: PersonaType;
};

export type CommodityComplexFilterInput = {
  /** And filter, all filter terms in this will be applied with and operator */
  and?: InputMaybe<Array<FilterByCommodityTermInput>>;
  /** Or filter, all filter terms in this will be applied with or operator */
  or?: InputMaybe<Array<FilterByCommodityTermInput>>;
};

export enum CommodityConnectionType {
  HANGERS = 'HANGERS',
  PIPE = 'PIPE',
  STRUCTURAL = 'STRUCTURAL',
  SUPPORTS = 'SUPPORTS',
  TANKS = 'TANKS'
}

export enum CommodityFilterByTerm {
  /** Include this filter to filter commodities by associated crew member, ex: for Field Weld Engineer's supporting Foremen */
  APPLY_ASSOCIATED_CREW_MEMBERS = 'APPLY_ASSOCIATED_CREW_MEMBERS',
  /** Area Number */
  AREA_NUMBER = 'AREA_NUMBER',
  /** Assigned crew member, boolean filterValue, 'true' or 'false', use PERSONA_TYPE_ID with this filter */
  ASSIGNED_CREW_MEMBER = 'ASSIGNED_CREW_MEMBER',
  /** Commodity Id */
  COMMODITY_ID = 'COMMODITY_ID',
  /** Commodity Status Id */
  COMMODITY_STATUS_ID = 'COMMODITY_STATUS_ID',
  /** Commodity Type Id */
  COMMODITY_TYPE_ID = 'COMMODITY_TYPE_ID',
  /** Connected Commodity Id */
  CONNECTED_COMMODITY_ID = 'CONNECTED_COMMODITY_ID',
  /** Commodity Group Type Id */
  CONNECTION_TYPE = 'CONNECTION_TYPE',
  /** Crew Member Id */
  CREW_MEMBER_ID = 'CREW_MEMBER_ID',
  /** Assignee Crew Member Name */
  CREW_MEMBER_NAME = 'CREW_MEMBER_NAME',
  /** Drawing Id */
  DRAWING_NUMBER = 'DRAWING_NUMBER',
  /** End Date */
  END_DATE = 'END_DATE',
  /** Exclude Connected Commodities */
  EXCLUDE_CONNECTED_COMMODITY = 'EXCLUDE_CONNECTED_COMMODITY',
  /** Filtering all welds: Boolean filter with values true, false */
  FILTER_ALL_WELDS = 'FILTER_ALL_WELDS',
  INCLUDE_BLOCKED_COMMODITY = 'INCLUDE_BLOCKED_COMMODITY',
  /** Is Fitup Required */
  IS_FITUP_REQUIRED = 'IS_FITUP_REQUIRED',
  /** Translates to Nominal Diameter > 2.5,  boolean filterValue, 'true' or 'false' */
  LARGE_BORE = 'LARGE_BORE',
  /** Material Type */
  MATERIAL_TYPE = 'MATERIAL_TYPE',
  /** NDE Required, boolean filterValue, 'true' or 'false' */
  NDE_REQUIRED = 'NDE_REQUIRED',
  /** Nominal Diameter value as of now used as 2.5. Ex. For Small Bore use 2.5 with LESS_THAN */
  NOMINAL_DIAMETER = 'NOMINAL_DIAMETER',
  /** Persona Type Id */
  PERSONA_TYPE_ID = 'PERSONA_TYPE_ID',
  /** this accept user id  whose data we need to filter */
  PRIMARY_CREW_MEMBER_ID = 'PRIMARY_CREW_MEMBER_ID',
  /** Priority Welds, boolean filterValue, 'true' or 'false' */
  PRIORITY_WELDS = 'PRIORITY_WELDS',
  /** Project Milestone Type ID */
  PROJECT_MILESTONE_TYPE_ID = 'PROJECT_MILESTONE_TYPE_ID',
  /** Translates to Nominal Diameter < 2.5,  boolean filterValue, 'true' or 'false' */
  SMALL_BORE = 'SMALL_BORE',
  /** Start Up System Number */
  STARTUP_SYSTEM_NUMBER = 'STARTUP_SYSTEM_NUMBER',
  /** Start Date */
  START_DATE = 'START_DATE',
  /** Tag Number */
  TAG_NUMBER = 'TAG_NUMBER',
  /** Test Work Package Number */
  TEST_WORK_PACKAGE_NUMBER = 'TEST_WORK_PACKAGE_NUMBER',
  /** Un-assigned Commodities */
  UNASSIGNED_COMMODITIES = 'UNASSIGNED_COMMODITIES',
  /** Weld Procedure Id */
  WELD_PROCEDURE_ID = 'WELD_PROCEDURE_ID',
  /** Work Package Id */
  WORK_PACKAGE_ID = 'WORK_PACKAGE_ID',
  /** Work Package Number */
  WORK_PACKAGE_NUMBER = 'WORK_PACKAGE_NUMBER'
}

export type CommodityFilterInput = {
  /** Comple Filter */
  complexFilter?: InputMaybe<CommodityComplexFilterInput>;
  /** Sort by Filter */
  sortByFilter?: InputMaybe<CommoditySortByFilterInput>;
};

export enum CommodityFilterInputError {
  /** Below values are only meant for Welds dashboard stats query */
  CREW_MEMBER_ID_MISSING = 'CREW_MEMBER_ID_MISSING',
  END_DATE_MISSING = 'END_DATE_MISSING',
  FILTER_DEPENDENCY_MISSING = 'FILTER_DEPENDENCY_MISSING',
  FILTER_VALUES_MISSING = 'FILTER_VALUES_MISSING',
  FILTER_VALUE_MISSING = 'FILTER_VALUE_MISSING',
  INVALID_FILTER_BOOLEAN_VALUE = 'INVALID_FILTER_BOOLEAN_VALUE',
  INVALID_FILTER_DATE_VALUE = 'INVALID_FILTER_DATE_VALUE',
  INVALID_FILTER_NUMBER_VALUE = 'INVALID_FILTER_NUMBER_VALUE',
  INVALID_FILTER_OPERATOR = 'INVALID_FILTER_OPERATOR',
  INVALID_FILTER_VALUE = 'INVALID_FILTER_VALUE',
  PRIMARY_CREW_MEMBER_ID_MISSING = 'PRIMARY_CREW_MEMBER_ID_MISSING',
  START_DATE_MISSING = 'START_DATE_MISSING'
}

export enum CommodityFilterStatusFlag {
  APPROVED = 'APPROVED',
  BLOCKED = 'BLOCKED',
  CLAIMED = 'CLAIMED',
  FITUP_INSPECTION = 'FITUP_INSPECTION',
  FITUP_REQUESTED = 'FITUP_REQUESTED',
  READY_TO_WELD = 'READY_TO_WELD',
  REJECTED = 'REJECTED',
  SENT_BACK_TO_PIPING = 'SENT_BACK_TO_PIPING',
  VT_APPROVED = 'VT_APPROVED',
  VT_SENT_BACK = 'VT_SENT_BACK'
}

export type CommodityList = {
  cursor?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<CommodityFilterInputError>>>;
  items: Array<CommodityWrapper>;
  priorityCommodityCount?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CommodityListPriorityCommodityCountArgs = {
  input?: InputMaybe<CommodityFilterInput>;
};

export type CommodityLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/** Milestone to track workflow and progress of Commodity */
export type CommodityMilestone = {
  attachments: Array<Attachment>;
  /** Get all blocks from CommodityMilestone */
  blocks: Array<Block>;
  commodity: CommodityWrapper;
  currentStatus: MilestoneStatus;
  hours: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isExpired: Scalars['Boolean']['output'];
  lobMilestoneTypeId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  plannedEndDate?: Maybe<Scalars['Date']['output']>;
  plannedStartDate?: Maybe<Scalars['Date']['output']>;
  planningAiRequestId?: Maybe<Scalars['ID']['output']>;
  projectMilestoneTypeId?: Maybe<Scalars['ID']['output']>;
  quantity: Quantity;
  timesRejected: Scalars['Int']['output'];
  type: ProjectMilestoneType;
  weekNumber?: Maybe<Scalars['Int']['output']>;
  weldStatuses?: Maybe<Array<Weld>>;
  workPackageId: Scalars['String']['output'];
};

export type CommodityMilestoneActivity = {
  activity?: Maybe<MilestoneActivity>;
  /** AI Planning Request ID - indicates if milestone was AI-planned */
  aiPlanningRequestId?: Maybe<Scalars['ID']['output']>;
  /** Attachment provided on status change */
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  /** Block comments if milestoneStatus is blocked */
  blockComments?: Maybe<Array<BlockComment>>;
  /** Comments provided on reject or reclaim */
  comments?: Maybe<Scalars['String']['output']>;
  crewMember?: Maybe<CrewMember>;
  currentItrStatus?: Maybe<PipeCleanedStatus>;
  dateTime?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  isLobStatus?: Maybe<Scalars['Boolean']['output']>;
  milestoneName?: Maybe<Scalars['String']['output']>;
  milestoneStatus?: Maybe<MilestoneStatusCode>;
  /** order By milestone */
  orderBy?: Maybe<Scalars['Int']['output']>;
  /** Planning AI Comment - reason provided when replanning AI-planned milestone */
  planningAiComment?: Maybe<Scalars['String']['output']>;
  /** Rejection Reason */
  rejectionReason?: Maybe<MilestoneRejectionReason>;
  /** Rejection Sub Reasons */
  rejectionSubReasons?: Maybe<Array<MilestoneRejectionSubReason>>;
};

export type CommodityMilestoneActivityList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<CommodityMilestoneActivity>;
  total: Scalars['Int']['output'];
};

export type CommodityMilestoneList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<CommodityMilestone>;
  total: Scalars['Int']['output'];
};

export type CommodityMilestoneStatusStats = {
  /** Commodity milestone status count */
  stats: Scalars['Int']['output'];
  /** Milestone status */
  status: MilestoneStatusCode;
};

/** Input details required for Commodity progress */
export type CommodityProgressDetailInput = {
  /** Commodity Id */
  commodityId: Scalars['ID']['input'];
  /** Commodity Complete */
  isComplete: Scalars['Boolean']['input'];
};

/** Update Commodity progress response payload */
export type CommodityProgressPayload = {
  caddies?: Maybe<Array<RodRequestCaddy>>;
  error?: Maybe<UpdateStencilErrorCode>;
};

export type CommodityReference = {
  /** Commodity identifier from EIP */
  commodityId: Scalars['ID']['input'];
};

export enum CommoditySearchTerm {
  AREA_NUMBER = 'AREA_NUMBER',
  DRAWING_NUMBER = 'DRAWING_NUMBER',
  MATERIAL_TYPE = 'MATERIAL_TYPE',
  STARTUP_SYSTEM_NUMBER = 'STARTUP_SYSTEM_NUMBER',
  TAG = 'TAG',
  TEST_WP_NUMBER = 'TEST_WP_NUMBER',
  USER_NAME = 'USER_NAME',
  WPS = 'WPS',
  WP_NUMBER = 'WP_NUMBER'
}

export type CommoditySection = {
  /** App Type Id */
  appTypeId: Scalars['String']['output'];
  /** Array of Commodity Details Fields */
  fields: Array<CommoditySectionField>;
  /** Section title */
  title: Scalars['String']['output'];
};

export type CommoditySectionField = {
  /** Commodity Type */
  commodityType?: Maybe<CommodityType>;
  /** Lob Field Name */
  lobFieldName?: Maybe<Scalars['String']['output']>;
  /** Localized Field Name */
  name: Scalars['String']['output'];
  /** Use Localization Flag */
  useLocalization?: Maybe<Scalars['Boolean']['output']>;
  /** Field Value */
  value?: Maybe<Scalars['String']['output']>;
  /** Field Type */
  valueType: CommodityValueType;
};

export type CommoditySectionFieldInput = {
  appTypeId: Scalars['String']['input'];
  isDeleted: Scalars['Boolean']['input'];
  lobFieldName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderNo: Scalars['Int']['input'];
  useLocalization?: InputMaybe<Scalars['Boolean']['input']>;
  valueType: CommodityValueType;
};

export type CommoditySortByFilterInput = {
  /** Sort Order, ascending or descending, defaults to ascending */
  sortOrder?: InputMaybe<SortOrder>;
  /** Term to sort the results by. */
  term: CommoditySortByTerm;
};

export enum CommoditySortByTerm {
  ACTIVITY_DATE = 'ACTIVITY_DATE',
  TAG = 'TAG',
  TEST_WP_NUMBER = 'TEST_WP_NUMBER',
  WP_NUMBER = 'WP_NUMBER'
}

export type CommodityStats = {
  associatedCrewMemberIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Crew Attendance Percentage */
  attendancePct: Scalars['Int']['output'];
  /** CrewMember details for which the stats are applicable */
  crewMember: CrewMember;
  /** Id value contains crewMemberId for which the stats are applicable */
  id: Scalars['ID']['output'];
  /** The total number of welds assigned to me. */
  numAssignedToMe: Scalars['Int']['output'];
  /** The total number of crews. */
  numCrews: Scalars['Int']['output'];
  /** The total number of priority welds. */
  numPriorityWelds: Scalars['Int']['output'];
  /** The total number of un-assigned welds. */
  numUnassigned: Scalars['Int']['output'];
  /** The total number of welders. */
  numWelders: Scalars['Int']['output'];
  /** Stats by weld status */
  statusStats: Array<CommodityStatusStats>;
};

export type CommodityStatsPayload = {
  commodityStats?: Maybe<CommodityStats>;
  errors?: Maybe<Array<Maybe<CommodityFilterInputError>>>;
};

export type CommodityStatsSummary = {
  errors?: Maybe<Array<Maybe<CommodityFilterInputError>>>;
  numCommodities: Scalars['Int']['output'];
  statusStats: Array<CommodityMilestoneStatusStats>;
};

export type CommodityStatus = {
  id: Scalars['ID']['output'];
  nameI18n: Scalars['String']['output'];
  status: CommodityStatusCode;
  statusAt?: Maybe<Scalars['Datetime']['output']>;
  statusBy?: Maybe<CrewMember>;
};

export enum CommodityStatusCode {
  BLOCKED = 'BLOCKED',
  CLAIMED = 'CLAIMED',
  FITUP_INSPECTION = 'FITUP_INSPECTION',
  FITUP_REQUESTED = 'FITUP_REQUESTED',
  READY_TO_WELD = 'READY_TO_WELD',
  SENT_BACK_TO_PIPING = 'SENT_BACK_TO_PIPING',
  VT_APPROVED = 'VT_APPROVED',
  VT_SENT_BACK = 'VT_SENT_BACK'
}

export type CommodityStatusStats = {
  /** Commodity status count */
  stats: Scalars['Int']['output'];
  /** Commodity status */
  status: CommodityFilterStatusFlag;
};

export type CommodityType = {
  /** Project related commodity type */
  id: Scalars['ID']['output'];
  lobCommodityCode: Scalars['String']['output'];
  lobCommodityTypeId: Scalars['String']['output'];
  lobTemplateCode: Scalars['String']['output'];
  lobTemplateTypeId: Scalars['String']['output'];
  /** Commodity material tracking */
  materialTracking?: Maybe<MaterialTrackingCode>;
  /** Commodity type display name */
  name: Scalars['String']['output'];
  project: Project;
  projectMilestoneTypes: Array<ProjectMilestoneType>;
  sortOrder: Scalars['Int']['output'];
  unitOfMeasure: UnitOfMeasure;
};

export type CommodityUpdatedPayload = {
  commodityId: Scalars['ID']['output'];
};

export enum CommodityValueType {
  /** Value is expected to be a long text, for example, remarks */
  LONG_TEXT = 'LONG_TEXT',
  /** Value is a number */
  NUMBER = 'NUMBER',
  /** Value is a text */
  TEXT = 'TEXT'
}

/** Used as a commodity wrapper for temporary implementation until we can revisit with a union type */
export type CommodityWrapper = {
  /** Not null if this commodity is a commodity */
  materialCommodity?: Maybe<MaterialCommodity>;
  /** Not null if this commodity is a weld */
  weld?: Maybe<Weld>;
};

export type Company = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompanyInput = {
  searchKeyword: Scalars['String']['input'];
};

export enum ConfigureProjectEntitySeedType {
  CALCULATION_CONFIGS = 'CALCULATION_CONFIGS',
  COMMODITY_SECTIONS = 'COMMODITY_SECTIONS',
  COMMODITY_TYPES = 'COMMODITY_TYPES',
  CREW_MEMBER_DISCIPLINE_CONFIGS = 'CREW_MEMBER_DISCIPLINE_CONFIGS',
  EIS_ARTIFACTS = 'EIS_ARTIFACTS',
  FEATURE_VALUES = 'FEATURE_VALUES',
  ITR_CONFIG = 'ITR_CONFIG',
  MILESTONE_TYPES = 'MILESTONE_TYPES',
  PERMISSION_CONFIGS = 'PERMISSION_CONFIGS',
  PLANNING_WEEKS = 'PLANNING_WEEKS',
  REPORTS = 'REPORTS',
  ROD_ROOM_MODULE = 'ROD_ROOM_MODULE'
}

export enum ConfigureProjectErrorCode {
  CONFIGURE_PROJECT_ERRORED = 'CONFIGURE_PROJECT_ERRORED',
  EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT = 'EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT',
  INVALID_COUNTRY = 'INVALID_COUNTRY',
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  INVALID_LANGUAGE = 'INVALID_LANGUAGE',
  INVALID_STATE = 'INVALID_STATE',
  INVALID_SUPPORT_USER = 'INVALID_SUPPORT_USER',
  INVALID_TIME_FORMAT = 'INVALID_TIME_FORMAT',
  INVALID_TIME_ZONE = 'INVALID_TIME_ZONE',
  PROJECT_NOT_FOUND = 'PROJECT_NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type ConfigureProjectInput = {
  entitySeedTypes: Array<ConfigureProjectEntitySeedType>;
  /** Project Id */
  id: Scalars['ID']['input'];
};

export type ConfigureProjectPayload = {
  error?: Maybe<ConfigureProjectErrorCode>;
  project?: Maybe<Project>;
};

export enum CopyDataflowEntityMappingError {
  COPY_DATAFLOW_ENTITY_MAPPING_ERRORED = 'COPY_DATAFLOW_ENTITY_MAPPING_ERRORED',
  INVALID_DATAFLOW_ENTITY_TYPE_ID = 'INVALID_DATAFLOW_ENTITY_TYPE_ID',
  PROJECT_DATAFLOW_APP_REGISTRY_NOT_FOUND = 'PROJECT_DATAFLOW_APP_REGISTRY_NOT_FOUND',
  PROJECT_DATAFLOW_ENTITY_TYPE_NOT_FOUND = 'PROJECT_DATAFLOW_ENTITY_TYPE_NOT_FOUND'
}

export type CopyDataflowEntityMappingInput = {
  /** destination projectId */
  projectId: Scalars['String']['input'];
  projectsDataflowEntityRegistryIds: Array<Scalars['ID']['input']>;
};

export type CopyDataflowEntityMappingPayload = {
  error?: Maybe<CopyDataflowEntityMappingError>;
  rowsUpdated: Scalars['Int']['output'];
};

export type CostCode = {
  /** Cost code string */
  costCode: Scalars['String']['output'];
  /** Cost Code description */
  description?: Maybe<Scalars['String']['output']>;
  /** Cost Code entity */
  entity?: Maybe<Scalars['String']['output']>;
  error?: Maybe<CostCodeError>;
  /** Unique Cost code id from eTrack */
  id: Scalars['ID']['output'];
  /** Cost code that is present in Teamworks but not present in eTrack */
  invalid: Scalars['Boolean']['output'];
  /** Job number */
  jobNumber?: Maybe<Scalars['String']['output']>;
  /** Indicates if the cost code is restricted and cannot be charged by all crews */
  restricted: Scalars['Boolean']['output'];
  /** Sub job number */
  subJobNumber?: Maybe<Scalars['String']['output']>;
  /** A cost code can be unavialable to charge yet still could have been used in the past when it was valid */
  unavailable: Scalars['Boolean']['output'];
  /** The list of workpackages linked to this cost code */
  workPackages?: Maybe<Array<WorkPackage>>;
};

export enum CostCodeError {
  COST_CODE_ERRORED = 'COST_CODE_ERRORED'
}

export type CostCodeList = {
  cursor?: Maybe<Scalars['String']['output']>;
  error?: Maybe<CostCodeListError>;
  items?: Maybe<Array<CostCode>>;
  total: Scalars['Int']['output'];
};

export enum CostCodeListError {
  COMMODITY_COST_CODE_NOT_FOUND = 'COMMODITY_COST_CODE_NOT_FOUND',
  COST_CODE_LIST_ERRORED = 'COST_CODE_LIST_ERRORED',
  CREW_NOT_FOUND = 'CREW_NOT_FOUND'
}

export enum CostCodeSearchScope {
  ALL = 'ALL',
  ASSIGNED = 'ASSIGNED'
}

export type Country = {
  id: Scalars['ID']['output'];
  /** Locale */
  locale: Scalars['String']['output'];
  /** Country name */
  name: Scalars['String']['output'];
};

/** Error while creating a block */
export type CreateBlockError = {
  errorCode?: Maybe<CreateBlockErrorCode>;
  milestone?: Maybe<CommodityMilestone>;
};

/** Error code while creating a block */
export enum CreateBlockErrorCode {
  COMMENT_TOO_LARGE = 'COMMENT_TOO_LARGE',
  CREATE_BLOCK_ERRORED = 'CREATE_BLOCK_ERRORED',
  EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT = 'EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT',
  MILESTONE_ALREADY_APPROVED = 'MILESTONE_ALREADY_APPROVED',
  MILESTONE_ALREADY_BLOCKED = 'MILESTONE_ALREADY_BLOCKED',
  MILESTONE_ALREADY_CLAIMED = 'MILESTONE_ALREADY_CLAIMED',
  MILESTONE_NOT_FOUND = 'MILESTONE_NOT_FOUND',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

/** Input details required for creating a block */
export type CreateBlockInput = {
  /** List of attachment inputs for this block. */
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  /** The Block Type Id  */
  blockTypeId: Scalars['ID']['input'];
  /** Comments made about this block. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** A list of milestones that a block applies to. */
  milestoneIds: Array<Scalars['ID']['input']>;
  /** Work Package Id associated to this block.-TO BE REMOVED, DO NOT USE */
  workPackageId?: InputMaybe<Scalars['ID']['input']>;
};

/** Created block */
export type CreateBlockPayload = {
  block?: Maybe<Block>;
  error?: Maybe<Array<Maybe<CreateBlockError>>>;
};

export enum CreateFitupRequestError {
  COMMODITY_ALREADY_APPROVED = 'COMMODITY_ALREADY_APPROVED',
  COMMODITY_ALREADY_CLAIMED = 'COMMODITY_ALREADY_CLAIMED',
  CREATE_FITUP_REQUEST_ERRORED = 'CREATE_FITUP_REQUEST_ERRORED',
  FITUP_ALREADY_REQUESTED = 'FITUP_ALREADY_REQUESTED',
  INVALID_COMMODITY_ID = 'INVALID_COMMODITY_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

export type CreateFitupRequestsError = {
  errorCode: CreateFitupRequestError;
  weld?: Maybe<Weld>;
};

export type CreateFitupRequestsInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  commodityIds: Array<Scalars['ID']['input']>;
  installationCrewMember: FitupRequestCrewMember;
  isFitupRequired: Scalars['Boolean']['input'];
  isWeldingRequired: Scalars['Boolean']['input'];
  itrRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateFitupRequestsPayload = {
  erroredWelds?: Maybe<Array<CreateFitupRequestsError>>;
  welds?: Maybe<Array<Weld>>;
};

/** Error code while issuing a caddy */
export enum CreateRodRequestCaddyErrorCode {
  CADDY_ALREADY_ISSUED = 'CADDY_ALREADY_ISSUED',
  COMMENT_TOO_LARGE = 'COMMENT_TOO_LARGE',
  CREATE_ROD_REQUEST_CADDY_ERRORED = 'CREATE_ROD_REQUEST_CADDY_ERRORED',
  INVALID_ROD_ROOM_ID = 'INVALID_ROD_ROOM_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  STENCIL_EMPTY = 'STENCIL_EMPTY'
}

/** Input details required for creating rod request and issuing a rod */
export type CreateRodRequestCaddyInput = {
  /** Caddies to be issued */
  caddies: Array<IssueCaddyInput>;
  /** Comments made about this rod request. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Pickup location */
  rodRoomId: Scalars['ID']['input'];
  /** Stencils for the request */
  stencilIds: Array<Scalars['ID']['input']>;
  /** Weld Ids */
  weldIds: Array<Scalars['ID']['input']>;
  /** Weld Procedure Id */
  weldProcedureId: Scalars['ID']['input'];
};

/** Rod request and issue Caddy response payload */
export type CreateRodRequestCaddyPayload = {
  errorCaddies?: Maybe<Array<CreateRodrequestCaddyError>>;
  rodRequest?: Maybe<RodRequest>;
};

/** Error code while creating a rod request */
export enum CreateRodRequestErrorCode {
  COMMENT_TOO_LARGE = 'COMMENT_TOO_LARGE',
  CREATE_ROD_REQUEST_ERRORED = 'CREATE_ROD_REQUEST_ERRORED',
  FILLER_MATERIAL_MISSING = 'FILLER_MATERIAL_MISSING',
  INVALID_ROD_ROOM_ID = 'INVALID_ROD_ROOM_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  STENCIL_EMPTY = 'STENCIL_EMPTY',
  WELD_PROCEDURE_NOT_APPLICABLE = 'WELD_PROCEDURE_NOT_APPLICABLE'
}

/** Input details required for creating a rod request */
export type CreateRodRequestInput = {
  /** Comments made about this rod request. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Filler Materials for the request */
  fillerMaterialDiameterIds: Array<Scalars['ID']['input']>;
  /** Pickup time of the request */
  pickUpTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Pickup location */
  rodRoomId: Scalars['ID']['input'];
  /** Stencils for the request */
  stencilIds: Array<Scalars['ID']['input']>;
  /** Weld Ids */
  weldIds: Array<Scalars['ID']['input']>;
  /** Weld Procedure Id */
  weldProcedureId: Scalars['ID']['input'];
};

/** Created rod request */
export type CreateRodRequestPayload = {
  error?: Maybe<CreateRodRequestErrorCode>;
  rodRequest?: Maybe<RodRequest>;
};

/** Error code while creating a rod room */
export enum CreateRodRoomErrorCode {
  CREATE_ROD_ROOM_ERRORED = 'CREATE_ROD_ROOM_ERRORED',
  EMPTY_ROD_ROOM_NAME = 'EMPTY_ROD_ROOM_NAME',
  INVALID_ELEVATION_VALUE = 'INVALID_ELEVATION_VALUE',
  INVALID_LATITUDE_VALUE = 'INVALID_LATITUDE_VALUE',
  INVALID_LONGITUDE_VALUE = 'INVALID_LONGITUDE_VALUE',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

export type CreateRodRoomInput = {
  /** Elevation for Rod Room */
  elevation: Scalars['Float']['input'];
  /** Latitude for Rod Room */
  latitude: Scalars['Float']['input'];
  /** Longitude for Rod Room */
  longitude: Scalars['Float']['input'];
  /** Description for Rod Room */
  rodRoomDescription?: InputMaybe<Scalars['String']['input']>;
  /** rom room name */
  rodRoomName: Scalars['String']['input'];
};

export type CreateRodRoomPayload = {
  error?: Maybe<CreateRodRoomErrorCode>;
  rodRoom?: Maybe<RodRoom>;
};

export type CreateRodrequestCaddyError = {
  caddy?: Maybe<Caddy>;
  errorCode: CreateRodRequestCaddyErrorCode;
};

export type Crew = {
  /** Crew Employees of the crew that report to the Foreman in the crew */
  crewEmployees?: Maybe<Array<CrewMember>>;
  /** Crew Number of the crew */
  crewNumber: Scalars['String']['output'];
  /** Foreman of the crew */
  foreman?: Maybe<CrewMember>;
  /** General Foreman of the crew */
  generalForeman?: Maybe<CrewMember>;
  /** Crew Id */
  id: Scalars['ID']['output'];
  /** Shift details of the crew's lead */
  shift?: Maybe<Shift>;
  /** Superintendent of the crew */
  superintendent?: Maybe<CrewMember>;
};

export type CrewAttendanceInput = {
  /** Date of attendance */
  forDate?: InputMaybe<Scalars['Date']['input']>;
  /** Foreman identifier for the crew */
  foremanId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CrewChangeActionType {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED'
}

export type CrewChangeCrew = {
  /** Crew Number associated to the crew change request */
  crewNumber: Scalars['String']['output'];
  /** Foreman associated to the crew change request */
  foreman: CrewMember;
  /** General Foreman associated to the crew change request */
  generalForeman: CrewMember;
  /** Id associated to this CrewChangeCrew object */
  id: Scalars['ID']['output'];
  /** Superintendent associated to the crew change request */
  superintendent: CrewMember;
};

export type CrewChangeHierarchyInput = {
  crewEmployeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  foremanId: Scalars['ID']['input'];
  generalForemanId: Scalars['ID']['input'];
  superintendentId: Scalars['ID']['input'];
};

export type CrewChangePayload = {
  foremanId?: Maybe<Scalars['ID']['output']>;
  generalForemanId?: Maybe<Scalars['ID']['output']>;
  superintendentId?: Maybe<Scalars['ID']['output']>;
};

export type CrewChangeRequest = {
  /** Affected crew members for the crew change request */
  affectedCrewMembers: Array<CrewMember>;
  /** Comments */
  comments?: Maybe<Scalars['String']['output']>;
  /** Current crew change request status */
  currentStatus: CrewChangeRequestStatusCode;
  /** Destination crew */
  destinationCrew: CrewChangeCrew;
  /** Primary identifier for crew change request */
  id: Scalars['ID']['output'];
  /** Move type for this crew change request */
  moveType: CrewChangeRequestMoveType;
  /** Origin crew */
  originCrew: CrewChangeCrew;
  /** Status history for a given crew change request */
  statusHistory: Array<CrewChangeRequestStatus>;
};

export enum CrewChangeRequestFilterByEnum {
  /** All Requests including pending, approved, declined */
  ALL = 'ALL',
  /** Approved requests */
  APPROVED = 'APPROVED',
  /** Cancelled Requests */
  CANCELLED = 'CANCELLED',
  /** Approved, Declined and Cancelled */
  CLOSED = 'CLOSED',
  /** Decline requests */
  DECLINED = 'DECLINED',
  /** Pending approvals */
  PENDING_APPROVAL = 'PENDING_APPROVAL'
}

export type CrewChangeRequestFilterByTerm = {
  filterBy: CrewChangeRequestFilterByEnum;
  filterMode: CrewChangeRequestFilterMode;
};

export enum CrewChangeRequestFilterMode {
  /** Filter requests by my pending approvals only */
  MY_APPROVALS = 'MY_APPROVALS',
  /** Filter requests by my requests initiated by me */
  MY_REQUESTS = 'MY_REQUESTS'
}

export type CrewChangeRequestList = {
  items: Array<CrewChangeRequest>;
  /** Row number of the last record in the list */
  rowNumber: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CrewChangeRequestMoveType {
  /** Only Craft employees are part of the request */
  CRAFT = 'CRAFT',
  /** Craft and Foreman are part of the request */
  CREW = 'CREW'
}

export type CrewChangeRequestPayload = {
  crewChangeActionType: CrewChangeActionType;
  crewChangeRequestIds: Array<Scalars['ID']['output']>;
  lastActionAt: Scalars['Datetime']['output'];
  projectId: Scalars['ID']['output'];
};

export type CrewChangeRequestSortByTerm = {
  sortBy: CrewChangeRequestStatusCode;
  sortOrder: SortOrder;
};

export type CrewChangeRequestStatus = {
  /** Created date */
  createdAt: Scalars['Datetime']['output'];
  /** Created by crew member */
  createdBy: CrewMember;
  /** Crew change request status */
  status: CrewChangeRequestStatusCode;
};

export enum CrewChangeRequestStatusCode {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  DECLINED = 'DECLINED',
  PENDING_APPROVAL = 'PENDING_APPROVAL'
}

export type CrewChangeStat = {
  /** crew change stat filter */
  statType: CrewChangeRequestFilterByEnum;
  /** total crew change requests */
  total: Scalars['Int']['output'];
};

export type CrewChangeStatInput = {
  /** End date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Start date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CrewChangeStats = {
  /** My Approvals stats */
  approvals: Array<CrewChangeStat>;
  /** My Requests stats */
  requests: Array<CrewChangeStat>;
};

export type CrewList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<Crew>;
  total: Scalars['Int']['output'];
};

export type CrewMember = {
  /** Badge number. All manual workers have a badge number on the job site. For Welders its their stencil number */
  badgeNumber?: Maybe<Scalars['String']['output']>;
  /** Crew information */
  crew?: Maybe<Crew>;
  /** Crew ID */
  crewId?: Maybe<Scalars['String']['output']>;
  /** Crew member discipline (WELDING, etc) */
  discipline?: Maybe<CrewMemberDiscipline>;
  /** Employee firstname from EIP */
  firstName: Scalars['String']['output'];
  /** Has a pending crew change request */
  hasPendingCrewChangeRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Employee ID from EIP */
  id: Scalars['ID']['output'];
  /** URL of the image of the person */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Employee lastname from EIP */
  lastName: Scalars['String']['output'];
  /** lobEmployeeId of the user if the user is present in eTrack */
  lobEmployeeId?: Maybe<Scalars['String']['output']>;
  /** Persona (Foreman, etc) */
  persona?: Maybe<PersonaType>;
  /** Pending Planning with AI request for the CrewMember */
  planningAiRequest?: Maybe<PlanningWithAiRequest>;
  /** Position code */
  positionCode?: Maybe<Scalars['String']['output']>;
  /** Shift */
  shift?: Maybe<Shift>;
  /** Shift (day/night) */
  shiftType?: Maybe<CrewMemberShiftType>;
  /** Employee sub group description */
  subGroupDescription?: Maybe<Scalars['String']['output']>;
  /** Supervisor information. Deferred Field */
  supervisor?: Maybe<CrewMember>;
};

/** A grouped list of assigned crew members for a work package */
export type CrewMemberAssignment = {
  /** Crew member */
  crewMember?: Maybe<CrewMember>;
  /** Persona of the crew member */
  persona: PersonaType;
};

export type CrewMemberAssignmentError = {
  crewMember?: Maybe<CrewMember>;
  error?: Maybe<AssignCrewMembersError>;
  ownershipType?: Maybe<OwnershipType>;
  persona?: Maybe<PersonaType>;
};

export type CrewMemberAssignmentInput = {
  /** Leave this empty to unassign the crew member */
  crewMemberId?: InputMaybe<Scalars['ID']['input']>;
  ownershipType: OwnershipType;
  persona: PersonaType;
  /** Reassign end of shift */
  reAssignEndOfShift?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrewMemberAssignmentWorkPackageError = {
  error?: Maybe<AssignCrewMembersError>;
  workPackage?: Maybe<WorkPackageError>;
};

export enum CrewMemberDiscipline {
  NONE = 'NONE',
  WELDING = 'WELDING'
}

export type CrewMemberEarnableHours = {
  crewMemberId: Scalars['ID']['output'];
  earnableHours: Scalars['Float']['output'];
};

export type CrewMemberEarnableHoursInput = {
  /** List of crew members */
  crewMembers?: InputMaybe<Array<PlanningCrewMemberInput>>;
  supervisor?: InputMaybe<PlanningCrewMemberInput>;
};

export type CrewMemberExpiredMilestoneStats = {
  /** Crew Member */
  crewMember?: Maybe<CrewMember>;
  /** Unique indentifier for the type */
  id: Scalars['ID']['output'];
  /** Expired Milestone count */
  numExpiredMilestones: Scalars['Int']['output'];
};

export type CrewMemberList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<CrewMember>;
  total: Scalars['Int']['output'];
};

export enum CrewMemberShiftType {
  DAY = 'DAY',
  NIGHT = 'NIGHT'
}

export enum CrewMemberSortByTerm {
  WELDER_STENCIL = 'WELDER_STENCIL'
}

export type CrewMemberStats = {
  /** Total sum of claimed hours for all milestones in all commodities. */
  claimedHours: Scalars['Float']['output'];
  /** Total crew hours for the persona */
  crewCapacityHours: Scalars['Float']['output'];
  /** Crew Member */
  crewMember?: Maybe<CrewMember>;
  /** Total sum of planned hours for all milestones in all commodities. */
  plannedHours: Scalars['Float']['output'];
};

export type CrewMemberWeeklyLookAheadStatsInput = {
  crewMember?: InputMaybe<PlanningCrewMemberInput>;
  /** Check to get data for All Superintendents */
  isAllSuperintendents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of next weeks to fetch data */
  numNextWeeks?: InputMaybe<Scalars['Int']['input']>;
  /** Number of Previous weeks to fetch data */
  numPreviousWeeks?: InputMaybe<Scalars['Int']['input']>;
  supervisor?: InputMaybe<PlanningCrewMemberInput>;
};

export type CrewProgressStats = {
  commodityStatusStats?: Maybe<Array<Maybe<CommodityStatusStats>>>;
  craftIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  crewMember: CrewMember;
  crewMemberId: Scalars['ID']['output'];
  hasExpiredRodRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Pass input to apply the rod-request level filters like ALL, TODAY, TOMORROW AND EXPIRED */
  numRodRequests: Scalars['Int']['output'];
};


export type CrewProgressStatsCommodityStatusStatsArgs = {
  input?: InputMaybe<CrewProgressStatsInput>;
};


export type CrewProgressStatsNumRodRequestsArgs = {
  input: CrewProgressStatsInput;
};

export enum CrewProgressStatsFilterByTerm {
  /** CREW_MEMBER_ID - Valid Operators EQUALS,NOT_EQUALS */
  CREW_MEMBER_ID = 'CREW_MEMBER_ID',
  /** End Date */
  END_DATE = 'END_DATE',
  INCLUDE_BLOCKED_COMMODITY = 'INCLUDE_BLOCKED_COMMODITY',
  /** PERSONA_TYPE - Valid Operator EQUALS,NOT_EQUALS */
  PERSONA_TYPE = 'PERSONA_TYPE',
  /** E.g. ALL, TODAY, TOMORROW AND EXPIRED. Valid Operators EQUALS,NOT_EQUALS, IN and NOT_IN */
  ROD_REQUEST_PICK_UP_DATE = 'ROD_REQUEST_PICK_UP_DATE',
  /** Start Date */
  START_DATE = 'START_DATE'
}

export type CrewProgressStatsFilterByTermInput = {
  /** Operator to control the ANDs and ORs */
  operator: FilterOperator;
  term: CrewProgressStatsFilterByTerm;
  /** Value for Terms that require IDs, Booleans,  */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Muliple values, applicable only for IN operator */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CrewProgressStatsFilterInput = {
  /** And filter, all filter terms in this will be applied with and operator */
  and?: InputMaybe<Array<CrewProgressStatsFilterByTermInput>>;
  /** Or filter, all filter terms in this will be applied with or operator */
  or?: InputMaybe<Array<CrewProgressStatsFilterByTermInput>>;
};

export enum CrewProgressStatsFilterInputError {
  CREW_PROGRESS_STATS_ERRORED = 'CREW_PROGRESS_STATS_ERRORED',
  FILTER_DEPENDENCY_MISSING = 'FILTER_DEPENDENCY_MISSING',
  FILTER_VALUES_MISSING = 'FILTER_VALUES_MISSING',
  FILTER_VALUE_MISSING = 'FILTER_VALUE_MISSING',
  INVALID_FILTER_OPERATOR = 'INVALID_FILTER_OPERATOR',
  INVALID_FILTER_ROD_REQUEST_PICK_UP_DATE_TYPE = 'INVALID_FILTER_ROD_REQUEST_PICK_UP_DATE_TYPE',
  INVALID_PERSONA_TYPE = 'INVALID_PERSONA_TYPE',
  PAGING_LIMIT_EXCEEDED_ON_REQUEST_COUNT_SORT = 'PAGING_LIMIT_EXCEEDED_ON_REQUEST_COUNT_SORT'
}

export type CrewProgressStatsInput = {
  /** Filter to handle all types */
  complexFilter?: InputMaybe<CrewProgressStatsFilterInput>;
  /** Sort by Filter */
  sortByFilter?: InputMaybe<CrewProgressStatsSortByFilterInput>;
};

export type CrewProgressStatsList = {
  crewMember?: Maybe<CrewMember>;
  /** Crew Member Id for which stats are requested */
  crewMemberId: Scalars['ID']['output'];
  cursor?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<CrewProgressStatsFilterInputError>>>;
  items: Array<CrewProgressStats>;
  total: Scalars['Int']['output'];
};

export type CrewProgressStatsSortByFilterInput = {
  /** Sort Order, ascending or descending, defaults to ascending */
  sortOrder?: InputMaybe<SortOrder>;
  /** Term to sort the results by. */
  term: CrewProgressStatsSortByTerm;
};

export enum CrewProgressStatsSortByTerm {
  REQUEST_COUNT = 'REQUEST_COUNT',
  WELDER = 'WELDER'
}

export type CrewStats = {
  attendanceGraph: AttendanceGraph;
  attendancePct: Scalars['Int']['output'];
  /** Head count */
  numCrewMembers: Scalars['Int']['output'];
  /** Number of crews */
  numCrews: Scalars['Int']['output'];
  numCurrentlyOnSite: Scalars['Int']['output'];
};

export type CrewType = {
  /** Whether the crew type is selected for the current project */
  applicableToProject: Scalars['Boolean']['output'];
  /** Full descriptive name of the crew type. Eg. Pipefitters, Iron workers */
  description?: Maybe<Scalars['String']['output']>;
  /** The schema from eTrack is unknown for now. We might remove this property or just have it populated with the prefix like PF, IW */
  id: Scalars['ID']['output'];
  /** Prefix that signifies the short name of the crew for eg. PF, IW */
  name: Scalars['String']['output'];
};

export type CrewUpdatedPayload = {
  affectedCrewMembers: Array<AffectedCrewPayload>;
};

export type DailyMilestoneProgress = {
  cumulativeMilestoneHours?: Maybe<Scalars['Int']['output']>;
  cumulativeMilestoneQuantity?: Maybe<Scalars['Float']['output']>;
  date: Scalars['Date']['output'];
  /** Internal ID for Planning Week */
  id: Scalars['ID']['output'];
  milestoneApprovedHours: Scalars['Int']['output'];
  milestoneApprovedQuantity: Scalars['Float']['output'];
  milestoneClaimedInPlanHours: Scalars['Int']['output'];
  milestoneClaimedInPlanQuantity: Scalars['Float']['output'];
  milestoneQuantity: Scalars['Float']['output'];
  milestonehours: Scalars['Int']['output'];
  targetHours: Scalars['Int']['output'];
  targetQuantity: Scalars['Float']['output'];
  weekDay: Scalars['String']['output'];
};

export enum DataFlowDefinitionError {
  DATA_FLOW_DEFINITION_ERRORED = 'DATA_FLOW_DEFINITION_ERRORED'
}

export type DataFlowDefinitionInput = {
  projectIds: Array<Scalars['ID']['input']>;
};

export type DataFlowDefinitionPayload = {
  error?: Maybe<DataFlowDefinitionError>;
  rowsUpdated: Scalars['Int']['output'];
  status: ImportDataFlowDefinitionStatusCode;
};

export enum DataflowDirection {
  BPS_TO_LOB = 'BPS_TO_LOB',
  LOB_TO_BPS = 'LOB_TO_BPS'
}

export enum DataflowEntityFieldDataType {
  array = 'array',
  boolean = 'boolean',
  date = 'date',
  datetime = 'datetime',
  decimal = 'decimal',
  number = 'number',
  object = 'object',
  string = 'string'
}

export type DataflowEntityMapping = {
  /** entity type id in BPS */
  bpsEntityTypeId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  dataflowDirection?: Maybe<DataflowDirection>;
  /** entity registry in LOB */
  dataflowEntityRegistry: DataflowEntityRegistry;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFilter?: Maybe<Scalars['Boolean']['output']>;
  isReceiverFieldKey?: Maybe<Scalars['Boolean']['output']>;
  isSenderFieldKey?: Maybe<Scalars['Boolean']['output']>;
  /** entity id in LOB */
  projectsDataflowEntityRegistryId?: Maybe<Scalars['String']['output']>;
  receiverAppCode?: Maybe<Scalars['String']['output']>;
  receiverFieldDataType: DataflowEntityFieldDataType;
  receiverFieldDescription?: Maybe<Scalars['String']['output']>;
  /** Entity Field Name in BPS */
  receiverFieldPath: Scalars['String']['output'];
  senderAppCode?: Maybe<Scalars['String']['output']>;
  senderFieldDataType: DataflowEntityFieldDataType;
  senderFieldDescription?: Maybe<Scalars['String']['output']>;
  /** Entity Field Name in LOB */
  senderFieldPath: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<User>;
};

export enum DataflowEntityMappingError {
  APP_NOT_REGISTERED = 'APP_NOT_REGISTERED'
}

export type DataflowEntityMappingErrorPayload = {
  dataflowDirection?: Maybe<DataflowDirection>;
  id?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  projectsDataflowEntityRegistryId?: Maybe<Scalars['ID']['output']>;
  receiverFieldDataType?: Maybe<Scalars['String']['output']>;
  receiverFieldDescription?: Maybe<Scalars['String']['output']>;
  receiverFieldPath?: Maybe<Scalars['String']['output']>;
  senderFieldDataType?: Maybe<Scalars['String']['output']>;
  senderFieldDescription?: Maybe<Scalars['String']['output']>;
  senderFieldPath?: Maybe<Scalars['String']['output']>;
};

export type DataflowEntityMappingInput = {
  projectId: Scalars['String']['input'];
};

export type DataflowEntityMappingPayload = {
  dataflowEntityMappings?: Maybe<Array<DataflowEntityMapping>>;
  error?: Maybe<DataflowEntityMappingError>;
};

export type DataflowEntityRegistry = {
  bpsEntityTypeId: Scalars['String']['output'];
  bpsEventNotificationTopic?: Maybe<Scalars['String']['output']>;
  dataflowAppRegistry?: Maybe<ProjectDataflowAppRegistry>;
  dataflowAppRegistryId?: Maybe<Scalars['ID']['output']>;
  dataflowDirection?: Maybe<DataflowDirection>;
  dataflowMode?: Maybe<Scalars['String']['output']>;
  entityDeleteUrl?: Maybe<Scalars['String']['output']>;
  entityDictionary?: Maybe<Scalars['JSON']['output']>;
  entityDictionaryLastUpdatedAt?: Maybe<Scalars['Date']['output']>;
  entityDictionaryUrl?: Maybe<Scalars['String']['output']>;
  entityGetUrl?: Maybe<Scalars['String']['output']>;
  entityPostUrl?: Maybe<Scalars['String']['output']>;
  entityPutUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lobEntityTypeId: Scalars['String']['output'];
};

export type DataflowEntityRegistryInput = {
  projectId: Scalars['String']['input'];
};

export enum DeclineCrewChangeError {
  EIS_ERROR = 'EIS_ERROR',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  REQUEST_IS_ALREADY_APPROVED = 'REQUEST_IS_ALREADY_APPROVED',
  REQUEST_IS_ALREADY_CANCELLED = 'REQUEST_IS_ALREADY_CANCELLED',
  REQUEST_IS_ALREADY_DECLINED = 'REQUEST_IS_ALREADY_DECLINED',
  REQUEST_NOT_FOUND = 'REQUEST_NOT_FOUND'
}

export type DeclineCrewChangeRequestPayload = {
  crewChangeRequest?: Maybe<CrewChangeRequest>;
  error?: Maybe<DeclineCrewChangeError>;
};

export type DefaultRolePermission = {
  id: Scalars['ID']['output'];
  permissionScopeId: Scalars['String']['output'];
  roleId: Scalars['String']['output'];
};

/** Delete block attachment error */
export enum DeleteBlockAttachmentError {
  BLOCKID_NOT_FOUND = 'BLOCKID_NOT_FOUND',
  DELETE_BLOCK_ATTACHMENT_ERRORED = 'DELETE_BLOCK_ATTACHMENT_ERRORED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  UNASSIGNED_WORK_PACKAGE = 'UNASSIGNED_WORK_PACKAGE'
}

/** Delete attachment from a block */
export type DeleteBlockAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
};

/** Payload after deleting attachment from an existing block */
export type DeleteBlockAttachmentPayload = {
  block?: Maybe<Block>;
  error?: Maybe<DeleteBlockAttachmentError>;
  /** If the removed is true then the file was removed physically from Azure storage */
  removed?: Maybe<Scalars['Boolean']['output']>;
};

/** Error code while deleting a caddy */
export enum DeleteCaddyErrorCode {
  DELETE_CADDY_MUTATION_ERROR = 'DELETE_CADDY_MUTATION_ERROR',
  INVALID_CADDY_ID = 'INVALID_CADDY_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

/** Input details required for deleting a caddy */
export type DeleteCaddyInput = {
  /** Caddy Id */
  id: Scalars['ID']['input'];
};

/** Delete Caddy response payload */
export type DeleteCaddyPayload = {
  caddy?: Maybe<RodRequestCaddy>;
  error?: Maybe<DeleteCaddyErrorCode>;
};

export enum DeleteCommodityAttachmentError {
  ASSOCIATED_ATTACHMENT_NOT_AVAILABLE = 'ASSOCIATED_ATTACHMENT_NOT_AVAILABLE',
  COMMODITY_NOT_FOUND = 'COMMODITY_NOT_FOUND',
  DELETE_COMMODITY_ATTACHMENT_ERRORED = 'DELETE_COMMODITY_ATTACHMENT_ERRORED',
  DOCUMENT_UPLOADED_BY_SOME_OTHER_USER = 'DOCUMENT_UPLOADED_BY_SOME_OTHER_USER',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION'
}

export type DeleteCommodityAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
  commodityId: Scalars['ID']['input'];
};

export type DeleteCommodityAttachmentPayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<DeleteCommodityAttachmentError>;
};

export enum DeleteMilestoneAttachmentError {
  ASSOCIATED_ATTACHMENT_NOT_AVAILABLE = 'ASSOCIATED_ATTACHMENT_NOT_AVAILABLE',
  DELETE_MILESTONE_ATTACHMENT_ERRORED = 'DELETE_MILESTONE_ATTACHMENT_ERRORED',
  DOCUMENT_UPLOADED_BY_SOME_OTHER_USER = 'DOCUMENT_UPLOADED_BY_SOME_OTHER_USER',
  MILESTONE_NOT_FOUND = 'MILESTONE_NOT_FOUND'
}

export type DeleteMilestoneAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
  commodityMilestoneId: Scalars['ID']['input'];
};

export type DeleteMilestoneAttachmentPayload = {
  error?: Maybe<DeleteMilestoneAttachmentError>;
  milestone?: Maybe<CommodityMilestone>;
};

export enum DeleteMilestoneTypeError {
  DELETE_MILESTONE_TYPE_ERRORED = 'DELETE_MILESTONE_TYPE_ERRORED',
  PROJECT_MILESTONE_TYPE_NOT_FOUND = 'PROJECT_MILESTONE_TYPE_NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type DeleteMilestoneTypeInput = {
  projectMilestoneTypeId: Scalars['ID']['input'];
};

export type DeleteMilestoneTypePayload = {
  error?: Maybe<DeleteMilestoneTypeError>;
  numCommodityMilestonesDeleted: Scalars['Int']['output'];
};

/** Delete project report error */
export enum DeleteProjectReportError {
  DELETE_REPORT_ERRORED = 'DELETE_REPORT_ERRORED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND'
}

export type DeleteProjectReportInput = {
  /** Project Report id */
  id: Scalars['ID']['input'];
};

export type DeleteProjectReportPayload = {
  error?: Maybe<DeleteProjectReportError>;
  /** Project Report id */
  projectReport?: Maybe<ProjectReport>;
};

/** Error code while deleting a rod request */
export enum DeleteRodRequestErrorCode {
  ALL_ISSUED_CADDIES_NOT_RETURNED = 'ALL_ISSUED_CADDIES_NOT_RETURNED',
  DELETE_ROD_REQUEST_ERRORED = 'DELETE_ROD_REQUEST_ERRORED',
  INVALID_ROD_REQUEST_ID = 'INVALID_ROD_REQUEST_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  ROD_REQUEST_ALREADY_CLOSED = 'ROD_REQUEST_ALREADY_CLOSED',
  ROD_REQUEST_ALREADY_DELETED = 'ROD_REQUEST_ALREADY_DELETED'
}

export type DeleteRodRequestInput = {
  /** Rod Request ID */
  rodRequestId: Scalars['ID']['input'];
};

/** Delete Rod Request response payload */
export type DeleteRodRequestPayload = {
  error?: Maybe<DeleteRodRequestErrorCode>;
  rodRequest?: Maybe<RodRequest>;
};

/** Delete role error */
export enum DeleteRoleError {
  DEFAULT_ROLE_CAN_NOT_BE_DELETED = 'DEFAULT_ROLE_CAN_NOT_BE_DELETED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  ROLE_IS_ASSIGNED = 'ROLE_IS_ASSIGNED'
}

export type DeleteRolePayload = {
  error?: Maybe<DeleteRoleError>;
  /** Role id */
  id: Scalars['ID']['output'];
};

export enum DeleteWeldAttachmentError {
  ASSOCIATED_ATTACHMENT_NOT_AVAILABLE = 'ASSOCIATED_ATTACHMENT_NOT_AVAILABLE',
  DELETE_WELD_ATTACHMENT_ERRORED = 'DELETE_WELD_ATTACHMENT_ERRORED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  PHOTO_ATTACHED_BY_SOME_OTHER_USER = 'PHOTO_ATTACHED_BY_SOME_OTHER_USER',
  WELD_NOT_FOUND = 'WELD_NOT_FOUND'
}

export type DeleteWeldAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
  weldId: Scalars['ID']['input'];
};

export type DeleteWeldAttachmentPayload = {
  error?: Maybe<DeleteWeldAttachmentError>;
  weld?: Maybe<Weld>;
};

export enum DeleteWorkPackageAttachmentError {
  ASSOCIATED_ATTACHMENT_NOT_AVAILABLE = 'ASSOCIATED_ATTACHMENT_NOT_AVAILABLE',
  DELETE_WORK_PACKAGE_ATTACHMENT_ERRORED = 'DELETE_WORK_PACKAGE_ATTACHMENT_ERRORED',
  DOCUMENT_UPLOADED_BY_SOME_OTHER_USER = 'DOCUMENT_UPLOADED_BY_SOME_OTHER_USER',
  WORK_PACKAGE_NOT_FOUND = 'WORK_PACKAGE_NOT_FOUND'
}

export type DeleteWorkPackageAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
  workPackageId: Scalars['ID']['input'];
};

export type DeleteWorkPackageAttachmentPayload = {
  error?: Maybe<DeleteWorkPackageAttachmentError>;
  workPackage?: Maybe<WorkPackage>;
};

/** Error while saving the device registration id */
export enum DeviceRegistrationError {
  REGISTRATION_ID_NULL = 'REGISTRATION_ID_NULL'
}

export type DiameterInput = {
  /** Rod diameter */
  diameterId: Scalars['ID']['input'];
  /** Heat or lot number */
  heatOrLotNumberId: Scalars['ID']['input'];
};

export type DrawingComplexFilterInput = {
  /** And filter, all filter terms in this will be applied with and operator */
  and?: InputMaybe<Array<FilterByDrawingTermInput>>;
  /** Or filter, all filter terms in this will be applied with or operator */
  or?: InputMaybe<Array<FilterByDrawingTermInput>>;
};

export enum DrawingFilterByTerm {
  /** Commodity Type Id */
  COMMODITY_TYPE_ID = 'COMMODITY_TYPE_ID',
  /** Crew Member Id */
  CREW_MEMBER_ID = 'CREW_MEMBER_ID',
  /** Drawing Id */
  DRAWING_NUMBER = 'DRAWING_NUMBER'
}

export enum DrawingFilterInputError {
  FILTER_VALUES_MISSING = 'FILTER_VALUES_MISSING',
  FILTER_VALUE_MISSING = 'FILTER_VALUE_MISSING',
  INVALID_FILTER_OPERATOR = 'INVALID_FILTER_OPERATOR',
  INVALID_FILTER_VALUE = 'INVALID_FILTER_VALUE'
}

export type DrawingInput = {
  complexFilter?: InputMaybe<DrawingComplexFilterInput>;
};

export type DrawingList = {
  cursor?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<DrawingFilterInputError>>>;
  items: Array<IsoDocument>;
  total: Scalars['Int']['output'];
};

export type EarnableHours = {
  /** Total of earnable hours for the supervisor */
  allEarnableHours: Scalars['Float']['output'];
  /** Earnable hours for the given list of crew members */
  crewMemberEarnableHours: Array<CrewMemberEarnableHours>;
  /** Total of any unassigned earnable hours for the supervisor */
  unassignedEarnableHours: Scalars['Float']['output'];
};

export type EmployeeUpdatedPayload = {
  crewMemberId: Scalars['ID']['output'];
  personaTypeId: PersonaType;
};

export type EntityList = {
  entityTypes: Array<Scalars['String']['output']>;
};

export type EventNotification = {
  createdAt: Scalars['Datetime']['output'];
  entityTypeId: Scalars['String']['output'];
  error?: Maybe<Scalars['JSON']['output']>;
  errorTypeId?: Maybe<EventNotificationErrorTypeId>;
  id: Scalars['ID']['output'];
  identifier: Array<Scalars['String']['output']>;
  message: Scalars['JSON']['output'];
  nextScheduleAt?: Maybe<Scalars['Datetime']['output']>;
  notificationTypeId: EventNotificationTypeId;
  retryCount: Scalars['Int']['output'];
  retryId?: Maybe<Scalars['String']['output']>;
  retryNextScheduledAt?: Maybe<Scalars['Datetime']['output']>;
  status: EventNotificationStatus;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export enum EventNotificationErrorCode {
  FILTER_VALUES_MISSING = 'FILTER_VALUES_MISSING',
  FILTER_VALUE_MISSING = 'FILTER_VALUE_MISSING',
  INVALID_ENTITY_TYPE_VALUE = 'INVALID_ENTITY_TYPE_VALUE',
  INVALID_ERROR_TYPE_VALUE = 'INVALID_ERROR_TYPE_VALUE',
  INVALID_FILTER_OPERATOR = 'INVALID_FILTER_OPERATOR',
  INVALID_FILTER_VALUE = 'INVALID_FILTER_VALUE',
  INVALID_NOTIFICATION_TYPE_ID_VALUE = 'INVALID_NOTIFICATION_TYPE_ID_VALUE',
  INVALID_STATUS_VALUE = 'INVALID_STATUS_VALUE'
}

export enum EventNotificationErrorTypeId {
  NONTRANSIENT = 'NONTRANSIENT',
  TRANSIENT = 'TRANSIENT'
}

export enum EventNotificationFilterByTerm {
  /** EntityType enum is used. Ex: WorkPack, Spool, BulkPipe. Valid Operators EQUALS,NOT_EQUALS, IN and NOT_IN */
  ENTITY_TYPE = 'ENTITY_TYPE',
  /** Valid values are TRANSIENT, NONTRANSIENT. Valid Operators EQUALS, NOT_EQUALS, IN and NOT_IN */
  ERROR_TYPE = 'ERROR_TYPE',
  /** Notification Id. Valid Operators EQUALS, NOT_EQUALS, IN and NOT_IN */
  NOTIFICATION_ID = 'NOTIFICATION_ID',
  /** E.g. INBOUND AND OUTBOUND. Valid Operators EQUALS, NOT_EQUALS, IN and NOT_IN */
  NOTIFICATION_TYPE_ID = 'NOTIFICATION_TYPE_ID',
  /** This field is used for searching Error Description or Error Summary. Valid Operators EQUALS, NOT_EQUALS, IN and NOT_IN, CONTAINS */
  SEARCH_ERRORS = 'SEARCH_ERRORS',
  /** Valid values are PUBLISH, SUCCESS or ERROR. Valid Operators EQUALS, NOT_EQUALS, IN and NOT_IN */
  STATUS = 'STATUS'
}

export type EventNotificationFilterByTermInput = {
  /** Operator to control the ANDs and ORs */
  operator: FilterOperator;
  term: EventNotificationFilterByTerm;
  /** Value for Terms that require IDs, Booleans,  */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Muliple values, applicable only for IN operator */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EventNotificationFilterInput = {
  /** And filter, all filter terms in this will be applied with and operator */
  and?: InputMaybe<Array<EventNotificationFilterByTermInput>>;
  /** Or filter, all filter terms in this will be applied with or operator */
  or?: InputMaybe<Array<EventNotificationFilterByTermInput>>;
};

export type EventNotificationInput = {
  /** Filter to handle all types */
  complexFilter?: InputMaybe<EventNotificationFilterInput>;
  /** sort the filter values using this key */
  sortByFilter?: InputMaybe<EventNotificationSortByFilterInput>;
};

export type EventNotificationList = {
  cursor: Scalars['String']['output'];
  errors?: Maybe<Array<EventNotificationErrorCode>>;
  items: Array<EventNotification>;
  total: Scalars['Int']['output'];
};

export type EventNotificationSortByFilterInput = {
  /** Sort Order, ascending or descending, defaults to ascending */
  sortOrder: SortOrder;
  /** Term to sort the results by. */
  term: EventNotificationSortByTerm;
};

export enum EventNotificationSortByTerm {
  CREATED_AT = 'CREATED_AT',
  ENTITY_TYPE_ID = 'ENTITY_TYPE_ID',
  ERROR_TYPE_ID = 'ERROR_TYPE_ID',
  NEXT_SCHEDULE_AT = 'NEXT_SCHEDULE_AT',
  NOTIFICATION_TYPE_ID = 'NOTIFICATION_TYPE_ID',
  RETRY_COUNT = 'RETRY_COUNT',
  STATUS = 'STATUS',
  UPDATED_AT = 'UPDATED_AT'
}

export type EventNotificationStat = {
  entityType: Scalars['String']['output'];
  stats: Scalars['Int']['output'];
};

export enum EventNotificationStatus {
  ERROR = 'ERROR',
  PUBLISH = 'PUBLISH',
  RESCHEDULED = 'RESCHEDULED',
  SUCCESS = 'SUCCESS'
}

export enum EventNotificationTypeId {
  ALL = 'ALL',
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

/** List of potential exceptions the server can return */
export enum ExceptionCode {
  /** The user does not have the required permission for this action */
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  /** Generic error code */
  SYSTEM_ERROR = 'SYSTEM_ERROR'
}

export type ExpiredMilestones = {
  commodityMilestoneIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Impacted milestones */
  milestones: Array<CommodityMilestone>;
};

export type Facility = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
  title: Scalars['String']['output'];
};

export type FacilityUnitRate = {
  facility: Facility;
  unitRate: UnitRate;
};

export type FacilityUnitRateInput = {
  facilityId: Scalars['ID']['input'];
  unitRate: UnitRateInput;
};

export type Feature = {
  enabled: Scalars['Boolean']['output'];
  featureDefinition?: Maybe<FeatureDefinition>;
  id: Scalars['ID']['output'];
  metaData?: Maybe<Scalars['JSON']['output']>;
  readOnly: Scalars['Boolean']['output'];
};

export type FeatureDefinition = {
  /** App Feature */
  appFeature: AppFeature;
  /** Description of the feature definition */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Structure for additional attributes required for the feature */
  metaDataDefinition?: Maybe<Scalars['JSON']['output']>;
  /** Feature name */
  name: Scalars['String']['output'];
};

export type FillerMaterialFilterInput = {
  /** Caddy id */
  caddyId: Scalars['String']['input'];
};

export type FillerMaterialInput = {
  /** Rod diameter and heat lot number */
  diameters: Array<DiameterInput>;
  /** Filler material of Rod */
  fillerMaterialId: Scalars['ID']['input'];
};

export enum FillerMaterialType {
  BARE = 'BARE',
  COATED = 'COATED'
}

export type FilterByCommodityTermInput = {
  /** Operator to control the ANDs and ORs */
  operator: FilterOperator;
  term: CommodityFilterByTerm;
  /** Value for Terms that require IDs, Booleans,  */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Muliple values, applicable only for IN operator */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FilterByDateInput = {
  /** End date of the week */
  endDate: Scalars['Date']['input'];
  /** Start date of the week */
  startDate: Scalars['Date']['input'];
};

export type FilterByDrawingTermInput = {
  /** Operator to control the ANDs and ORs */
  operator: FilterOperator;
  term: DrawingFilterByTerm;
  /** Value for Terms that require IDs, Booleans,  */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Muliple values, applicable only for IN operator */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FilterOperator {
  /** value is mandatory */
  CONTAINS = 'CONTAINS',
  /** value is mandatory */
  EQUALS = 'EQUALS',
  /** value is mandatory */
  FUZZY = 'FUZZY',
  /** value is mandatory */
  GREATER_THAN = 'GREATER_THAN',
  /** values is mandatory */
  IN = 'IN',
  /** value is mandatory */
  LESS_THAN = 'LESS_THAN',
  /** value is mandatory */
  NOT_EQUALS = 'NOT_EQUALS',
  /** values is mandatory */
  NOT_IN = 'NOT_IN'
}

export type FitupRequest = {
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  installationCrewMember?: Maybe<CrewMember>;
  isFitupRequired: Scalars['Boolean']['output'];
  isWeldingRequired: Scalars['Boolean']['output'];
};

export type FitupRequestCrewMember = {
  crewMemberId: Scalars['ID']['input'];
  personaType: PersonaType;
};

export type FlushEntityInput = {
  entityType: AppEntityType;
  ids: Array<Scalars['String']['input']>;
};

export type Gbu = {
  /** Gbu description */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type GeoLocation = {
  /** Elevation of the item in feet above sea level. */
  elevation?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type ImportCommoditiesInput = {
  importScheduleType: ImportScheduleType;
  lobCommodityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lobCommodityTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lobUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
};

export type ImportCommoditiesPayload = {
  error?: Maybe<ImportError>;
  importSchedule?: Maybe<ImportSchedule>;
  importScheduleId?: Maybe<Scalars['String']['output']>;
  importStatus?: Maybe<Scalars['String']['output']>;
};

export enum ImportDataFlowDefinitionStatusCode {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS'
}

export enum ImportError {
  API_UNAVAILABLE = 'API_UNAVAILABLE',
  DATAFLOW_APP_REGISTRY_NOT_FOUND = 'DATAFLOW_APP_REGISTRY_NOT_FOUND',
  ETRACK_API_ERRORED = 'ETRACK_API_ERRORED',
  ETRACK_CREW_API_ERRORED = 'ETRACK_CREW_API_ERRORED',
  ETRACK_CREW_EMPLOYEE_API_ERRORED = 'ETRACK_CREW_EMPLOYEE_API_ERRORED',
  ETRACK_EMPLOYEE_API_ERRORED = 'ETRACK_EMPLOYEE_API_ERRORED',
  ETRACK_SHIFT_API_ERRORED = 'ETRACK_SHIFT_API_ERRORED',
  HYDRATE_COMMODITIES_ERROR = 'HYDRATE_COMMODITIES_ERROR',
  IMPORT_LOB_COMMODITIES_ERROR = 'IMPORT_LOB_COMMODITIES_ERROR',
  IMPORT_NOT_SCHEDULED = 'IMPORT_NOT_SCHEDULED',
  INCORRECT_IMPORT_LAST_RUN_DATE = 'INCORRECT_IMPORT_LAST_RUN_DATE',
  INTERNAL_SERVICE_ERROR = 'INTERNAL_SERVICE_ERROR',
  INVALID_INPUT = 'INVALID_INPUT',
  INVALID_LOB_COMMODITY_TYPE_ID = 'INVALID_LOB_COMMODITY_TYPE_ID',
  MAX_PAGE_INDEX = 'MAX_PAGE_INDEX',
  MIN_PAGE_INDEX = 'MIN_PAGE_INDEX',
  PROJECT_CONFIG_NOT_FOUND = 'PROJECT_CONFIG_NOT_FOUND',
  SCHEDULING_ERROR = 'SCHEDULING_ERROR',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  TW_API_ERRORED = 'TW_API_ERRORED',
  WITS_API_ERRORED = 'WITS_API_ERRORED',
  WITS_WELDER_API_ERRORED = 'WITS_WELDER_API_ERRORED',
  WORK_PACKAGE_DICIPLINES_NOT_FOUND = 'WORK_PACKAGE_DICIPLINES_NOT_FOUND'
}

/** Import Schedule */
export type ImportSchedule = {
  /** Import schedule created by */
  createdAt: Scalars['Datetime']['output'];
  /** Import schedule created by */
  createdBy: User;
  /** Schedule End Date */
  endDatetime?: Maybe<Scalars['Datetime']['output']>;
  /** Import error summary */
  errorSummary?: Maybe<ImportSummary>;
  /** ID of the import schedule */
  id: Scalars['ID']['output'];
  /** Import Status */
  importStatus: ImportStatus;
  /** Total records imported/affected summary */
  importSummary?: Maybe<ImportSummary>;
  /** Import Type */
  importType: ImportType;
  /** Schedule Start Date */
  startDatetime: Scalars['Datetime']['output'];
};

export enum ImportScheduleType {
  FULL_IMPORT = 'FULL_IMPORT',
  INCREMENTAL_IMPORT = 'INCREMENTAL_IMPORT',
  SELECTIVE_IMPORT = 'SELECTIVE_IMPORT'
}

export type ImportStatus = {
  error?: Maybe<ImportError>;
  status: ImportStatusCode;
};

/** Import Status */
export enum ImportStatusCode {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  ERRORED = 'ERRORED',
  IN_PROGRESS = 'IN_PROGRESS',
  SCHEDULED = 'SCHEDULED'
}

export type ImportSummary = {
  totalCaddies?: Maybe<Scalars['Int']['output']>;
  totalCommodities?: Maybe<Scalars['Int']['output']>;
  totalCommodityStatus?: Maybe<Scalars['Int']['output']>;
  totalFitupRequests?: Maybe<Scalars['Int']['output']>;
  totalImportedWelders?: Maybe<Scalars['Int']['output']>;
  totalMilestoneStatus?: Maybe<Scalars['Int']['output']>;
  totalMilestones?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
  totalWorkPackageOwners?: Maybe<Scalars['Int']['output']>;
  totalWorkPackages?: Maybe<Scalars['Int']['output']>;
};

/** Import Type */
export enum ImportType {
  COMMODITIES = 'COMMODITIES',
  USERS = 'USERS',
  WELD_CONFIG = 'WELD_CONFIG',
  WORK_PACKAGES = 'WORK_PACKAGES'
}

export type ImportUsersInput = {
  appTypeId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type ImportUsersPayload = {
  error?: Maybe<ImportError>;
  importSchedule?: Maybe<ImportSchedule>;
  importScheduleId?: Maybe<Scalars['String']['output']>;
  importStatus?: Maybe<Scalars['String']['output']>;
};

export type ImportWeldConfigPayload = {
  error?: Maybe<ImportError>;
  importSchedule?: Maybe<ImportSchedule>;
  importScheduleId?: Maybe<Scalars['String']['output']>;
  importStatus?: Maybe<ImportStatusCode>;
};

export type ImportWorkPackageInput = {
  disciplineId: Scalars['String']['input'];
  importScheduleType: ImportScheduleType;
  lobUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  lobWorkPackageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type ImportWorkPackagesPayload = {
  error?: Maybe<ImportError>;
  importSchedule?: Maybe<ImportSchedule>;
  importScheduleId?: Maybe<Scalars['String']['output']>;
  importStatus?: Maybe<Scalars['String']['output']>;
};

export type IsoDocument = {
  commodity: CommodityWrapper;
  documentNumber: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Input details required for issuing a rod */
export type IssueCaddiesInput = {
  /** Caddies to be issued */
  caddies: Array<IssueCaddyInput>;
  /** Rod Request Id */
  rodRequestId: Scalars['ID']['input'];
};

/** Issue Caddy response payload */
export type IssueCaddiesPayload = {
  caddies?: Maybe<Array<RodRequestCaddy>>;
  error?: Maybe<IssueCaddyErrorCode>;
};

/** Issue Caddy response error */
export type IssueCaddyError = {
  caddyId?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<IssueCaddyErrorCode>;
};

/** Error code while updating a caddy */
export enum IssueCaddyErrorCode {
  INVALID_CADDY_ID = 'INVALID_CADDY_ID',
  INVALID_ROD_REQUEST_ID = 'INVALID_ROD_REQUEST_ID',
  ISSUE_CADDIES_MUTATION_ERRORED = 'ISSUE_CADDIES_MUTATION_ERRORED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  STENCILS_NOT_IN_ROD_REQUEST = 'STENCILS_NOT_IN_ROD_REQUEST'
}

/** Input details required for issuing a rod */
export type IssueCaddyInput = {
  /** Caddy Id */
  caddyId: Scalars['ID']['input'];
  fillerMaterialDiameterDetailId: Array<Scalars['ID']['input']>;
  /** Filler material for the caddy */
  fillerMaterialId: Scalars['ID']['input'];
  /** Issued Used crewMember Id */
  issuedBy: Scalars['ID']['input'];
  /** Stencils for the request */
  issuedToStencilIds: Array<Scalars['ID']['input']>;
  /** Picked up user crewMember id.  */
  pickedUpBy: Scalars['ID']['input'];
};

export enum ItrMilestoneAction {
  APPROVE = 'APPROVE',
  CLAIM = 'CLAIM'
}

export type ItrMilestoneConfigInput = {
  projectCommodityTypeItrId: Scalars['ID']['input'];
  projectMilestoneTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ItrType {
  PIPE_CLEANLINESS = 'PIPE_CLEANLINESS'
}

export type Language = {
  /** Locale */
  id: Scalars['ID']['output'];
  /** Language name */
  name: Scalars['String']['output'];
};

export enum LoadWorkPackageError {
  INVALID_DATE_FILTERS = 'INVALID_DATE_FILTERS',
  INVALID_WORK_PACKAGE_ID = 'INVALID_WORK_PACKAGE_ID',
  WORK_PACKAGE_NOT_FOUND = 'WORK_PACKAGE_NOT_FOUND'
}

export enum LobAppCode {
  ACNX = 'ACNX',
  ETRACK = 'ETRACK',
  TW = 'TW',
  WITS = 'WITS'
}

/** Employee details from EIP */
export type LobEmployee = {
  /** BUN of the lob employee */
  bun?: Maybe<Scalars['String']['output']>;
  /** Mobile carrier of lob employee's phone */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Email of the lob employee */
  email?: Maybe<Scalars['String']['output']>;
  /** First Name */
  firstName: Scalars['String']['output'];
  /** Unique ID of lob employee */
  id: Scalars['ID']['output'];
  /** Lob employee's image url */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** It returns true If the Lob employee already exists in BPS DB. Otherwise returns false */
  isBPSUser: Scalars['Boolean']['output'];
  /** Last Name */
  lastName: Scalars['String']['output'];
  /** Middle Name */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Phone number of the lob employee */
  phone?: Maybe<Scalars['String']['output']>;
  /** Supervisor of the user */
  supervisor?: Maybe<LobEmployee>;
};

export type LobEmployeeList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<LobEmployee>;
  total: Scalars['Int']['output'];
};

export type MapMarker = {
  displayIdentifier: Scalars['String']['output'];
  geoLocation: GeoLocation;
  /** Unique identifier of the Marker ex. Weld, Rod Room, Data Vault Id */
  id: Scalars['ID']['output'];
  locationDescription?: Maybe<Scalars['String']['output']>;
  type: MarkerType;
};

export type MapMarkersPayload = {
  commodities?: Maybe<Array<MapMarker>>;
  dataVaults?: Maybe<Array<MapMarker>>;
  errors?: Maybe<Array<CommodityFilterInputError>>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Rod Room Map Markers */
  rodRooms?: Maybe<Array<MapMarker>>;
};


export type MapMarkersPayloadCommoditiesArgs = {
  commodityComplexFilter?: InputMaybe<CommodityComplexFilterInput>;
  types: Array<MarkerType>;
};


export type MapMarkersPayloadDataVaultsArgs = {
  types: Array<MarkerType>;
};


export type MapMarkersPayloadRodRoomsArgs = {
  types: Array<MarkerType>;
};

export enum MarkerType {
  DATA_VAULT = 'DATA_VAULT',
  PIPING = 'PIPING',
  ROD_ROOM = 'ROD_ROOM',
  STEEL = 'STEEL'
}

export type Material = {
  balance?: Maybe<Scalars['Float']['output']>;
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  design?: Maybe<Scalars['Float']['output']>;
  iso?: Maybe<Scalars['String']['output']>;
  issue?: Maybe<Scalars['Float']['output']>;
  mrrDate?: Maybe<Scalars['Datetime']['output']>;
  mrrNumber?: Maybe<Scalars['String']['output']>;
  mwrNumber?: Maybe<Scalars['String']['output']>;
  mwrs?: Maybe<Array<Maybe<MaterialWithdrawal>>>;
  onHand?: Maybe<Scalars['Float']['output']>;
  tagOrStockCode?: Maybe<Scalars['String']['output']>;
};

/** Underlying configuration based metadata for this commodity type */
export type MaterialCommodity = {
  /** Area number for this commodity */
  areaNumber?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  /** List of personas assigned to Material commodity */
  commodityAssignees?: Maybe<Array<CommodityAssignee>>;
  /** Cost Code of the Commodity */
  costCodeId?: Maybe<Scalars['String']['output']>;
  /** Total sum of approved hours for all milestones in this commodity. */
  earnedHours: Scalars['Float']['output'];
  /** Total sum of approved LF/LM for all milestones in this commodity. */
  earnedQuantity: Scalars['Float']['output'];
  /** The last date of the week this commodity is planned for */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** Facility of this commodity */
  facility?: Maybe<Facility>;
  /** Unique identifier of the commodity */
  id: Scalars['ID']['output'];
  /** ISO Document */
  isoDocument?: Maybe<IsoDocument>;
  /** Location description of the Commodity */
  locationDescription?: Maybe<Scalars['String']['output']>;
  /** Material for this commodity */
  material?: Maybe<Material>;
  /** Material status for the commodity */
  materialStatusI18n?: Maybe<MaterialStatus>;
  /** List of milestones for the commodity */
  milestones: Array<CommodityMilestone>;
  /** History of status changes on the milestones. */
  milestonesActivityHistory?: Maybe<CommodityMilestoneActivityList>;
  /** The Material Withdrawal Request number, a request that the FE/ FM makes to request material be issued to them from the Project site's warehouse */
  mwrNumber?: Maybe<Scalars['String']['output']>;
  /** milestone planned end date */
  plannedEndDate?: Maybe<Scalars['Date']['output']>;
  /** milestone planned start date */
  plannedStartDate?: Maybe<Scalars['Date']['output']>;
  /** Commodity spec reference data */
  sections: Array<CommoditySection>;
  /** The starting date of the week this commodity is planned for */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** Startup number for this commodity */
  startupNumber?: Maybe<Scalars['String']['output']>;
  /** Tag number of the commodity */
  tag: Scalars['String']['output'];
  /** Total sum of hours for all milestones in this commodity. */
  totalEarnableHours: Scalars['Float']['output'];
  /** Total sum of hours for all milestones in this commodity along with unit of measure */
  totalEarnableQuantity: Quantity;
  /** Commodity type information */
  type: CommodityType;
  /** Workpackage of the commodity */
  workPackage?: Maybe<WorkPackage>;
};


/** Underlying configuration based metadata for this commodity type */
export type MaterialCommodityAttachmentsArgs = {
  attachmentType?: InputMaybe<AttachmentType>;
};


/** Underlying configuration based metadata for this commodity type */
export type MaterialCommodityMilestonesActivityHistoryArgs = {
  paging?: InputMaybe<PagingInput>;
};

export type MaterialOnSite = {
  commodityType: CommodityType;
  materialTracking: MaterialTrackingCode;
  numOnSite: Scalars['Int']['output'];
  totalCommodities: Scalars['Int']['output'];
};

export enum MaterialStatus {
  /** Material status is not relevant for the commodity */
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  /** Material located and is ready to be used on job */
  ON_SITE = 'ON_SITE',
  /** Material has been received at the warehouse but not delivered to project site */
  RECEIVED = 'RECEIVED',
  /** Material has been ordred and awaited at the warehouse */
  RECEIVING = 'RECEIVING'
}

export enum MaterialTrackingCode {
  /** Indicate this commodity for materials should not be queried/displayed on UI. */
  DISABLED = 'DISABLED',
  /** Indicate this commodity should display both total commodities count and numOnSite count for this commodity. */
  MATERIAL_COMMODITIES = 'MATERIAL_COMMODITIES',
  /** Indicate this commodity should display only total commodities count, numOnSite will be 0 for this commodity. */
  TOTAL_COMMODITIES = 'TOTAL_COMMODITIES'
}

export type MaterialWithdrawal = {
  mwrDate?: Maybe<Scalars['Datetime']['output']>;
  mwrNumber?: Maybe<Scalars['String']['output']>;
  mwrQty?: Maybe<Scalars['Float']['output']>;
  mwrStatus?: Maybe<MwrStatus>;
};

export enum MilestoneActivity {
  APPROVED = 'APPROVED',
  ASSIGNED = 'ASSIGNED',
  BLOCK_OPENED = 'BLOCK_OPENED',
  BLOCK_RESOLVED = 'BLOCK_RESOLVED',
  CANCELED = 'CANCELED',
  CLAIMED = 'CLAIMED',
  CLAIMED_APPROVED = 'CLAIMED_APPROVED',
  PLANNED = 'PLANNED',
  RECLAIMED = 'RECLAIMED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  UNAPPROVED = 'UNAPPROVED',
  UNASSIGNED = 'UNASSIGNED',
  UNCLAIMED = 'UNCLAIMED',
  UNPLANNED = 'UNPLANNED'
}

export type MilestoneActivityStats = {
  milestoneActivityStatus: MilestoneActivityStatusType;
  stats: Array<MilestoneTypeCount>;
};

export type MilestoneActivityStatsByCommodityType = {
  commodityType?: Maybe<CommodityType>;
  milestoneActivityStats: Array<MilestoneActivityStats>;
};

/** ALL - All milestones which can be claim or approve, CLAIMABLE - All milestones which can be claim, APPROVABLE - All milestones which can be approve */
export enum MilestoneActivityStatusType {
  ALL = 'ALL',
  APPROVABLE = 'APPROVABLE',
  CLAIMABLE = 'CLAIMABLE'
}

export enum MilestoneFilterStatusFlag {
  ALL_UNPLANNED = 'ALL_UNPLANNED',
  BLOCKED = 'BLOCKED',
  EXPIRED = 'EXPIRED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  READY_TO_CLAIM_CONNECTIONS = 'READY_TO_CLAIM_CONNECTIONS',
  REJECTED = 'REJECTED'
}

export type MilestoneReference = {
  commodityRef: CommodityReference;
  typeId: Scalars['ID']['input'];
};

export type MilestoneRejectionReason = {
  comments?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type MilestoneRejectionSubReason = {
  comments?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  milestoneStatusId?: Maybe<Scalars['ID']['output']>;
  reason: Scalars['String']['output'];
};

export type MilestoneStats = {
  hours: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Number of Milestones */
  numMilestones: Scalars['Int']['output'];
  /** Linear feet equivalent */
  quantity: Quantity;
};

export type MilestoneStatus = {
  actionableMilestoneStatusId: Scalars['ID']['output'];
  activity: MilestoneActivity;
  appData?: Maybe<MilestoneStatusAppData>;
  codeI18n: MilestoneStatusCode;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<CrewMember>;
  id: Scalars['ID']['output'];
  rejectionSubReasonTypes: Array<ProjectMilestoneTypeRejectionSubReason>;
  rejectionType?: Maybe<ProjectMilestoneTypeRejectionReason>;
  type: ProjectMilestoneType;
};

export type MilestoneStatusAppData = {
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  weldedProcedureId?: Maybe<Scalars['String']['output']>;
};

/** Available status for a milestone. */
export enum MilestoneStatusCode {
  APPROVED = 'APPROVED',
  ASSIGNED = 'ASSIGNED',
  BLOCKED = 'BLOCKED',
  BLOCK_RESOLVED = 'BLOCK_RESOLVED',
  CANCELED = 'CANCELED',
  CLAIMED = 'CLAIMED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  PLANNED = 'PLANNED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  UNAPPROVED = 'UNAPPROVED',
  UNASSIGNED = 'UNASSIGNED',
  UNCLAIMED = 'UNCLAIMED',
  UNPLANNED = 'UNPLANNED'
}

/** Input object to use in claimMilestone Mutation. */
export type MilestoneStatusInput = {
  commodityMilestoneId: Scalars['ID']['input'];
  itrRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MilestoneType = {
  commodityTypes: Array<CommodityType>;
  id: Scalars['ID']['output'];
  /**
   * Boolean flag when true indicates that this milestone requires Inspection and Test record aka Pipe Cleanliness self certification before claim
   * @deprecated This field is deprecated
   */
  itrRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type MilestoneTypeCount = {
  id: Scalars['ID']['output'];
  milestoneType: MilestoneType;
  numMilestones: Scalars['Int']['output'];
};

/** Input object to use in commodityMilestones Query. If milestoneActivityStatusIds is not passed in input, all the milestones which can be claim or approve whould be consider in stats */
export type MilestonesActivityStatsFilterInput = {
  commodityTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  milestoneActivityStatusIds?: InputMaybe<Array<MilestoneActivityStatusType>>;
};

/** Input object to use in commodityMilestones Query. */
export type MilestonesFilterInput = {
  commodityTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  milestoneActivityStatusIds?: InputMaybe<Array<MilestoneActivityStatusType>>;
  milestoneTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MilestonesUnplannedPayload = {
  foremanId: Scalars['ID']['output'];
  milestoneCount: Scalars['Int']['output'];
};

/** List of modules available in the application */
export enum Module {
  ADMIN = 'ADMIN',
  APPLICATION = 'APPLICATION',
  BLOCKS = 'BLOCKS',
  CREW_CHANGE = 'CREW_CHANGE',
  DASHBOARD = 'DASHBOARD',
  NOTIFICATIONS = 'NOTIFICATIONS',
  PLANNING = 'PLANNING',
  PUNCHLIST = 'PUNCHLIST',
  REPORTS = 'REPORTS',
  ROD_ROOM = 'ROD_ROOM',
  SHIFT_LOG = 'SHIFT_LOG',
  TESTING = 'TESTING',
  TIMESHEET = 'TIMESHEET',
  WELDS = 'WELDS',
  WORK_PACKAGES = 'WORK_PACKAGES'
}

export type Mutation = {
  /** Add attachment to an existing block */
  addBlockAttachment: AddBlockAttachmentPayload;
  /** Add comments to an existing block */
  addBlockComment: AddBlockCommentPayload;
  /** Add attachment to an existing Commodity */
  addCommodityAttachment: AddCommodityAttachmentPayload;
  /** Mutation to add a crew change request */
  addCrewChangeRequest: AddCrewChangeRequestPayload;
  addDataflowEntityMappings: AddDataflowEntityMappingPayload;
  /** @deprecated This mutation is deprecated */
  addDefaultPermission: AddDefaultPermissionPayload;
  /** Add import schedule */
  addImportSchedule: AddImportSchedulePayload;
  /** Add attachment to an existing milestone */
  addMilestoneAttachment: AddMilestoneAttachmentPayload;
  /** Add Project Commodity Type(s). */
  addProjectCommodityTypes: Array<CommodityType>;
  /** Add Project Milestone Type(s) */
  addProjectMilestoneTypes: Array<CommodityType>;
  /** @deprecated This mutation is deprecated */
  addProjectPermission: AddProjectPermissionPayload;
  addProjectReport: AddProjectReportPayload;
  /** Mutation to add new role */
  addRole: AddRolePayload;
  /** Add Users mutation is only a temporary mutation until IAM implements resolving users */
  addUser: AddUserPayload;
  /** Add attachment to weld */
  addWeldAttachment: AddWeldAttachmentPayload;
  /** Add attachment to an existing WorkPackage */
  addWorkPackageAttachment: AddWorkPackageAttachmentPayload;
  /** Mutation to approve all crew change requests */
  approveAllCrewChangeRequests: ApproveAllCrewChangeRequestsPayload;
  /** Changes the milestones status to APPROVED. */
  approveAllMilestones: ApproveAllMilestonesPayload;
  /** Mutation to approve a crew change request */
  approveCrewChangeRequest: ApproveCrewChangeRequestPayload;
  /** Approve Fitup. Set the status to Ready To Weld  */
  approveFitup: ApproveFitupPayload;
  /** Changes the milestone status to APPROVED. */
  approveMilestone: ApproveMilestonePayload;
  /** Approve weld. Set the status to VT Approved  */
  approveWeld: ApproveWeldPayload;
  /** Approve weld fitup  */
  approveWeldFitupInspection: ApproveWeldFitupInspectionPayload;
  /** Bulk Assign Crew Members to Commodities */
  assignCommodityCrewMembers: AssignCommodityCrewMembersPayload;
  assignCrewMembers: AssignCrewMembersPayload;
  assignUnassignAssociatedCrewMembers: AssignUnassignAssociatedCrewMembersPayload;
  /** Assign/UnAssign as Priority */
  assignUnassignPriorityCommodity: AssignUnassignPriorityPayload;
  /** Mutation to add facilities to user */
  assignUserFacilities: AssignUserFacilitiesPayload;
  /** Mutation to add roles to user */
  assignUserRoles: AssignUserRolesPayload;
  /** Assign Weld Crew. Assign Weld Foreman, Stencils, Lead Field Weld Engineer */
  assignWeldCrew: AssignWeldCrewPayload;
  /** Assign/Un-assign welding foreman to a weld commodity. */
  assignWeldForeman: AssignWeldForemanPayload;
  cancelAiPlanning: PlanningPayload;
  /** Mutation to cancel a crew change request */
  cancelCrewChangeRequest: CancelCrewChangeRequestPayload;
  /** Cancel Fitup Request(s) */
  cancelFitupRequest: CancelFitupRequestPayload;
  /** Cancel import schedule */
  cancelImportSchedule: CancelImportSchedulePayload;
  /** Changes the milestones status to CLAIMED. */
  claimAllMilestones: ClaimAllMilestonesPayload;
  /** Claim and Approve Weld */
  claimApproveWeld: ClaimApproveWeldPayload;
  /** Changes the milestone status to CLAIMED. */
  claimMilestone: ClaimMilestonePayload;
  /** Claim a weld */
  claimWeld: ClaimWeldPayload;
  /** Clears all the entries in redis cache. DO NOT USE THIS UNLESS REQUIRED FOR DEBUGGING. TO BE PHASED OUT ONCE THE ENVIRONMENTS ARE STABLE */
  clearAll: Scalars['Boolean']['output'];
  /** Close a rod request by Id */
  closeRodRequest: CloseRodRequestPayload;
  /** Close rod request By Stencil Id */
  closeRodRequestByStencilId: CloseRodRequestByStencilIdPayload;
  /** Configure a project */
  configureProject: ConfigureProjectPayload;
  copyDataflowEntityMappings: CopyDataflowEntityMappingPayload;
  /** Create a new block */
  createBlock: CreateBlockPayload;
  /** Create Fitup Request(s) */
  createFitupRequests: CreateFitupRequestsPayload;
  /** Create a new rod request */
  createRodRequest: CreateRodRequestPayload;
  /** Create and Update a rod request */
  createRodRequestCaddy: CreateRodRequestCaddyPayload;
  /** create Rod Room */
  createRodRoom: CreateRodRoomPayload;
  /** Mutation to decline a crew change request */
  declineCrewChangeRequest: DeclineCrewChangeRequestPayload;
  /** Delete attachment from an existing block */
  deleteBlockAttachment: DeleteBlockAttachmentPayload;
  /** Delete Issued Caddies */
  deleteCaddy: DeleteCaddyPayload;
  deleteCommodityAttachment: DeleteCommodityAttachmentPayload;
  /** Delete attachment to an existing milestone */
  deleteMilestoneAttachment: DeleteMilestoneAttachmentPayload;
  /** Delete Project Milestone Type. deleted all the associated commodity milestones and recalculates the work package percerntage completes. */
  deleteMilestoneType: DeleteMilestoneTypePayload;
  deletePlanForWpIds: PlanningPayload;
  /** Delete Project Commodity Type. */
  deleteProjectCommodityType?: Maybe<Scalars['Int']['output']>;
  deleteProjectReport: DeleteProjectReportPayload;
  /** Delete a Rod Request */
  deleteRodRequest: DeleteRodRequestPayload;
  /** Mutation to delete custom role */
  deleteRole: DeleteRolePayload;
  /** Delete attachment from weld */
  deleteWeldAttachment: DeleteWeldAttachmentPayload;
  /** Delete attachment to an existing WorkPackage */
  deleteWorkPackageAttachment: DeleteWorkPackageAttachmentPayload;
  /** Flushing entities based on their id */
  flushEntities: Scalars['Boolean']['output'];
  importDataFlowDefinition: DataFlowDefinitionPayload;
  /** Issue Caddy */
  issueCaddies: IssueCaddiesPayload;
  /** Pin / Add a set of cost codes for a foreman's crew. */
  pinCostCodes: PinCostCodesPayload;
  planAiPlanning: AiPlanningPayload;
  /** Update Rod Request Progress */
  progressRodRequestWelds: BulkRodRequestProgressWeldsPayload;
  /** Reassign Fitup Request */
  reassignFitupRequest: ReassignFitupRequestPayload;
  /** Changes the milestone status to CLAIMED. */
  reclaimMilestone: ReclaimMilestonePayload;
  /** Changes the milestone status to CLAIMED. */
  reclaimWeld: ReclaimWeldPayload;
  /** Send Back to Piping */
  rejectFitup: RejectFitupPayload;
  /** Send back to piping in absence of fitup milestone. Payload will be same as rejectFitup and milestoneId is optional in the input, rest of the input is same. */
  rejectFitupRequest: RejectFitupPayload;
  /** Changes the milestone status to REJECTED. */
  rejectMilestone: RejectMilestonePayload;
  /** Send Back to Foreman */
  rejectWeld: RejectWeldPayload;
  /** Resolve a block. */
  resolveBlock: ResolveBlockPayload;
  /** Mutation to restore default role permissions by role Id */
  restoreDefaultPermissions: RestoreDefaultPermissionPayload;
  /** Return Issued Caddies */
  returnCaddies: ReturnCaddiesPayload;
  sampleLastUpdatedMutation: SampleLastUpdatedMutationPayload;
  saveAiPlanning: PlanningPayload;
  /** Save Project Commodity section items */
  saveCommoditySectionItemsConfig: SaveCommoditySectionItemsPayload;
  /** Save crew type selection for project. Input ids should contain all selections bold old and new combined as input will completely replace the saved selections. */
  saveCrewTypeSelection: SaveCrewTypeSelectionPayload;
  /** Preserve device registration id in the database. */
  saveDeviceRegistrationId?: Maybe<SaveDeviceRegistrationPayload>;
  /** Save one or more features. Can be used to enable/disable features or to update feature configuration. */
  saveFeatures: SaveFeaturesPayload;
  /** Update ITR Config */
  saveItrConfig: SaveItrConfigPayload;
  /** Save Project Lob Role Names, this mutation requires full input, removes the missing entries and adds new entries. */
  savePersonaLobRoleNames: SavePersonaLobRoleNamesPayload;
  savePlanning: PlanningPayload;
  /** Update Planning and Target Calculation */
  savePlanningAndTargetConfig: SavePlanningAndTargetConfigPayload;
  /** update quantity reporting */
  saveQuantityReportingConfig: SaveQuantityReportingConfigPayload;
  /** Save a daily timesheet for a given foreman's crew. */
  saveTimesheet: SaveTimesheetPayload;
  /** Save a daily timesheet for a given foreman's crew. */
  saveTimesheetCharges: SaveTimesheetChargesPayload;
  /** Save user preferences like language, unit of measurement etc */
  saveUserPreferences: SaveUserPreferencesPayload;
  /** Save Weld Program management */
  saveWeldProgramConfig: SaveWeldProgramConfigPayload;
  /** Send a sample push notification. */
  sendSamplePushNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Set Default project for a user */
  setUserDefaultProject: SetUserDefaultProjectPayload;
  syncEventNotifications: SyncEventNotificationsPayload;
  testMutation: TestMutationPayload;
  /** Changes the milestone status to CLAIMED. */
  unapproveFitup: UnApproveFitupPayload;
  /** Changes the milestone status to CLAIMED. */
  unapproveMilestone: UnApproveMilestonePayload;
  /** Changes the milestone status to CLAIMED. */
  unapproveWeld: UnApproveWeldPayload;
  /** Changes the milestone status to PLANNED. */
  unclaimMilestone: UnclaimMilestonePayload;
  /** Changes the milestone status to PLANNED. */
  unclaimWeld: UnclaimWeldPayload;
  /** Unpin / Delete a set of cost codes from a foreman's pinned cost codes. */
  unpinCostCodes: UnpinCostCodesPayload;
  unplan: PlanningPayload;
  /** Update existing block */
  updateBlock: UpdateBlockPayload;
  /** Change the status of a block. Not implemented yet. */
  updateBlockStatus: UpdateBlockStatusPayload;
  /** Update Issued Caddy */
  updateCaddy: UpdateCaddyPayload;
  /** Update Details of a given commodity. */
  updateCommodity: UpdateCommodityPayload;
  /** add/Update Location Description of a given commodity. */
  updateCommodityLocationDescription: UpdateCommodityLocationDescriptionPayload;
  /** Update Stencil Progress */
  updateCommodityProgress: CommodityProgressPayload;
  updateDataflowEntityMappings: UpdateDataflowEntityMappingPayload;
  /** @deprecated This mutation is deprecated */
  updateDefaultPermission: UpdateDefaultPermissionPayload;
  /** Activate/De-Activate modules */
  updateModules: UpdateModulesPayload;
  /**
   * Mutation to customize permissions
   * @deprecated This mutation is deprecated, use updateProjectPermissions of role-permission instead!
   */
  updatePermissions: UpdatePermissionPayload;
  /** Update a project */
  updateProject: UpdateProjectPayload;
  /** Update Project Commodity Type. */
  updateProjectCommodityType: CommodityType;
  /** Update Project Milestone Type */
  updateProjectMilestoneTypes: Array<CommodityType>;
  updateProjectPermissions: UpdateProjectPermissionPayload;
  updateProjectReport: UpdateProjectReportPayload;
  /** Update a rod request */
  updateRodRequest: UpdateRodRequestPayload;
  /** update Rod Room */
  updateRodRoom: UpdateRodRoomPayload;
  /** Mutation to edit custom role */
  updateRole: UpdateRolePayload;
  /** Mutation to update user */
  updateUser: UpdateUserPayload;
  /** Mutation to activate/de-activate user */
  updateUserStatus: UpdateUserStatusPayload;
  /** Removes given work packages disciplines by marking them as inactive */
  updateWorkPackageDisciplines: UpdateWorkPackageDisciplinesPayload;
  updateWorkPackageSchedule: UpdateWorkPackageSchedulePayload;
  void?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddBlockAttachmentArgs = {
  input: AddBlockAttachmentInput;
};


export type MutationAddBlockCommentArgs = {
  input: AddBlockCommentInput;
};


export type MutationAddCommodityAttachmentArgs = {
  input: AddCommodityAttachmentInput;
};


export type MutationAddCrewChangeRequestArgs = {
  input: AddCrewChangeRequestInput;
};


export type MutationAddDataflowEntityMappingsArgs = {
  input: Array<AddDataflowEntityMappingInput>;
};


export type MutationAddDefaultPermissionArgs = {
  input: AddDefaultPermissionInput;
};


export type MutationAddImportScheduleArgs = {
  input: AddImportScheduleInput;
};


export type MutationAddMilestoneAttachmentArgs = {
  input: AddMilestoneAttachmentInput;
};


export type MutationAddProjectCommodityTypesArgs = {
  input: Array<AddProjectCommodityTypeInput>;
};


export type MutationAddProjectMilestoneTypesArgs = {
  input: AddProjectMilestoneTypeInput;
};


export type MutationAddProjectPermissionArgs = {
  input: AddProjectPermissionInput;
};


export type MutationAddProjectReportArgs = {
  input: AddProjectReportInput;
};


export type MutationAddRoleArgs = {
  input: AddRoleInput;
};


export type MutationAddUserArgs = {
  input: AddUserInput;
};


export type MutationAddWeldAttachmentArgs = {
  input: AddWeldAttachmentInput;
};


export type MutationAddWorkPackageAttachmentArgs = {
  input: AddWorkPackageAttachmentInput;
};


export type MutationApproveAllMilestonesArgs = {
  input: ApproveAllMilestonesInput;
};


export type MutationApproveCrewChangeRequestArgs = {
  crewChangeRequestId: Scalars['ID']['input'];
};


export type MutationApproveFitupArgs = {
  input: MilestoneStatusInput;
};


export type MutationApproveMilestoneArgs = {
  input: MilestoneStatusInput;
};


export type MutationApproveWeldArgs = {
  input: MilestoneStatusInput;
};


export type MutationApproveWeldFitupInspectionArgs = {
  input: ApproveWeldFitupInspectionInput;
};


export type MutationAssignCommodityCrewMembersArgs = {
  input: AssignCommoditiesInput;
};


export type MutationAssignCrewMembersArgs = {
  input: AssignCrewMembersInput;
};


export type MutationAssignUnassignAssociatedCrewMembersArgs = {
  input: AssignUnassignAssociatedCrewMembersInput;
};


export type MutationAssignUnassignPriorityCommodityArgs = {
  input: AssignUnassignPriorityInput;
};


export type MutationAssignUserFacilitiesArgs = {
  input: AssignUserFacilitiesInput;
};


export type MutationAssignUserRolesArgs = {
  input: AssignUserRolesInput;
};


export type MutationAssignWeldCrewArgs = {
  input: AssignWeldCrewInput;
};


export type MutationAssignWeldForemanArgs = {
  input: AssignWeldForemanInput;
};


export type MutationCancelAiPlanningArgs = {
  planningAiRequestId: Scalars['ID']['input'];
};


export type MutationCancelCrewChangeRequestArgs = {
  crewChangeRequestId: Scalars['ID']['input'];
};


export type MutationCancelFitupRequestArgs = {
  input: MilestoneStatusInput;
};


export type MutationCancelImportScheduleArgs = {
  input: CancelImportScheduleInput;
};


export type MutationClaimAllMilestonesArgs = {
  input: ClaimAllMilestonesInput;
};


export type MutationClaimApproveWeldArgs = {
  input: ClaimApproveWeldInput;
};


export type MutationClaimMilestoneArgs = {
  input: ClaimMilestoneInput;
};


export type MutationClaimWeldArgs = {
  input: ClaimWeldInput;
};


export type MutationCloseRodRequestArgs = {
  input: CloseRodRequestInput;
};


export type MutationCloseRodRequestByStencilIdArgs = {
  input: CloseRodRequestByStencilIdInput;
};


export type MutationConfigureProjectArgs = {
  input: ConfigureProjectInput;
};


export type MutationCopyDataflowEntityMappingsArgs = {
  input: CopyDataflowEntityMappingInput;
};


export type MutationCreateBlockArgs = {
  input: CreateBlockInput;
};


export type MutationCreateFitupRequestsArgs = {
  input: CreateFitupRequestsInput;
};


export type MutationCreateRodRequestArgs = {
  input: CreateRodRequestInput;
};


export type MutationCreateRodRequestCaddyArgs = {
  input: CreateRodRequestCaddyInput;
};


export type MutationCreateRodRoomArgs = {
  input: CreateRodRoomInput;
};


export type MutationDeclineCrewChangeRequestArgs = {
  crewChangeRequestId: Scalars['ID']['input'];
};


export type MutationDeleteBlockAttachmentArgs = {
  input: DeleteBlockAttachmentInput;
};


export type MutationDeleteCaddyArgs = {
  input: DeleteCaddyInput;
};


export type MutationDeleteCommodityAttachmentArgs = {
  input: DeleteCommodityAttachmentInput;
};


export type MutationDeleteMilestoneAttachmentArgs = {
  input: DeleteMilestoneAttachmentInput;
};


export type MutationDeleteMilestoneTypeArgs = {
  input: DeleteMilestoneTypeInput;
};


export type MutationDeletePlanForWpIdsArgs = {
  wpIds: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProjectCommodityTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectReportArgs = {
  id?: InputMaybe<DeleteProjectReportInput>;
};


export type MutationDeleteRodRequestArgs = {
  input: DeleteRodRequestInput;
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWeldAttachmentArgs = {
  input: DeleteWeldAttachmentInput;
};


export type MutationDeleteWorkPackageAttachmentArgs = {
  input: DeleteWorkPackageAttachmentInput;
};


export type MutationFlushEntitiesArgs = {
  input: FlushEntityInput;
};


export type MutationIssueCaddiesArgs = {
  input: IssueCaddiesInput;
};


export type MutationPinCostCodesArgs = {
  input: PinCostCodesInput;
};


export type MutationPlanAiPlanningArgs = {
  input: AiPlanningInput;
};


export type MutationProgressRodRequestWeldsArgs = {
  input: BulkRodRequestProgressInput;
};


export type MutationReassignFitupRequestArgs = {
  input: ReassignFitupRequestInput;
};


export type MutationReclaimMilestoneArgs = {
  input: ReclaimMilestoneInput;
};


export type MutationReclaimWeldArgs = {
  input: ReclaimWeldInput;
};


export type MutationRejectFitupArgs = {
  input: RejectFitupInput;
};


export type MutationRejectFitupRequestArgs = {
  input: RejectFitupRequestInput;
};


export type MutationRejectMilestoneArgs = {
  input: RejectMilestoneInput;
};


export type MutationRejectWeldArgs = {
  input: RejectWeldInput;
};


export type MutationResolveBlockArgs = {
  input: ResolveBlockInput;
};


export type MutationRestoreDefaultPermissionsArgs = {
  inputs: Array<Scalars['ID']['input']>;
};


export type MutationReturnCaddiesArgs = {
  input: ReturnCaddiesInput;
};


export type MutationSampleLastUpdatedMutationArgs = {
  input: SampleLastUpdatedMutationInput;
};


export type MutationSaveAiPlanningArgs = {
  planningAiRequestId: Scalars['ID']['input'];
};


export type MutationSaveCommoditySectionItemsConfigArgs = {
  input: Array<SaveCommoditySectionItemInput>;
};


export type MutationSaveCrewTypeSelectionArgs = {
  input: Array<Scalars['ID']['input']>;
};


export type MutationSaveDeviceRegistrationIdArgs = {
  input: RegisterDeviceInput;
};


export type MutationSaveFeaturesArgs = {
  input: Array<SaveFeatureInput>;
};


export type MutationSaveItrConfigArgs = {
  input: Array<InputMaybe<SaveItrConfigInput>>;
};


export type MutationSavePersonaLobRoleNamesArgs = {
  input: Array<SavePersonaLobRoleNamesInput>;
};


export type MutationSavePlanningArgs = {
  input: SavePlanningInput;
};


export type MutationSavePlanningAndTargetConfigArgs = {
  input: SavePlanningAndTargetConfigInput;
};


export type MutationSaveQuantityReportingConfigArgs = {
  input: SaveQuantityReportingConfigInput;
};


export type MutationSaveTimesheetArgs = {
  input: SaveTimesheetInput;
};


export type MutationSaveTimesheetChargesArgs = {
  input: SaveTimesheetChargesInput;
};


export type MutationSaveUserPreferencesArgs = {
  input: SaveUserPreferencesInput;
};


export type MutationSaveWeldProgramConfigArgs = {
  input: SaveWeldProgramConfigInput;
};


export type MutationSendSamplePushNotificationArgs = {
  message: Scalars['String']['input'];
};


export type MutationSetUserDefaultProjectArgs = {
  input: SetUserDefaultProjectInput;
};


export type MutationSyncEventNotificationsArgs = {
  input: SyncEventNotificationsInput;
};


export type MutationTestMutationArgs = {
  input: TestMutationInput;
};


export type MutationUnapproveFitupArgs = {
  input: MilestoneStatusInput;
};


export type MutationUnapproveMilestoneArgs = {
  input: MilestoneStatusInput;
};


export type MutationUnapproveWeldArgs = {
  input: MilestoneStatusInput;
};


export type MutationUnclaimMilestoneArgs = {
  input: MilestoneStatusInput;
};


export type MutationUnclaimWeldArgs = {
  input: MilestoneStatusInput;
};


export type MutationUnpinCostCodesArgs = {
  input: UnpinCostCodesInput;
};


export type MutationUnplanArgs = {
  input: UnplanInput;
};


export type MutationUpdateBlockArgs = {
  input: UpdateBlockInput;
};


export type MutationUpdateBlockStatusArgs = {
  input?: InputMaybe<UpdateBlockStatusInput>;
};


export type MutationUpdateCaddyArgs = {
  input: UpdateCaddyInput;
};


export type MutationUpdateCommodityArgs = {
  input: UpdateCommodityInput;
};


export type MutationUpdateCommodityLocationDescriptionArgs = {
  input: UpdateCommodityLocationDescriptionInput;
};


export type MutationUpdateCommodityProgressArgs = {
  input: UpdateCommodityProgressInput;
};


export type MutationUpdateDataflowEntityMappingsArgs = {
  input: Array<UpdateDataflowEntityMappingInput>;
};


export type MutationUpdateDefaultPermissionArgs = {
  input: UpdateDefaultPermissionInput;
};


export type MutationUpdateModulesArgs = {
  input: Array<InputMaybe<UpdateModuleInput>>;
};


export type MutationUpdatePermissionsArgs = {
  inputs: Array<UpdatePermissionInput>;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateProjectCommodityTypeArgs = {
  input: UpdateProjectCommodityTypeInput;
};


export type MutationUpdateProjectMilestoneTypesArgs = {
  input: Array<UpdateProjectMilestoneTypeInput>;
};


export type MutationUpdateProjectPermissionsArgs = {
  inputs: Array<UpdateProjectPermissionInput>;
};


export type MutationUpdateProjectReportArgs = {
  input: UpdateProjectReportInput;
};


export type MutationUpdateRodRequestArgs = {
  input: UpdateRodRequestInput;
};


export type MutationUpdateRodRoomArgs = {
  input: UpdateRodRoomInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserStatusArgs = {
  input: UpdateUserStatusInput;
};


export type MutationUpdateWorkPackageDisciplinesArgs = {
  input: Array<InputMaybe<UpdateWorkPackageDisciplineInput>>;
};


export type MutationUpdateWorkPackageScheduleArgs = {
  input: UpdateWorkPackageScheduleInput;
};

export enum MwrStatus {
  CREW_ASSIGNED = 'CREW_ASSIGNED',
  IN_PICKING = 'IN_PICKING',
  ISSUED = 'ISSUED',
  LOADED = 'LOADED'
}

export type NotificationUpdatedPayload = {
  id: Scalars['ID']['output'];
};

export type Owner = {
  assignedCrewMembers: CrewMemberAssignment;
  totalQuantity: QuantitySummary;
};

export type OwnerDetails = {
  owners: Array<Owner>;
  totalQuantity: QuantitySummary;
};

export enum OwnershipLevel {
  ALL = 'ALL',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export enum OwnershipType {
  /** TODO: fixture only */
  OTHER = 'OTHER',
  PRIMARY = 'PRIMARY',
  /** TODO: fixture only */
  SECONDARY = 'SECONDARY'
}

export type PagingInput = {
  cursor: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};

export type PagingListInput = {
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

/** Input for row number based pagination */
export type PagingRowNumberInput = {
  limit: Scalars['Int']['input'];
  rowNumber: Scalars['Int']['input'];
};

export type PendingApprovalInput = {
  crewMemberId: Scalars['ID']['input'];
  /** Array of Project commodity type ids */
  filterByCommodityTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Array of milestone type ids */
  filterByMilestoneTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter By In Plan & Out Of Plan Milestones */
  filterByPlanStatus?: InputMaybe<Array<InputMaybe<WeeklyWorkListFilterByPlanStatus>>>;
  ownershipLevel: OwnershipLevel;
  personaType: PersonaType;
  /** Text search by workpackage/tag or cost code */
  searchByField?: InputMaybe<WeeklyWorkListSearchBy>;
  /** Search text value */
  searchValue?: InputMaybe<Scalars['String']['input']>;
  /** Leave empty when data for all work packages are needed */
  workPackageIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PendingApprovalSummary = {
  /** Total hours that are approved in current week */
  approvedHours: Scalars['Int']['output'];
  /** Total quantity that are approved in current week */
  approvedQuantity: Quantity;
  /** Total hours claimed so far that are not approved yet */
  pendingApprovalHours: Scalars['Int']['output'];
  /** Total quntity claimed so far that are not approved yet */
  pendingApprovalQuantity: Quantity;
};

export type PermissionScope = {
  permission: AuthPermission;
  scope: AuthScope;
};

export type PersonaLobRoleName = {
  /** Id by project */
  id: Scalars['ID']['output'];
  /** Lob Role names associated to the persona */
  lobRoleNames: Array<Scalars['String']['output']>;
  /** Persona type */
  persona: PersonaType;
};

export enum PersonaType {
  CRAFT = 'CRAFT',
  FIELD_ENGINEER = 'FIELD_ENGINEER',
  FIELD_WELD_ENGINEER = 'FIELD_WELD_ENGINEER',
  FOREMAN = 'FOREMAN',
  GENERAL_FOREMAN = 'GENERAL_FOREMAN',
  NONE = 'NONE',
  NON_INTERACTIVE_ACCOUNT = 'NON_INTERACTIVE_ACCOUNT',
  PROJECT_ADMIN = 'PROJECT_ADMIN',
  ROD_ROOM_ATTENDANT = 'ROD_ROOM_ATTENDANT',
  SUPERINTENDENT = 'SUPERINTENDENT',
  SUPER_ADMIN = 'SUPER_ADMIN',
  SUPER_USER = 'SUPER_USER'
}

export enum PinCostCodesError {
  COST_CODE_ALREADY_PINNED = 'COST_CODE_ALREADY_PINNED',
  INVALID_COST_CODE = 'INVALID_COST_CODE',
  INVALID_WORK_PACKAGE_ID = 'INVALID_WORK_PACKAGE_ID',
  PIN_COST_CODES_ERRORED = 'PIN_COST_CODES_ERRORED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

/**
 * Not implemented yet. Cost code pinning aka adding a cost code requires a cost code id.
 * That cost code may be related to a commodity in a work package, in which case workPackageId property
 * is used. If the cost code is a Non WP scoped cost code then the workPackageId is not needed.
 * At a time either WP scoped cost codes can be added or Non WP scoped cost codes can be added. Both cannot
 * be added together. Ref Add Cost Code screens.
 */
export type PinCostCodesInput = {
  /** Cost code ids that are unrelated to a WP */
  costCodesIds: Array<Scalars['ID']['input']>;
  /** Which crew's timesheet we are adding cost codes to */
  crewId: Scalars['String']['input'];
  /** Which work package user selected to add cost codes from */
  workPackageId?: InputMaybe<Scalars['ID']['input']>;
};

/** Cost codes that are added are automatically assumed to be pinned */
export type PinCostCodesPayload = {
  costCodes?: Maybe<PinnedCostCodes>;
  error?: Maybe<PinCostCodesError>;
};

export type PinnedCostCodeCollection = {
  /** Non-Work Package scoped cost codes wrapper objects */
  timesheetCostCodes: Array<TimesheetCostCode>;
  /** Work Package scoped cost codes wrapper objects */
  timesheetWorkPackages: Array<TimesheetWorkPackage>;
};

export type PinnedCostCodes = {
  /** Cost codes just added */
  timesheetCostCodes: Array<TimesheetCostCode>;
  /** Work Package if work pakcage related cost codes were saved */
  workPackage?: Maybe<WorkPackage>;
  workPackageId?: Maybe<Scalars['String']['output']>;
};

export type PinnedCostCodesByCrewInput = {
  /** Crew Id of the foreman whose cost codes we want to see! */
  crewId: Scalars['String']['input'];
};

export type PipeCleanedStatus = {
  id: Scalars['ID']['output'];
  pipeCleanInspectionBy?: Maybe<CrewMember>;
  pipeCleanInspectionDate?: Maybe<Scalars['Datetime']['output']>;
};

export type PlanningAiCompletedPayload = {
  count?: Maybe<Scalars['Int']['output']>;
  foremanId: Scalars['ID']['output'];
  planningAiRequestId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  statusMessage?: Maybe<Scalars['String']['output']>;
  statusMessageData?: Maybe<Scalars['JSON']['output']>;
};

export type PlanningAssignmentFilterBy = {
  /** CrewMemberId of the selected persona */
  crewMemberId?: InputMaybe<Scalars['ID']['input']>;
  /** Selected Persona type */
  persona: PersonaType;
};

export type PlanningBacklogMilestonesInput = {
  /** CrewMemberId of the selected foreman */
  foremanId?: InputMaybe<Scalars['ID']['input']>;
  /** Planning AI Request ID */
  planningAiRequestId?: InputMaybe<Scalars['ID']['input']>;
  workPackageIds: Array<Scalars['ID']['input']>;
};

export type PlanningCrewMemberInput = {
  /** CrewMemberId of the selected persona */
  crewMemberId: Scalars['ID']['input'];
  /** Selected Persona type */
  persona: PersonaType;
};

export enum PlanningDisciplineType {
  ELECTRICAL = 'ELECTRICAL',
  PIPING = 'PIPING'
}

export type PlanningError = {
  commodityMilestoneIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Impacted milestones */
  commodityMilestones?: Maybe<Array<CommodityMilestone>>;
  errorCode: PlanningErrorCode;
  id: Scalars['ID']['output'];
};

export enum PlanningErrorCode {
  CANCEL_AI_PLANNING_ERRORED = 'CANCEL_AI_PLANNING_ERRORED',
  CREW_CAPACITY_ALREADY_PLANNED = 'CREW_CAPACITY_ALREADY_PLANNED',
  CREW_CAPACITY_NOT_FOUND = 'CREW_CAPACITY_NOT_FOUND',
  DELETE_PLAN_ERRORED = 'DELETE_PLAN_ERRORED',
  INVALID_PLANNING_WEEK = 'INVALID_PLANNING_WEEK',
  MILESTONES_ALREADY_PLANNED = 'MILESTONES_ALREADY_PLANNED',
  MILESTONES_NOT_PLANNED = 'MILESTONES_NOT_PLANNED',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_CLAIMED = 'MILESTONE_IS_CLAIMED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NO_MILESTONES_FOUND = 'NO_MILESTONES_FOUND',
  NO_MILESTONES_PROVIDED = 'NO_MILESTONES_PROVIDED',
  NO_WORKPACKAGES_PROVIDED = 'NO_WORKPACKAGES_PROVIDED',
  NO_WORKPACKAGES_SCHEDULED = 'NO_WORKPACKAGES_SCHEDULED',
  PENDING_REQUEST_EXISTS = 'PENDING_REQUEST_EXISTS',
  PLANNING_AI_REQUEST_ALREADY_CANCELLED = 'PLANNING_AI_REQUEST_ALREADY_CANCELLED',
  PLANNING_AI_REQUEST_NOT_FOUND = 'PLANNING_AI_REQUEST_NOT_FOUND',
  PLANNING_API_ERROR = 'PLANNING_API_ERROR',
  PLANNING_CONFIG_NOT_FOUND = 'PLANNING_CONFIG_NOT_FOUND',
  PLANNING_WEEK_OUT_OF_WORKPACKAGE_SCHEDULE = 'PLANNING_WEEK_OUT_OF_WORKPACKAGE_SCHEDULE',
  PLAN_ALREADY_SAVED = 'PLAN_ALREADY_SAVED',
  PLAN_DATA_NOT_FOUND = 'PLAN_DATA_NOT_FOUND',
  PLAN_IS_NOT_GENERATED = 'PLAN_IS_NOT_GENERATED',
  PLAN_WITH_AI_ERRORED = 'PLAN_WITH_AI_ERRORED',
  SAVE_AI_PLAN_ERRORED = 'SAVE_AI_PLAN_ERRORED',
  SAVE_PLAN_ERRORED = 'SAVE_PLAN_ERRORED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  TRANSFER_PLAN_ERRORED = 'TRANSFER_PLAN_ERRORED',
  UNPLAN_ERRORED = 'UNPLAN_ERRORED'
}

export type PlanningFilterInput = {
  /** CrewMemberId of the selected persona */
  crewMemberId?: InputMaybe<Scalars['ID']['input']>;
  /** Number of next weeks to fetch planned data */
  numNextWeeks?: InputMaybe<Scalars['Int']['input']>;
  /** Number of Previous weeks to fetch planned data */
  numPreviousWeeks?: InputMaybe<Scalars['Int']['input']>;
  /** Selected Persona type */
  persona?: InputMaybe<PersonaType>;
  /** Planning AI Request ID */
  planningAiRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlanningPayload = {
  commodityMilestoneIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Impacted milestones */
  commodityMilestones?: Maybe<Array<CommodityMilestone>>;
  error?: Maybe<Array<PlanningError>>;
  expiredMilestoneCount: CrewMemberExpiredMilestoneStats;
  id: Scalars['ID']['output'];
  planningStats?: Maybe<Array<PlanningStatsByCrewMember>>;
};

export type PlanningStatsByCrewMember = {
  crewMember: CrewMember;
  crewMemberId: Scalars['ID']['output'];
  planningWeekStats?: Maybe<Array<PlanningWeekStats>>;
};

export type PlanningWeek = {
  commodityMilestoneIds: Array<Scalars['ID']['output']>;
  /**
   * TODO: Delete this from schema
   * @deprecated Field is deprecated!
   */
  crewMemberStats?: Maybe<Array<CrewMemberStats>>;
  /** The end date of this planning week */
  endDate: Scalars['Date']['output'];
  /** Internal ID for Planning Week */
  id: Scalars['ID']['output'];
  /** Milestones that are going to be addressed during this week. This could be null if nothing is planned for the week. */
  milestones: Array<CommodityMilestone>;
  /** The starting date of this planning week */
  startDate: Scalars['Date']['output'];
  /** Week number of year */
  weekNumber: Scalars['Int']['output'];
  /** The Calendar Year */
  year: Scalars['Int']['output'];
};


export type PlanningWeekMilestonesArgs = {
  input?: InputMaybe<PlanningFilterInput>;
};

export type PlanningWeekSavedPayload = {
  foremanId: Scalars['ID']['output'];
  milestoneCount: Scalars['Int']['output'];
};

export type PlanningWeekStats = {
  /** claimed milestone stats for the planning week. */
  claimedMilestoneStats: MilestoneStats;
  /** committed milestone stats for the planning week. */
  committedMilestoneStats: MilestoneStats;
  /** Total crew hours for the persona */
  crewCapacityHours?: Maybe<Scalars['Float']['output']>;
  /** Crew Member */
  crewMember?: Maybe<CrewMember>;
  /** CrewMember Id */
  crewMemberId?: Maybe<Scalars['ID']['output']>;
  /** The end date of this planning week */
  endDate: Scalars['Date']['output'];
  /** Internal ID for Planning Week */
  id: Scalars['ID']['output'];
  /** planned milestone stats for the planning week. */
  plannedMilestoneStats: MilestoneStats;
  /** The starting date of this planning week */
  startDate: Scalars['Date']['output'];
  /** target  stats for the planning week. */
  target?: Maybe<MilestoneStats>;
  /** Week number of year */
  weekNumber: Scalars['Int']['output'];
  /** The Calendar Year */
  year: Scalars['Int']['output'];
};

export type PlanningWithAiRequest = {
  aiPlanReceivedAt?: Maybe<Scalars['Date']['output']>;
  aiPlanRequestId?: Maybe<Scalars['ID']['output']>;
  aiPlanRequestedAt: Scalars['Date']['output'];
  aiPlanRequestedBy: Scalars['ID']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  foremanId: Scalars['ID']['output'];
  generalForemanId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  statusMessage?: Maybe<Scalars['String']['output']>;
  statusMessageData?: Maybe<Scalars['JSON']['output']>;
  superintendentId: Scalars['ID']['output'];
};

export enum ProgressRodRequestWeldError {
  INVALID_INPUT_DATA = 'INVALID_INPUT_DATA',
  INVALID_ROD_REQUEST_ID = 'INVALID_ROD_REQUEST_ID',
  INVALID_ROD_REQUEST_WELD_STATUS = 'INVALID_ROD_REQUEST_WELD_STATUS',
  INVALID_WELDER_ID = 'INVALID_WELDER_ID',
  INVALID_WELD_ID = 'INVALID_WELD_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  PROGRESS_ROD_REQUEST_WELD_ERRORED = 'PROGRESS_ROD_REQUEST_WELD_ERRORED'
}

export enum ProgressRodRequestWeldErrorCode {
  INVALID_CREATED_BY = 'INVALID_CREATED_BY',
  INVALID_INPUT_DATA = 'INVALID_INPUT_DATA',
  INVALID_PICKUP_TIME = 'INVALID_PICKUP_TIME',
  INVALID_ROD_REQUEST_ID = 'INVALID_ROD_REQUEST_ID',
  INVALID_ROD_REQUEST_WELD_STATUS = 'INVALID_ROD_REQUEST_WELD_STATUS',
  INVALID_WELDER_ID = 'INVALID_WELDER_ID',
  INVALID_WELD_ID = 'INVALID_WELD_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  PROGRESS_ROD_REQUEST_WELD_ERRORED = 'PROGRESS_ROD_REQUEST_WELD_ERRORED',
  ROD_REQUEST_ALREADY_CLOSED_DELETED = 'ROD_REQUEST_ALREADY_CLOSED_DELETED'
}

export type ProgressRodRequestWeldErrors = {
  errorCode: ProgressRodRequestWeldErrorCode;
  rodRequest?: Maybe<RodRequest>;
};

export type ProgressRodRequestWeldInput = {
  status: RodRequestWeldStatus;
  weldId: Scalars['ID']['input'];
};

export type ProgressRodRequestWeldsInput = {
  /** If there is no weld progress then this should be true and progressRodRequestWeldInput will be empty */
  didNotWeld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weld progress data is passed here */
  progressRodRequestWeldInput?: InputMaybe<Array<InputMaybe<ProgressRodRequestWeldInput>>>;
  rodRequestId: Scalars['ID']['input'];
};

export type ProgressRodRequestWeldsPayload = {
  error?: Maybe<Array<ProgressRodRequestWeldErrors>>;
  rodRequest?: Maybe<Array<RodRequest>>;
};

export type Project = {
  /**
   * allow direct claim approval
   * @deprecated This query is deprecated, use ProjectConfig.allowApprovalByNotification instead!
   */
  allowApprovalByNotification: Scalars['Boolean']['output'];
  /**
   * App data format of the project
   * @deprecated This query is deprecated, use ProjectConfig.appDataFormats instead!
   */
  appDataFormats: Array<AppDataFormat>;
  /** Application support information */
  applicationSupportInfo?: Maybe<Scalars['String']['output']>;
  /** Context identifier of the project */
  contextId: Scalars['String']['output'];
  /** Project country */
  country: Country;
  /**
   * Current Week of the project
   * @deprecated This query is deprecated, use ProjectConfig.currentWeek instead!
   */
  currentWeek: Scalars['Int']['output'];
  /** Project gbu */
  gbu: Gbu;
  id: Scalars['ID']['output'];
  /** Project job number */
  jobNumber: Scalars['String']['output'];
  /** Language of the project */
  language: Language;
  /** Project location */
  location: Scalars['String']['output'];
  /** Logo attachment */
  logoAttachment?: Maybe<Attachment>;
  /** Project name */
  name: Scalars['String']['output'];
  /** Project Configuration */
  projectConfiguration: ProjectConfig;
  /**
   * Support users of the proejct
   * @deprecated This query is deprecated, use ProjectConfig.projectSupportUsers instead!
   */
  projectSupportUsers: Array<ProjectSupportUser>;
  /**
   * Timezone of project
   * @deprecated This query is deprecated, use ProjectConfig.projectTimeZone instead!
   */
  projectTimeZone: AppTimeZone;
  /** Project state */
  state: State;
  /** Project sub job number */
  subJobNumber: Scalars['String']['output'];
  /**
   * Time zone of the project
   * @deprecated This field is deprecated, use projectTimeZone instead!
   */
  timeZone: Scalars['String']['output'];
  /**
   * Total Weeks
   * @deprecated This query is deprecated, use ProjectConfig.totalWeeks instead!
   */
  totalWeeks: Scalars['Int']['output'];
  uomType: UomType;
  /**
   * Selection for application interface to display hours or quantities
   * @deprecated This query is deprecated, use ProjectConfig.usersQuantityDisplayToggle instead!
   */
  usersQuantityDisplayToggle: Scalars['Boolean']['output'];
  /**
   * Project Current Week End Date
   * @deprecated This query is deprecated, use ProjectConfig.weekEndDate instead!
   */
  weekEndDate: Scalars['Date']['output'];
  /**
   * end day of the planning week
   * @deprecated This query is deprecated, use ProjectConfig.weekEndDay instead!
   */
  weekEndDay: Scalars['Int']['output'];
  /**
   * Week end time
   * @deprecated This query is deprecated, use ProjectConfig.weekEndTime instead!
   */
  weekEndTime: Scalars['Time']['output'];
  /**
   * Project Current Week Start Date
   * @deprecated This query is deprecated, use ProjectConfig.weekStartDate instead!
   */
  weekStartDate: Scalars['Date']['output'];
  /**
   * Start Day of the week
   * @deprecated This query is deprecated, use ProjectConfig.weekStartDay instead!
   */
  weekStartDay: Scalars['Int']['output'];
  /**
   * Week start time
   * @deprecated This query is deprecated, use ProjectConfig.weekStartTime instead!
   */
  weekStartTime: Scalars['Time']['output'];
};

export type ProjectCommodityTypeItr = {
  id: Scalars['ID']['output'];
  projectCommodityType: CommodityType;
  projectMilestoneType?: Maybe<ProjectMilestoneType>;
};

/**
 * Configuration values per tenant.
 *   - Project serves as tenant
 */
export type ProjectConfig = {
  /** allow direct claim approval */
  allowApprovalByNotification: Scalars['Boolean']['output'];
  /** App data format of the project */
  appDataFormats: Array<AppDataFormat>;
  /** List all unique milestone types in the project */
  availableMilestoneTypes: Array<MilestoneType>;
  /** Book Label CSV */
  bookLabels?: Maybe<Scalars['String']['output']>;
  commoditySections: Array<CommoditySection>;
  /** Composite Unit Rate */
  compositeUnitRate: UnitRate;
  /** List all crew types */
  crewTypes: Array<CrewType>;
  /**
   * Current Week of the project
   * @deprecated This field is deprecated, use projectConfiguration.projectWeeks.weekNumber instead!
   */
  currentWeek: Scalars['Int']['output'];
  /** Facility Unit Rates */
  facilityUnitRates?: Maybe<Array<FacilityUnitRate>>;
  /** List of all features available in this project */
  features: Array<Feature>;
  /** Center of the project */
  geoLocation?: Maybe<GeoLocation>;
  id: Scalars['ID']['output'];
  /** Indirect Tax */
  indirectTax: Scalars['Float']['output'];
  /** Enable viewing Book Builder books against Work Packages */
  isBookBuilderEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** ISO Document Prefix value to append to all the Aconex document searches. */
  isoDocumentPrefix: Scalars['String']['output'];
  /** ISO document prefix list */
  isoDocumentPrefixList?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to enable or disable DSCS integration. */
  materialsMgmtEnabled: Scalars['Boolean']['output'];
  /** Default value for  max number of attachment associated with each block */
  maxBlocksAttachment: Scalars['Int']['output'];
  /** List of all modules available in this project */
  modules: Array<AppModule>;
  /** Default value for database page size */
  pagingDefaultPageSize: Scalars['Int']['output'];
  /** Max value for database pagesize */
  pagingMaxPageSize: Scalars['Int']['output'];
  /** Lob Employee Role Names */
  personaLobRoleNames: Array<PersonaLobRoleName>;
  /** Project Adjustment Factor */
  projectAdjustmentFactor: Scalars['Float']['output'];
  /** List all commodity types in this project */
  projectCommodityTypes: Array<CommodityType>;
  /** List inspection test record */
  projectItrConfig: Array<ProjectItrConfig>;
  /** Project geolocation */
  projectLocation?: Maybe<ProjectLocation>;
  /** Support users of the proejct */
  projectSupportUsers: Array<ProjectSupportUser>;
  /** Timezone of project */
  projectTimeZone: AppTimeZone;
  /** Planning Weeks */
  projectWeeks: Array<ProjectWeek>;
  /**
   * Project time zone
   * @deprecated This field is deprecated, use projectTimeZone instead!
   */
  timeZone: Scalars['String']['output'];
  /** Timesheet applicable for this project? */
  timesheetEnabled: Scalars['Boolean']['output'];
  /** Total Weeks */
  totalWeeks: Scalars['Int']['output'];
  /** Selection for application interface to display hours or quantities */
  usersQuantityDisplayToggle: Scalars['Boolean']['output'];
  /**
   * Project Current Week End Date
   * @deprecated This field is deprecated, use projectConfiguration.projectWeeks.endDate instead!
   */
  weekEndDate: Scalars['Date']['output'];
  /** end day of the planning week */
  weekEndDay: Scalars['Int']['output'];
  /** Week end time */
  weekEndTime: Scalars['Time']['output'];
  /**
   * Project Current Week Start Date
   * @deprecated This field is deprecated, use projectConfiguration.projectWeeks.startDate instead!
   */
  weekStartDate: Scalars['Date']['output'];
  /** start day of the planning week */
  weekStartDay: Scalars['Int']['output'];
  /** Week start time */
  weekStartTime: Scalars['Time']['output'];
  /** Weekly Hours */
  weeklyHours: Scalars['Float']['output'];
  /** Weekly Working Days */
  weeklyWorkDays: Scalars['Int']['output'];
  /** Weld Program config */
  weldConfig: WeldProgramConfig;
  /** List all work packages disciplines with active status */
  workPackageDisciplines: Array<WorkPackageDiscipline>;
};

export type ProjectDataflowAppRegistry = {
  apiBaseUrl: Scalars['String']['output'];
  dataflowAppCode: Scalars['String']['output'];
  dataflowMode: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ProjectItrConfig = {
  id: Scalars['ID']['output'];
  itrMilestoneAction?: Maybe<ItrMilestoneAction>;
  itrType: ItrType;
  name: Scalars['String']['output'];
  projectCommodityTypeItrs: Array<ProjectCommodityTypeItr>;
};

export type ProjectLocation = {
  /** Elevation of the item in feet above sea level. */
  elevation?: Maybe<Scalars['Float']['output']>;
  maxLatitude: Scalars['Float']['output'];
  maxLongitude: Scalars['Float']['output'];
  minLatitude: Scalars['Float']['output'];
  minLongitude: Scalars['Float']['output'];
};

export type ProjectLocationInput = {
  maxLatitude: Scalars['Float']['input'];
  maxLongitude: Scalars['Float']['input'];
  minLatitude: Scalars['Float']['input'];
  minLongitude: Scalars['Float']['input'];
};

export type ProjectMilestoneType = {
  hasWeldActivity: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * A flag that indicates if Inspection Test Record aka Pipe cleanliness verification is required for this milestone.
   * @deprecated This field is deprecated
   */
  itrRequired: Scalars['Boolean']['output'];
  lobMilestoneTypeId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  projectItrConfig: Array<ProjectItrConfig>;
};

export type ProjectMilestoneTypeRejectionReason = {
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  subReasons: Array<ProjectMilestoneTypeRejectionSubReason>;
};

export type ProjectMilestoneTypeRejectionReasonsInput = {
  /** Project Milestone Type ID */
  projectMilestoneTypeId: Scalars['ID']['input'];
};

export type ProjectMilestoneTypeRejectionSubReason = {
  comments?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type ProjectReport = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  powerbiUrl: Scalars['String']['output'];
};

export type ProjectRolePermission = {
  id: Scalars['ID']['output'];
  permissionScopeId: Scalars['String']['output'];
  project: Project;
  roleId: Scalars['String']['output'];
  rolePermissionScopeId: Scalars['String']['output'];
};

export type ProjectSupportUser = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  project: Project;
  user: User;
};

export type ProjectSupportUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type ProjectWeek = {
  /** The end date of this planning week */
  endDate: Scalars['Date']['output'];
  /** Internal ID for Planning Week */
  id: Scalars['ID']['output'];
  /** True value represents current week */
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  /** The starting date of this planning week */
  startDate: Scalars['Date']['output'];
  /** Week number of year */
  weekNumber: Scalars['Int']['output'];
  /** The Calendar Year */
  year: Scalars['Int']['output'];
};

export type Quantity = {
  quantity: Scalars['Float']['output'];
  unitOfMeasure: UnitOfMeasure;
};

export type QuantityDetails = {
  primaryOwnersDetail: OwnerDetails;
  secondaryDayShiftOwnersDetail: OwnerDetails;
  secondaryNightShiftOwnersDetail: OwnerDetails;
  totalQuantity: QuantitySummary;
  twQuantitySummary: QuantitySummary;
};

export type QuantitySummary = {
  approvedHours: Scalars['Float']['output'];
  approvedQuantity: Quantity;
  claimedHours: Scalars['Float']['output'];
  claimedQuantity: Quantity;
  plannedHours: Scalars['Float']['output'];
  plannedQuantity: Quantity;
};

export type Query = {
  appDataFormats: Array<AppDataFormat>;
  /** Get all available block types */
  availableBlockTypes: Array<BlockType>;
  /** Milestones which can be planned (Unplanned and Expired) for the workpackage */
  backlogMilestones: BacklogMilestones;
  blockById?: Maybe<Block>;
  blockStats: BlockStats;
  blocks: BlockList;
  blocksByIds: Array<Block>;
  /** Caddy list */
  caddies: CaddyList;
  commodities: CommodityList;
  commoditiesByIds: Array<CommodityWrapper>;
  commodity?: Maybe<CommodityWrapper>;
  /** This query uses filterByDate, crewMemberId for all the stats, except for Claimed & Unassigned (FWE) which uses commodityFilterByTerm CREW_MEMBER_ID filter for filtering claimed */
  commodityStats: CommodityStatsPayload;
  commodityStatsSummary: CommodityStatsSummary;
  /** Get list of cost codes */
  costCodes?: Maybe<CostCodeList>;
  countries: Array<Country>;
  /** Get a list of crew change requests */
  crewChangeRequests?: Maybe<CrewChangeRequestList>;
  /** Get crew change request by ids */
  crewChangeRequestsByIds: Array<Maybe<CrewChangeRequest>>;
  /** Get crew change stats */
  crewChangeStats?: Maybe<CrewChangeStats>;
  crewHierarchy?: Maybe<CrewMemberList>;
  /** Get a list of crew members */
  crewMembers?: Maybe<CrewMemberList>;
  crewProgressStats?: Maybe<CrewProgressStatsList>;
  /**
   * List all crew types
   * @deprecated This query is deprecated, use ProjectConfig.crewTypes instead!
   */
  crewTypes: Array<CrewType>;
  /**
   * Get a list of crew members
   * @deprecated This query is deprecated
   */
  crews?: Maybe<CrewList>;
  dataflowAppCodesByProjectId?: Maybe<Array<ProjectDataflowAppRegistry>>;
  dataflowEntityMapping: DataflowEntityMappingPayload;
  dataflowEntityRegistries: Array<DataflowEntityRegistry>;
  dataflowEntityRegistriesByProjectId: Array<DataflowEntityRegistry>;
  /**
   * Query for list of unique default permissions.
   * @deprecated This query is deprecated
   */
  defaultPermissions: Array<DefaultRolePermission>;
  drawings: DrawingList;
  /** Earnable hours for CrewMember(s) */
  earnableHours: EarnableHours;
  eventNotificationStats?: Maybe<Array<EventNotificationStat>>;
  eventNotifications: EventNotificationList;
  eventNotificationsByIds: Array<EventNotification>;
  /** Expired milestone count */
  expiredMilestoneCount?: Maybe<CrewMemberExpiredMilestoneStats>;
  /** Expired milestones for the persona eg. foreman */
  expiredMilestones: ExpiredMilestones;
  /** Import Commodities agnostic to Work Packages */
  importCommodities: ImportCommoditiesPayload;
  /** Get Import schedules */
  importSchedules: Array<ImportSchedule>;
  /** Import Crew Members */
  importUsers: ImportUsersPayload;
  /** Import Weld Entities */
  importWeldConfig: ImportWeldConfigPayload;
  /** Import Work Packages */
  importWorkPackages: ImportWorkPackagesPayload;
  languages: Array<Language>;
  loadAllEntities: EntityList;
  loadAssociatedCrewMembers?: Maybe<AssociatedCrewMembers>;
  loadCompanies?: Maybe<Array<Company>>;
  loadWeldProcedures?: Maybe<WeldProcedureList>;
  /** Get a specific Lob employee */
  lobEmployeeById: LobEmployee;
  /** Get a list of Lob employees */
  lobEmployees: LobEmployeeList;
  mapMarkers?: Maybe<MapMarkersPayload>;
  /**
   * List of all modules available in this project
   * @deprecated This query is deprecated, use ProjectConfig.modules instead!
   */
  modules: Array<AppModule>;
  pendingApprovalSummary: PendingApprovalSummary;
  /** Give me a bunch of cost codes that have I added and therefore pinned in my timesheets in the past. */
  pinnedCostCodesByCrew: PinnedCostCodeCollection;
  /** Get all planned milestones for the persona (eg.foreman) */
  plannedMilestones: Array<PlanningWeek>;
  /** Get all planned milestones for the persona (eg.foreman) */
  planningWeekStats: Array<PlanningWeekStats>;
  /** @deprecated This query is deprecated, use ProjectConfig.projectCommodityTypes instead! */
  projectCommodityTypes: Array<CommodityType>;
  projectConfigById?: Maybe<ProjectConfig>;
  projectMilestoneTypeRejectionReasons: Array<ProjectMilestoneTypeRejectionReason>;
  /**
   * Query for list of unique permissions used in the project.
   * @deprecated This query is deprecated
   */
  projectPermissions: Array<ProjectRolePermission>;
  projects: Array<Project>;
  /** Get projects by projectIds */
  projectsByIds: Array<Maybe<Project>>;
  reportByIds: Array<Maybe<ProjectReport>>;
  reports: ReportList;
  /** Rod Filler Material By ID */
  rodFillerMaterialById?: Maybe<RodFillerMaterial>;
  /** Rod Filler materials */
  rodFillerMaterials: RodFillerMaterialList;
  /** Search caddy by rod room, caddy or welders */
  rodRequestCaddies: RodRequestCaddyList;
  /** Rod Request By Crew Member Stats (Ref to Bulk close screen in rod room screen) */
  rodRequestStatsByCrewMember: RodRequestStatsList;
  /** Rod Requests */
  rodRequests: RodRequestList;
  /** Rod Requests by Ids */
  rodRequestsByIds: Array<Maybe<RodRequest>>;
  /** Rod Room Stats */
  rodRoomStatsSummary: RodRoomStats;
  /** List of Rod Rooms */
  rodRooms?: Maybe<Array<RodRoom>>;
  /** List of all roles available in this project */
  roles: Array<AuthRole>;
  /** List of all roles by roleIds */
  rolesByIds: Array<AuthRole>;
  /** Get shift by shift id */
  shiftById?: Maybe<Shift>;
  states: Array<State>;
  /** Target Hours calculation */
  targetHoursCalculation: TargetHoursCalculation;
  /** Load all time types for a given project */
  timeTypes: Array<TimeType>;
  timeZones: Array<AppTimeZone>;
  /**
   * Query for a  timesheet days for a specific foreman.
   * Every employee belongs to a single crew, including general foreman.
   */
  timesheetByForeman: TimesheetDay;
  /** Give me a list of timesheet comments applicable to my project. */
  timesheetReasons: Array<TimesheetReason>;
  userByAuth?: Maybe<User>;
  /** List of all users based on filter criteria */
  users?: Maybe<UserList>;
  /** List of all users by Ids */
  usersByIds: Array<Maybe<User>>;
  void?: Maybe<Scalars['Boolean']['output']>;
  /** Weekly LookAheadStats for CrewMember(s) */
  weeklyLookAheadStatsByPersona: Array<WeeklyLookAheadStatsByPersona>;
  /** Claimed Progress hours for CrewMember */
  weeklyMilestoneProgress: WeeklyMilestoneProgress;
  weeklyWorkList: WeeklyWorkList;
  /** weeklyWorkListBulk query is only for CSV download */
  weeklyWorkListBulk: WeeklyWorkListBulk;
  weeklyWorkStats?: Maybe<WeeklyWorkStats>;
  weeklyWorkSummary?: Maybe<WeeklyWorkSummary>;
  /**
   * Provides a list of work packages disciplines from the configuration
   * @deprecated This query is deprecated, use ProjectConfig.workPackageDisciplines instead!
   */
  workPackageDisciplines: Array<WorkPackageDiscipline>;
  workPackageStats?: Maybe<WorkPackageStats>;
  workPackages?: Maybe<WorkPackageList>;
  workPackagesByIds: Array<WorkPackage>;
};


export type QueryAppDataFormatsArgs = {
  formatTypeId: AppDataFormatEnum;
};


export type QueryBacklogMilestonesArgs = {
  input?: InputMaybe<PlanningBacklogMilestonesInput>;
};


export type QueryBlockByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBlocksArgs = {
  input?: InputMaybe<BlockFilterInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryBlocksByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCaddiesArgs = {
  input: CaddyFilterInput;
  paging?: InputMaybe<PagingInput>;
};


export type QueryCommoditiesArgs = {
  input?: InputMaybe<CommodityFilterInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryCommoditiesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCommodityArgs = {
  input: CommodityReference;
};


export type QueryCommodityStatsArgs = {
  input: CommodityFilterInput;
};


export type QueryCommodityStatsSummaryArgs = {
  input?: InputMaybe<CommodityFilterInput>;
};


export type QueryCostCodesArgs = {
  input?: InputMaybe<SearchCostCodeInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryCrewChangeRequestsArgs = {
  input?: InputMaybe<SearchCrewChangeRequestInput>;
  paging?: InputMaybe<PagingRowNumberInput>;
};


export type QueryCrewChangeRequestsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCrewChangeStatsArgs = {
  input?: InputMaybe<CrewChangeStatInput>;
};


export type QueryCrewHierarchyArgs = {
  input?: InputMaybe<SearchCrewInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryCrewMembersArgs = {
  input?: InputMaybe<SearchCrewMemberInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryCrewProgressStatsArgs = {
  input: CrewProgressStatsInput;
  paging?: InputMaybe<PagingInput>;
};


export type QueryCrewsArgs = {
  input?: InputMaybe<SearchCrewInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryDataflowAppCodesByProjectIdArgs = {
  input: Scalars['String']['input'];
};


export type QueryDataflowEntityMappingArgs = {
  input: DataflowEntityMappingInput;
};


export type QueryDataflowEntityRegistriesArgs = {
  input?: InputMaybe<DataflowEntityRegistryInput>;
};


export type QueryDataflowEntityRegistriesByProjectIdArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDrawingsArgs = {
  input?: InputMaybe<DrawingInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryEarnableHoursArgs = {
  input: CrewMemberEarnableHoursInput;
};


export type QueryEventNotificationStatsArgs = {
  input: EventNotificationInput;
};


export type QueryEventNotificationsArgs = {
  input: EventNotificationInput;
  paging: PagingInput;
};


export type QueryEventNotificationsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryExpiredMilestoneCountArgs = {
  input?: InputMaybe<PlanningCrewMemberInput>;
};


export type QueryExpiredMilestonesArgs = {
  input?: InputMaybe<PlanningCrewMemberInput>;
};


export type QueryImportCommoditiesArgs = {
  input: ImportCommoditiesInput;
  pagingInput?: InputMaybe<PagingListInput>;
};


export type QueryImportUsersArgs = {
  input?: InputMaybe<ImportUsersInput>;
};


export type QueryImportWorkPackagesArgs = {
  input: ImportWorkPackageInput;
  pagingInput?: InputMaybe<PagingListInput>;
};


export type QueryLoadAssociatedCrewMembersArgs = {
  input?: InputMaybe<AssociatedCrewMembersInput>;
};


export type QueryLoadCompaniesArgs = {
  input?: InputMaybe<CompanyInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryLoadWeldProceduresArgs = {
  input?: InputMaybe<WeldProcedureInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryLobEmployeeByIdArgs = {
  etrackId: Scalars['String']['input'];
};


export type QueryLobEmployeesArgs = {
  paging?: InputMaybe<PagingInput>;
  searchKeyword: Scalars['String']['input'];
};


export type QueryMapMarkersArgs = {
  commodityComplexFilter?: InputMaybe<CommodityComplexFilterInput>;
  types: Array<MarkerType>;
};


export type QueryPendingApprovalSummaryArgs = {
  input: PendingApprovalInput;
};


export type QueryPinnedCostCodesByCrewArgs = {
  input: PinnedCostCodesByCrewInput;
};


export type QueryPlannedMilestonesArgs = {
  input?: InputMaybe<PlanningFilterInput>;
};


export type QueryPlanningWeekStatsArgs = {
  input?: InputMaybe<PlanningFilterInput>;
};


export type QueryProjectConfigByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectMilestoneTypeRejectionReasonsArgs = {
  input: ProjectMilestoneTypeRejectionReasonsInput;
};


export type QueryProjectsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryReportByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryReportsArgs = {
  input?: InputMaybe<ReportInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryRodFillerMaterialByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRodFillerMaterialsArgs = {
  input?: InputMaybe<RodFillerMaterialsInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryRodRequestCaddiesArgs = {
  input: RodRequestCaddyFilterInput;
  paging?: InputMaybe<PagingInput>;
};


export type QueryRodRequestStatsByCrewMemberArgs = {
  input?: InputMaybe<RodRequestStatsByCrewMemberInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryRodRequestsArgs = {
  input?: InputMaybe<RodRequestFilterInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryRodRequestsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryRodRoomStatsSummaryArgs = {
  input: RodRoomStatsInput;
};


export type QueryRolesByIdsArgs = {
  roleIds: Array<Scalars['ID']['input']>;
};


export type QueryShiftByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStatesArgs = {
  countryId: Scalars['String']['input'];
};


export type QueryTargetHoursCalculationArgs = {
  input: TargetHoursCalculationInput;
};


export type QueryTimesheetByForemanArgs = {
  input: TimesheetByForemanInput;
};


export type QueryUsersArgs = {
  input?: InputMaybe<UserFilterInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryUsersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryWeeklyLookAheadStatsByPersonaArgs = {
  input: CrewMemberWeeklyLookAheadStatsInput;
};


export type QueryWeeklyMilestoneProgressArgs = {
  input: WeeklyMilestoneProgressInput;
};


export type QueryWeeklyWorkListArgs = {
  input: WeeklyWorkInput;
  paging?: InputMaybe<PagingRowNumberInput>;
};


export type QueryWeeklyWorkListBulkArgs = {
  input: WeeklyWorkInput;
  paging?: InputMaybe<PagingRowNumberInput>;
};


export type QueryWeeklyWorkStatsArgs = {
  input: WorkPackageStatsInput;
};


export type QueryWeeklyWorkSummaryArgs = {
  input: WeeklyWorkInput;
};


export type QueryWorkPackageStatsArgs = {
  input: WorkPackageStatsInput;
};


export type QueryWorkPackagesArgs = {
  input?: InputMaybe<WorkPackageFilterInput>;
  paging?: InputMaybe<PagingInput>;
};


export type QueryWorkPackagesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum ReassignFitupRequestError {
  FITUP_REQUEST_NOT_FOUND = 'FITUP_REQUEST_NOT_FOUND',
  INVALID_COMMODITY_ID = 'INVALID_COMMODITY_ID',
  INVALID_CREW_MEMBER_ID = 'INVALID_CREW_MEMBER_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  REASSIGN_FITUP_REQUEST_ERRORED = 'REASSIGN_FITUP_REQUEST_ERRORED'
}

export type ReassignFitupRequestInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  commodityId: Scalars['ID']['input'];
  commodityMilestoneStatusId?: InputMaybe<Scalars['ID']['input']>;
  installationCrewMember: FitupRequestCrewMember;
  isWeldingRequired: Scalars['Boolean']['input'];
  itrRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReassignFitupRequestPayload = {
  errorCode?: Maybe<ReassignFitupRequestError>;
  weld?: Maybe<Weld>;
};

/** Available error for reclaimMilestone */
export enum ReclaimMilestoneError {
  EIS_ERROR = 'EIS_ERROR',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_CLAIMED = 'MILESTONE_IS_CLAIMED',
  MILESTONE_NOT_REJECTED = 'MILESTONE_NOT_REJECTED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  RECLAIM_MILESTONE_ERRORED = 'RECLAIM_MILESTONE_ERRORED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type ReclaimMilestoneInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  comments: Scalars['String']['input'];
  commodityMilestoneId: Scalars['ID']['input'];
  itrRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Payload returned on call to reclaimMilestone. */
export type ReclaimMilestonePayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<ReclaimMilestoneError>;
  milestone?: Maybe<CommodityMilestone>;
  workPackage?: Maybe<WorkPackage>;
};

export enum ReclaimWeldError {
  EIS_ERROR = 'EIS_ERROR',
  INVALID_STENCILS = 'INVALID_STENCILS',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_CLAIMED = 'MILESTONE_IS_CLAIMED',
  MILESTONE_NOT_REJECTED = 'MILESTONE_NOT_REJECTED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  RECLAIM_WELD_MILESTONE_ERRORED = 'RECLAIM_WELD_MILESTONE_ERRORED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  STENCILS_NOT_PROVIDED = 'STENCILS_NOT_PROVIDED',
  WELD_PROCEDURE_NOT_FROM_APPLICABLE_LIST = 'WELD_PROCEDURE_NOT_FROM_APPLICABLE_LIST'
}

export type ReclaimWeldInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  comments: Scalars['String']['input'];
  commodityMilestoneId: Scalars['ID']['input'];
  /** The location in latitude and longitude where this was welded. This is not mandatory right now but will be when we do ArcStryker. */
  location?: InputMaybe<CommodityLocationInput>;
  /** An optional comment on where weld is located on the job site. */
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Ids of the welders that participated in the welding. */
  stencilIds: Array<Scalars['ID']['input']>;
  /** Which weld procedure was used for installation. Must match one of the applicable weld procedures of the weld. */
  weldProcedureIds: Array<Scalars['ID']['input']>;
};

export type ReclaimWeldPayload = {
  error?: Maybe<ReclaimWeldError>;
  weld?: Maybe<Weld>;
};

export type RegisterDeviceInput = {
  /** Device registration ID which is generated by the front end. */
  RegistrationId: Scalars['String']['input'];
};

/** Available error for Send Back to Piping */
export enum RejectFitupError {
  EIS_ERROR = 'EIS_ERROR',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MILESTONE_NOT_CLAIMED = 'MILESTONE_NOT_CLAIMED',
  MISSING_COMMENTS = 'MISSING_COMMENTS',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  REJECT_FITUP_MILESTONE_ERRORED = 'REJECT_FITUP_MILESTONE_ERRORED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type RejectFitupInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  commodityMilestoneId: Scalars['ID']['input'];
  otherReasonComments?: InputMaybe<Scalars['String']['input']>;
  otherSubReasonComments?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonTypeId: Scalars['ID']['input'];
  rejectionSubReasonTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Send Back Weld to Piping Action Payload. */
export type RejectFitupPayload = {
  error?: Maybe<RejectFitupError>;
  weld?: Maybe<Weld>;
};

export enum RejectFitupReason {
  ADEQUATE_PROTECTION_ACCESSIBILITY = 'ADEQUATE_PROTECTION_ACCESSIBILITY',
  FITUP_ALIGNMENT_ISSUE = 'FITUP_ALIGNMENT_ISSUE',
  JOINT_CLEANLINESS = 'JOINT_CLEANLINESS',
  JOINT_NOT_READY_FOR_FITUP = 'JOINT_NOT_READY_FOR_FITUP',
  OTHER_REASON = 'OTHER_REASON'
}

export type RejectFitupRequestInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  /** Milestone id will belong to Install milestone= */
  commodityMilestoneId: Scalars['ID']['input'];
  otherReasonComments?: InputMaybe<Scalars['String']['input']>;
  otherSubReasonComments?: InputMaybe<Scalars['String']['input']>;
  /** Project milestone id */
  projectMilestoneTypeId?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonTypeId: Scalars['ID']['input'];
  rejectionSubReasonTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Available error for rejectMilestone */
export enum RejectMilestoneError {
  EIS_ERROR = 'EIS_ERROR',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MILESTONE_NOT_CLAIMED = 'MILESTONE_NOT_CLAIMED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  REJECT_MILESTONE_ERRORED = 'REJECT_MILESTONE_ERRORED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type RejectMilestoneInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  comments: Scalars['String']['input'];
  commodityMilestoneId: Scalars['ID']['input'];
  itrRequired?: InputMaybe<Scalars['Boolean']['input']>;
  rejectionReasonTypeId: Scalars['String']['input'];
};

/** Payload returned on call to rejectMilestone. */
export type RejectMilestonePayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<RejectMilestoneError>;
  milestone?: Maybe<CommodityMilestone>;
  workPackage?: Maybe<WorkPackage>;
};

/** Available error for Send Back to Foreman */
export enum RejectWeldError {
  EIS_ERROR = 'EIS_ERROR',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MILESTONE_NOT_CLAIMED = 'MILESTONE_NOT_CLAIMED',
  MISSING_COMMENTS = 'MISSING_COMMENTS',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  REJECT_WELD_MILESTONE_ERRORED = 'REJECT_WELD_MILESTONE_ERRORED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

/** Send Back Weld to Foreman Input */
export type RejectWeldInput = {
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  commodityMilestoneId: Scalars['ID']['input'];
  otherReasonComments?: InputMaybe<Scalars['String']['input']>;
  otherSubReasonComments?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonTypeId: Scalars['ID']['input'];
  rejectionSubReasonTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Send Back Weld to Foreman Action Payload */
export type RejectWeldPayload = {
  error?: Maybe<RejectWeldError>;
  weld?: Maybe<Weld>;
};

export enum RejectWeldReason {
  INCORRECT_WELD_CLAIMED = 'INCORRECT_WELD_CLAIMED',
  MISSING_INCORRECT_STENCILS = 'MISSING_INCORRECT_STENCILS',
  MISSING_WELD_TAG = 'MISSING_WELD_TAG',
  OTHER_REASON = 'OTHER_REASON',
  WELD_SURFACE_ISSUE = 'WELD_SURFACE_ISSUE',
  WORK_NOT_DONE_INCOMPLETE = 'WORK_NOT_DONE_INCOMPLETE'
}

export enum RejectWeldSubReason {
  ARC_STRIKES = 'ARC_STRIKES',
  INCOMPLETE_PENETRATION = 'INCOMPLETE_PENETRATION',
  OTHER_SUB_REASON = 'OTHER_SUB_REASON',
  SURFACE_CONTOUR = 'SURFACE_CONTOUR',
  WELD_SPATTER = 'WELD_SPATTER'
}

export enum RejectionType {
  FIELD_ENGINEERING_DISCLOSURE = 'FIELD_ENGINEERING_DISCLOSURE',
  IMPROPER_DOCUMENTATION = 'IMPROPER_DOCUMENTATION',
  INCORRECT_MATERIALS = 'INCORRECT_MATERIALS',
  INSTALLATION_NOT_TO_STANDARDS = 'INSTALLATION_NOT_TO_STANDARDS',
  OTHER_REJECTION = 'OTHER_REJECTION',
  WORK_NOT_COMPLETE = 'WORK_NOT_COMPLETE',
  WORK_NOT_RELEASED_YET = 'WORK_NOT_RELEASED_YET'
}

export type ReportInput = {
  activeReports?: InputMaybe<Scalars['Boolean']['input']>;
  searchKeyword: Scalars['String']['input'];
  /** Sort Order */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ReportList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<ProjectReport>;
  total: Scalars['Int']['output'];
};

/** Error while creating a block */
export enum ResolveBlockError {
  COMMENT_REQUIRED = 'COMMENT_REQUIRED',
  COMMENT_TOO_LARGE = 'COMMENT_TOO_LARGE',
  EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT = 'EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_BLOCKED = 'NOT_BLOCKED',
  NOT_FOUND = 'NOT_FOUND',
  RESOLVE_BLOCK_ERRORED = 'RESOLVE_BLOCK_ERRORED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

/** Input details required for updating a block */
export type ResolveBlockInput = {
  /** List of attachment inputs for this block. */
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  /** Comments made about this block. */
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Updated block response payload */
export type ResolveBlockPayload = {
  block?: Maybe<Block>;
  error?: Maybe<ResolveBlockError>;
};

export enum RestoreDefaultPermissionError {
  NOT_FOUND = 'NOT_FOUND'
}

export type RestoreDefaultPermissionPayload = {
  error?: Maybe<RestoreDefaultPermissionError>;
  rolePermissions: Array<AuthRole>;
};

export type ReturnCaddiesError = {
  caddy?: Maybe<RodRequestCaddy>;
  errorCode: ReturnCaddyErrorCode;
};

/** Input details required for issuing a rod */
export type ReturnCaddiesInput = {
  /** Caddy Ids */
  ids: Array<Scalars['ID']['input']>;
  /** Pickup location */
  returnedToRodRoomId: Scalars['ID']['input'];
};

/** Return Caddy response payload */
export type ReturnCaddiesPayload = {
  caddies?: Maybe<Array<RodRequestCaddy>>;
  erroredCaddies?: Maybe<Array<ReturnCaddiesError>>;
};

/** Error code while returning a caddy */
export enum ReturnCaddyErrorCode {
  INVALID_CADDY_ID = 'INVALID_CADDY_ID',
  INVALID_ROD_ROOM_ID = 'INVALID_ROD_ROOM_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  RETURN_CADDIES_MUTATION_ERROR = 'RETURN_CADDIES_MUTATION_ERROR',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type RodDiameter = {
  /** Internal ID for Rod Diamater */
  id: Scalars['ID']['output'];
  /** Label of Rod Diameter */
  label: Scalars['String']['output'];
};

export type RodDiametersFilterInput = {
  /** Filler Material id */
  fillerMaterialId: Scalars['String']['input'];
};

export type RodFillerMaterial = {
  /** Internal ID for Filler material */
  id: Scalars['ID']['output'];
  /** Label of Filler material */
  label: Scalars['String']['output'];
  /** Rod Diameters */
  rodFillerMaterialDetails: Array<RodFillerMaterialDetail>;
  /** Type of filler material */
  type?: Maybe<FillerMaterialType>;
};

export type RodFillerMaterialDetail = {
  /** Rod Diameter */
  diameter: RodDiameter;
  /** Rod filler material diameter ID */
  id: Scalars['ID']['output'];
  /** Rod Heat or Lot number */
  rodHeatLotNumber?: Maybe<Array<Maybe<RodHeatOrLotNumber>>>;
};

export type RodFillerMaterialList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<Maybe<RodFillerMaterial>>;
  total: Scalars['Int']['output'];
};

export type RodFillerMaterialSubscriptionPayload = {
  fillerMaterialIds: Array<Scalars['ID']['output']>;
};

export type RodFillerMaterialsInput = {
  /** WelProcedure ID */
  weldProcedureId: Scalars['ID']['input'];
};

export type RodHeatOrLotNumber = {
  /** Internal ID for Heat or Lot number */
  id: Scalars['ID']['output'];
  /** Label of Heat or Lot number */
  label: Scalars['String']['output'];
};

export type RodHeatOrLotNumbersFilterInput = {
  /** Filler Material id */
  fillerMaterialId: Scalars['String']['input'];
  /** Rod Diameter Id */
  rodDiameterId: Scalars['String']['input'];
};

export type RodRequest = {
  /** Issued Caddies */
  caddies: Array<Maybe<RodRequestCaddy>>;
  /** Rod request comments */
  comments: Array<RodRequestComment>;
  /** Created time of rod request */
  createdAt: Scalars['Datetime']['output'];
  /** Created by user */
  createdBy: CrewMember;
  /** The current status of the Rod Request */
  currentStatusI18n: RodRequestStatusCode;
  /** Filler Material for the request */
  fillerMaterials: Array<RodRequestFillerMaterial>;
  /** Internal ID for Rod Request */
  id: Scalars['ID']['output'];
  /** Pickup time of the request */
  pickUpTime: Scalars['Datetime']['output'];
  /** Rod request number */
  requestNumber: Scalars['String']['output'];
  /** Associated Rod room of the request */
  rodRoom: RodRoom;
  /** Rod Request Stencils */
  stencils: Array<RodRequestStencil>;
  /** Weld Procedure associated to this Rod request */
  weldProcedure: WeldProcedure;
  /** Welds Associated with Rod Request. Use progress key if stencil level weld status is needed. */
  welds: Array<Weld>;
};

export type RodRequestCaddy = {
  /** Caddy */
  caddy: Caddy;
  /** Created by user */
  createdBy: CrewMember;
  /** The current status of the Rod Request Caddy */
  currentStatusI18n: RodRequestCaddyStatusCode;
  /** Filler Materials */
  fillerMaterial: RodRequestCaddyFillerMaterial;
  /** Rod Request Caddy Id */
  id: Scalars['ID']['output'];
  /** Issued time of caddy */
  issuedAt: Scalars['Datetime']['output'];
  /** Issued by user */
  issuedBy: CrewMember;
  /** Picked up user */
  pickedUpBy?: Maybe<CrewMember>;
  /** Rod Request */
  rodRequest: RodRequest;
  /** Stencil of this caddy */
  stencils: Array<CrewMember>;
};

export type RodRequestCaddyComplexFilterInput = {
  /** And filter, all filter terms in this will be applied with and operator */
  and?: InputMaybe<Array<RodRequestCaddyFilterByTermInput>>;
  /** Or filter, all filter terms in this will be applied with or operator */
  or?: InputMaybe<Array<RodRequestCaddyFilterByTermInput>>;
};

export type RodRequestCaddyFillerMaterial = {
  /** Rod diameter and heat lot number */
  diameters: Array<CaddyFillerMaterialDiameter>;
  /** Filler material of Rod */
  fillerMaterial: RodFillerMaterial;
  /** Rod Request Caddy Filler Material Id */
  id: Scalars['ID']['output'];
};

export enum RodRequestCaddyFilterByTerm {
  /** CADDY_NUMBER - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN,CONTAINS */
  CADDY_NUMBER = 'CADDY_NUMBER',
  /** CADDY_STATUS - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN */
  CADDY_STATUS = 'CADDY_STATUS',
  /** ROD_ROOM_ID - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN */
  ROD_ROOM_ID = 'ROD_ROOM_ID',
  /** STENCIL_NUMBER  - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN,CONTAINS */
  STENCIL_NUMBER = 'STENCIL_NUMBER',
  /** WELDER - Valid Operators FUZZY */
  WELDER = 'WELDER'
}

export type RodRequestCaddyFilterByTermInput = {
  /** Operator to control the ANDs and ORs */
  operator: FilterOperator;
  term: RodRequestCaddyFilterByTerm;
  /** Value for Terms that require IDs, Booleans,  */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Muliple values, applicable only for IN operator */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RodRequestCaddyFilterInput = {
  /** Filter to handle all types of search */
  complexFilter?: InputMaybe<RodRequestCaddyComplexFilterInput>;
};

export enum RodRequestCaddyFilterInputError {
  FILTER_VALUES_MISSING = 'FILTER_VALUES_MISSING',
  FILTER_VALUE_MISSING = 'FILTER_VALUE_MISSING',
  INVALID_FILTER_OPERATOR = 'INVALID_FILTER_OPERATOR',
  INVALID_FILTER_ROD_ROOM_FLAG = 'INVALID_FILTER_ROD_ROOM_FLAG',
  INVALID_FILTER_STATUS = 'INVALID_FILTER_STATUS',
  INVALID_ROD_ROOM_INPUTS = 'INVALID_ROD_ROOM_INPUTS'
}

export type RodRequestCaddyList = {
  cursor?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<RodRequestCaddyFilterInputError>>>;
  items: Array<RodRequestCaddy>;
  total: Scalars['Int']['output'];
};

/** Defines available statuses in Rod Request workflow */
export enum RodRequestCaddyStatusCode {
  /** Caddy is Deleted */
  DELETED = 'DELETED',
  /** Caddy is issued */
  ISSUED = 'ISSUED',
  /** Caddy is returned */
  RETURNED = 'RETURNED'
}

export type RodRequestComment = {
  comment: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: CrewMember;
  id: Scalars['ID']['output'];
};

export type RodRequestComplexFilterInput = {
  /** And filter, all filter terms in this will be applied with and operator */
  and?: InputMaybe<Array<RodRequestFilterByTermInput>>;
  /** Or filter, all filter terms in this will be applied with or operator */
  or?: InputMaybe<Array<RodRequestFilterByTermInput>>;
};

export type RodRequestCrewMemberStats = {
  crewMember?: Maybe<CrewMember>;
  crewMemberId?: Maybe<Scalars['ID']['output']>;
  rodRequestStatusStats: Array<RodRequestStatusStats>;
};

export enum RodRequestCrewMemberStatsFilterInputError {
  FILTER_VALUES_MISSING = 'FILTER_VALUES_MISSING',
  FILTER_VALUE_MISSING = 'FILTER_VALUE_MISSING',
  INVALID_FILTER_DATE_VALUE = 'INVALID_FILTER_DATE_VALUE',
  INVALID_FILTER_OPERATOR = 'INVALID_FILTER_OPERATOR',
  INVALID_FILTER_VALUE = 'INVALID_FILTER_VALUE'
}

export type RodRequestFillerMaterial = {
  /** Rod diameter for rod request */
  diameters: Array<RodDiameter>;
  /** Filler material of Rod request */
  fillerMaterial: RodFillerMaterial;
  /** Rod Request Filler Material Id */
  id: Scalars['ID']['output'];
};

export type RodRequestFillerMaterialInput = {
  /** Rod diameter */
  diameterId: Scalars['ID']['input'];
  /** Filler material of Rod */
  fillerMaterialId: Scalars['ID']['input'];
};

export enum RodRequestFilterByTerm {
  /** ASSIGNEE_ID - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN,CONTAINS */
  ASSIGNEE_ID = 'ASSIGNEE_ID',
  /** FOREMAN - Valid Operators FUZZY */
  FOREMAN = 'FOREMAN',
  /** REQUESTER - Valid Operators FUZZY */
  REQUESTER = 'REQUESTER',
  /** ROD_CONTAINER - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN,CONTAINS */
  ROD_CONTAINER = 'ROD_CONTAINER',
  /** ROD_REQUEST_DATE - Valid Operator EQUALS,NOT_EQUALS,LESS_THAN,GREATER_THAN */
  ROD_REQUEST_DATE = 'ROD_REQUEST_DATE',
  /** ROD_REQUEST_NUMBER - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN,CONTAINS */
  ROD_REQUEST_NUMBER = 'ROD_REQUEST_NUMBER',
  /** ROD_REQUEST_STATUS_ID - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN,CONTAINS */
  ROD_REQUEST_STATUS_ID = 'ROD_REQUEST_STATUS_ID',
  /** ROD_ROOM_ID - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN,CONTAINS */
  ROD_ROOM_ID = 'ROD_ROOM_ID',
  /** STENCIL_ROD_REQUEST_STATUS_ID - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN */
  STENCIL_ROD_REQUEST_STATUS_ID = 'STENCIL_ROD_REQUEST_STATUS_ID',
  /** WELDER - Valid Operators FUZZY */
  WELDER = 'WELDER',
  /** WELD_ID - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN,CONTAINS */
  WELD_ID = 'WELD_ID',
  /** WELD_TAG - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN,CONTAINS */
  WELD_TAG = 'WELD_TAG'
}

export type RodRequestFilterByTermInput = {
  /** Operator to control the ANDs and ORs */
  operator: FilterOperator;
  term: RodRequestFilterByTerm;
  /** Value for Terms that require IDs, Booleans,  */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Muliple values, applicable only for IN operator */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RodRequestFilterInput = {
  /** Filter to handle all types of search */
  complexFilter?: InputMaybe<RodRequestComplexFilterInput>;
  /** Sort by Filter */
  sortByFilter?: InputMaybe<RodRequestSortByFilterInput>;
};

export enum RodRequestFilterInputError {
  FILTER_VALUES_MISSING = 'FILTER_VALUES_MISSING',
  FILTER_VALUE_MISSING = 'FILTER_VALUE_MISSING',
  INVALID_FILTER_DATE_VALUE = 'INVALID_FILTER_DATE_VALUE',
  INVALID_FILTER_OPERATOR = 'INVALID_FILTER_OPERATOR',
  INVALID_FILTER_STATUS_ID = 'INVALID_FILTER_STATUS_ID'
}

export type RodRequestList = {
  cursor?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<RodRequestFilterInputError>>>;
  items: Array<RodRequest>;
  total: Scalars['Int']['output'];
};

export enum RodRequestPickUpType {
  ALL = 'ALL',
  EXPIRED = 'EXPIRED',
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW'
}

export type RodRequestProgressStat = {
  caddyStatusStats: CaddyStatusStatsSummary;
  weldProgressStats: WeldProgressStatusStatsSummary;
};

export type RodRequestSortByFilterInput = {
  /** Sort Order, ascending or descending, defaults to ascending */
  sortOrder?: InputMaybe<SortOrder>;
  /** Term to sort the results by. */
  term: RodRequestSortByTerm;
};

export enum RodRequestSortByTerm {
  REQUEST_NUMBER = 'REQUEST_NUMBER',
  REQUEST_TIME = 'REQUEST_TIME'
}

export type RodRequestStatByStatus = {
  /** count by status */
  numStatus: Scalars['Int']['output'];
  /** Rod request status */
  status: RodRequestStatusCode;
};

export enum RodRequestStatsByCrewMemberFilterByTerm {
  /** CREW_MEMBER_ID - Stencil Id/Ids - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN */
  CREW_MEMBER_ID = 'CREW_MEMBER_ID',
  /** CREW_MEMBER_NAME - Valid Operator FUZZY */
  CREW_MEMBER_NAME = 'CREW_MEMBER_NAME',
  /** ROD_REQUEST_DATE - Valid Operator EQUALS,NOT_EQUALS,LESS_THAN,GREATER_THAN */
  ROD_REQUEST_DATE = 'ROD_REQUEST_DATE',
  /** ROD_ROOM_ID - Valid Operators EQUALS,NOT_EQUALS,IN,NOT_IN */
  ROD_ROOM_ID = 'ROD_ROOM_ID',
  /** Rod Request Status Id - Valid Operators EQUALS,NOT_EQUALS, Valid value/values CLOSED,REQUESTED */
  STENCIL_ROD_REQUEST_STATUS_ID = 'STENCIL_ROD_REQUEST_STATUS_ID',
  /** SUPERVISOR_ID - Foreman id - Valid Operators EQUALS,NOT_EQUALS */
  SUPERVISOR_ID = 'SUPERVISOR_ID'
}

export type RodRequestStatsByCrewMemberFilterByTermInput = {
  /** Operator to control the ANDs and ORs */
  operator: FilterOperator;
  term: RodRequestStatsByCrewMemberFilterByTerm;
  /** Value for Terms that require IDs, Booleans,  */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Muliple values, applicable only for IN operator */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RodRequestStatsByCrewMemberFilterInput = {
  /** And filter, all filter terms in this will be applied with and operator */
  and?: InputMaybe<Array<RodRequestStatsByCrewMemberFilterByTermInput>>;
  /** Or filter, all filter terms in this will be applied with or operator */
  or?: InputMaybe<Array<RodRequestStatsByCrewMemberFilterByTermInput>>;
};

export type RodRequestStatsByCrewMemberInput = {
  /** Filter to handle all types of search */
  complexFilter?: InputMaybe<RodRequestStatsByCrewMemberFilterInput>;
};

export type RodRequestStatsList = {
  crewMember?: Maybe<CrewMember>;
  /** Crew Member Id for which stats are requested */
  crewMemberId?: Maybe<Scalars['ID']['output']>;
  cursor?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<RodRequestCrewMemberStatsFilterInputError>>>;
  items: Array<Maybe<RodRequestCrewMemberStats>>;
  total: Scalars['Int']['output'];
};

/** Defines available statuses in Rod Request workflow */
export enum RodRequestStatusCode {
  /** All the stencil requests of this rod request are closed */
  CLOSED = 'CLOSED',
  /** Delete a rod request */
  DELETED = 'DELETED',
  /** Any of the stencil request of this rod request is expired */
  EXPIRED = 'EXPIRED',
  /** All the stencil requests of this rod request are issued */
  ISSUED = 'ISSUED',
  /** Some of stencil requests of this rod request are issued */
  PARTIAL_ISSUED = 'PARTIAL_ISSUED',
  /** The initial status of a Rod Request */
  REQUESTED = 'REQUESTED'
}

export enum RodRequestStatusCodeByStencil {
  /** All the stencil requests of this rod request are closed */
  CLOSED = 'CLOSED',
  /** The initial status of a Rod Request */
  REQUESTED = 'REQUESTED'
}

export type RodRequestStatusStats = {
  /** Rod Request status count */
  stats: Scalars['Int']['output'];
  /** Rod Request status */
  status: RodRequestStatusCode;
};

export type RodRequestStatusStatsSummary = {
  /** Total RodRequest for given rod Room */
  numRodRequests: Scalars['Int']['output'];
  /** RodRequest Stats */
  rodRequestSummary: Array<RodRequestStatusStats>;
};

export type RodRequestStencil = {
  stats: RodRequestProgressStat;
  status: RodRequestStatusCodeByStencil;
  statusAt: Scalars['Datetime']['output'];
  statusBy: CrewMember;
  stencil: CrewMember;
  welds: Array<RodRequestWeld>;
};

export type RodRequestWeld = {
  id: Scalars['ID']['output'];
  status: RodRequestWeldStatus;
  weld: Weld;
};

export enum RodRequestWeldStatus {
  COMPLETED = 'COMPLETED',
  DID_NOT_WELD = 'DID_NOT_WELD',
  INPROGRESS = 'INPROGRESS'
}

export type RodRequestsSubscriptionPayload = {
  rodRequestIds: Array<Scalars['ID']['output']>;
};

export type RodRoom = {
  /** Internal ID for Rod Room */
  id: Scalars['ID']['output'];
  /** Flag that indicates if this rodRoom is active */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Location of Rod room */
  location?: Maybe<GeoLocation>;
  /** Rod room location description */
  locationDescription?: Maybe<Scalars['String']['output']>;
  /** Name of the Rod room */
  name: Scalars['String']['output'];
};

export enum RodRoomCaddyStatusFlag {
  IN_HOUSE = 'IN_HOUSE',
  ISSUED = 'ISSUED',
  RETURNED = 'RETURNED',
  RETURNED_TO_OTHER_ROD_ROOM = 'RETURNED_TO_OTHER_ROD_ROOM'
}

export type RodRoomCaddyStatusStats = {
  /** Count */
  stats: Scalars['Int']['output'];
  /** Rod Room Caddy Status */
  status: RodRoomCaddyStatusFlag;
};

export type RodRoomCaddyStatusStatsSummary = {
  /** Caddy Stats */
  caddySummary: Array<RodRoomCaddyStatusStats>;
  /** Total caddies */
  numCaddies: Scalars['Int']['output'];
};

export type RodRoomStats = {
  /** Stats by caddy status */
  caddyStats: RodRoomCaddyStatusStatsSummary;
  errors?: Maybe<Array<RodRequestFilterInputError>>;
  /** Rod Room Id */
  id: Scalars['ID']['output'];
  /** Priority Welds Count */
  numPriority: Scalars['Int']['output'];
  /** Stats by Rod Request */
  rodRequestStats: RodRequestStatusStatsSummary;
  /** Stats by Rod Room */
  rodRoomStatsSummary?: Maybe<Array<RodRoomStatsSummary>>;
};

export type RodRoomStatsInput = {
  /** Filter to handle all types of search */
  complexFilter?: InputMaybe<RodRequestComplexFilterInput>;
  /** rodRoomId */
  rodRoomId: Scalars['ID']['input'];
  /** Sort by Filter */
  sortByFilter?: InputMaybe<RodRequestSortByFilterInput>;
};

export type RodRoomStatsSummary = {
  /** Count */
  stats: Scalars['Int']['output'];
  /** Rod Room Status */
  status: RodRoomStatusFlag;
};

export enum RodRoomStatusFlag {
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW'
}

export enum SampleLastUpdatedMutationError {
  INVALID_WORK_PACKAGE_ID = 'INVALID_WORK_PACKAGE_ID',
  /**
   * This shows the client is out of sync with the server.
   * The lastUpdated field provided is different than on the backend.
   */
  LAST_UPDATED_OUT_OF_SYNC_ERROR = 'LAST_UPDATED_OUT_OF_SYNC_ERROR'
}

export type SampleLastUpdatedMutationInput = {
  lastUpdated: Scalars['Datetime']['input'];
  workPackageId: Scalars['ID']['input'];
};

export type SampleLastUpdatedMutationPayload = {
  error?: Maybe<SampleLastUpdatedMutationError>;
  workPackage?: Maybe<WorkPackage>;
};

export type SaveCommoditySectionItemInput = {
  projectsCommodityTypeId: Scalars['ID']['input'];
  sectionFields: Array<CommoditySectionFieldInput>;
  sectionTitle: Scalars['String']['input'];
};

export enum SaveCommoditySectionItemsError {
  SAVE_COMMODITY_SECTION_ITEMS_ERRORED = 'SAVE_COMMODITY_SECTION_ITEMS_ERRORED'
}

export type SaveCommoditySectionItemsPayload = {
  commoditySections?: Maybe<Array<CommoditySection>>;
  error?: Maybe<SaveCommoditySectionItemsError>;
};

export enum SaveCrewTypeSelectionError {
  /** A Crew type id was provided which doesnt exist in the list of all crew types from eTrack */
  INVALID_CREW_TYPE_PROVIDED = 'INVALID_CREW_TYPE_PROVIDED'
}

export type SaveCrewTypeSelectionPayload = {
  crewTypes?: Maybe<Array<CrewType>>;
  error?: Maybe<SaveCrewTypeSelectionError>;
};

export type SaveFeatureInput = {
  /** Flag to indicate if the feature is active or not */
  enabled: Scalars['Boolean']['input'];
  /** ID of the feature to be saved */
  featureId: Scalars['ID']['input'];
  /** Meta Data for the feature to be saved, even if not changed, the value should be sent back */
  metaData?: InputMaybe<Scalars['JSON']['input']>;
};

export enum SaveFeaturesError {
  METADATA_DEFINITION_MISMATCH_ERROR = 'METADATA_DEFINITION_MISMATCH_ERROR',
  NOT_FOUND = 'NOT_FOUND'
}

export type SaveFeaturesPayload = {
  /** Error if any */
  error?: Maybe<SaveFeaturesError>;
  /** Project features that needs to be updated */
  features?: Maybe<Array<Feature>>;
};

export enum SaveItrConfigError {
  PROJECT_MILESTONE_TYPE_NOT_FOUND = 'PROJECT_MILESTONE_TYPE_NOT_FOUND'
}

export type SaveItrConfigInput = {
  itrMilestoneAction?: InputMaybe<ItrMilestoneAction>;
  itrMilestoneConfigInput: Array<ItrMilestoneConfigInput>;
  itrType: ItrType;
};

export type SaveItrConfigPayload = {
  error?: Maybe<SaveItrConfigError>;
  projectItrConfig: Array<ProjectItrConfig>;
};

export enum SavePersonaLobRoleNamesError {
  INPUT_HAS_DUPLICATE_VALUE = 'INPUT_HAS_DUPLICATE_VALUE',
  SAVE_PERSONA_LOB_ROLE_NAME_ERRORED = 'SAVE_PERSONA_LOB_ROLE_NAME_ERRORED'
}

export type SavePersonaLobRoleNamesInput = {
  /** Associated Lob Role Names */
  associatedLobRoleNames: Array<Scalars['String']['input']>;
  /** Persona Name */
  persona: Scalars['String']['input'];
};

export type SavePersonaLobRoleNamesPayload = {
  error?: Maybe<SavePersonaLobRoleNamesError>;
  projectConfig?: Maybe<ProjectConfig>;
};

export enum SavePlanningAndTargetConfigError {
  INVALID_VALUE = 'INVALID_VALUE',
  NOT_FOUND = 'NOT_FOUND'
}

export type SavePlanningAndTargetConfigInput = {
  /** Composite Unit Rate */
  compositeUnitRate: UnitRateInput;
  /** Facility Unit Rates */
  facilityUnitRates?: InputMaybe<Array<FacilityUnitRateInput>>;
  /** Indirect Tax */
  indirectTax: Scalars['Float']['input'];
  /** Project Adjustment Factor */
  projectAdjustmentFactor: Scalars['Float']['input'];
};

export type SavePlanningAndTargetConfigPayload = {
  error?: Maybe<SavePlanningAndTargetConfigError>;
  projectConfig?: Maybe<ProjectConfig>;
};

export type SavePlanningInput = {
  /** Comment for changing plan for AI planned milestones */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The list of IDs of milestones being saved */
  commodityMilestoneIds: Array<Scalars['ID']['input']>;
  /** CrewMemberId of the selected foreman */
  foremanId?: InputMaybe<Scalars['ID']['input']>;
  /** CrewMemberId of the selected genaral foreman */
  generalForemanId?: InputMaybe<Scalars['ID']['input']>;
  /** Planning AI Request ID if the save is for an AI generated plan */
  planningAiRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Planning week Id */
  planningWeekId: Scalars['ID']['input'];
  /** CrewMemberId of the selected suerintendent */
  superintendentId?: InputMaybe<Scalars['ID']['input']>;
  /** The week number for the week these milestones are being saved for */
  week: Scalars['Int']['input'];
  /** The year for the week these milestones are being saved for */
  year: Scalars['Int']['input'];
};

export enum SaveQuantityReportingConfigError {
  INVALID_DAY_VALUE_SPECIFIED = 'INVALID_DAY_VALUE_SPECIFIED',
  INVALID_TIME_VALUE_SPECIFIED = 'INVALID_TIME_VALUE_SPECIFIED',
  NOT_FOUND = 'NOT_FOUND',
  SAVE_QUANTITY_REPORTING_CONFIG_ERRORED = 'SAVE_QUANTITY_REPORTING_CONFIG_ERRORED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export type SaveQuantityReportingConfigInput = {
  allowApprovalByNotification: Scalars['Boolean']['input'];
  usersQuantityDisplayToggle: Scalars['Boolean']['input'];
  weekEndDay: Scalars['Int']['input'];
  /** 24 Hour format: HH:MM */
  weekEndTime: Scalars['Time']['input'];
  weekStartDay: Scalars['Int']['input'];
  /** 24 Hour format: HH:MM */
  weekStartTime: Scalars['Time']['input'];
  workPackageDisciplineClaims: Array<WorkPackageDisciplineConfigInput>;
};

export type SaveQuantityReportingConfigPayload = {
  error?: Maybe<SaveQuantityReportingConfigError>;
  projectConfig?: Maybe<ProjectConfig>;
  workPackageDisciplines?: Maybe<Array<WorkPackageDiscipline>>;
};

export type SaveTimesheetCharge = {
  /** Timesheet Comments */
  comment?: Maybe<TimesheetReason>;
  /** Costcode against which the charge is made. This could be a non-work package charge code */
  costCode: CostCode;
  /** Hours entered for a crew member for particular workpackage, costcode on the given timesheet day  */
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Time type */
  timeType: TimeType;
  /** Workpackage against which the charge is made */
  workPackage?: Maybe<WorkPackage>;
};

/** Error while Saving timesheet */
export type SaveTimesheetChargesError = {
  crewMemberId?: Maybe<Scalars['ID']['output']>;
  error: Scalars['String']['output'];
};

export type SaveTimesheetChargesInput = {
  /** This crew id of the foreman whose timesheet charge this is. */
  crewId: Scalars['String']['input'];
  /** Which date is the timesheet charge is being saved. */
  forDate: Scalars['Date']['input'];
  /** Entered time & comment against time type for selected crew member/cost code */
  timesheetCharges: Array<TimeSheetChargeInput>;
};

export type SaveTimesheetChargesPayload = {
  errors?: Maybe<Array<SaveTimesheetChargesError>>;
  timesheetDay?: Maybe<TimesheetDay>;
};

export enum SaveTimesheetError {
  CERT_CLASS_MISSING_FOR_ONE_OR_MORE_EMPLOYEES = 'CERT_CLASS_MISSING_FOR_ONE_OR_MORE_EMPLOYEES',
  INVALID_COST_CODE_PROVIDED = 'INVALID_COST_CODE_PROVIDED',
  INVALID_CREW_ID = 'INVALID_CREW_ID',
  INVALID_CREW_MEMBER_ID = 'INVALID_CREW_MEMBER_ID',
  MISSING_TIME_CHARGES = 'MISSING_TIME_CHARGES',
  POSITION_CODE_MISSING_FOR_ONE_OR_MORE_EMPLOYEES = 'POSITION_CODE_MISSING_FOR_ONE_OR_MORE_EMPLOYEES',
  REASONS_REQUIRED_FOR_TIMETYPE = 'REASONS_REQUIRED_FOR_TIMETYPE',
  SAVE_TIMESHEET_CHARGES_ERRORED = 'SAVE_TIMESHEET_CHARGES_ERRORED',
  SAVE_TIMESHEET_ERRORED = 'SAVE_TIMESHEET_ERRORED',
  TIMESHEET_NO_LONGER_EDITABLE = 'TIMESHEET_NO_LONGER_EDITABLE',
  USER_ABSENT_BUT_TIME_PROVIDED = 'USER_ABSENT_BUT_TIME_PROVIDED'
}

/** Data required to save a timesheet for a given day for a crew */
export type SaveTimesheetInput = {
  /** This crew id of the foreman whose timesheet this is. */
  crewId: Scalars['String']['input'];
  /** Which date is the timesheet being saved. */
  forDate: Scalars['Date']['input'];
  /** Entered time & comments against various time types for selected crew members */
  timeEntryInput: Array<TimeEntryInput>;
  /** Timesheet id from eTrack */
  timesheetId: Scalars['ID']['input'];
};

export type SaveTimesheetPayload = {
  errors?: Maybe<Array<SaveTimesheetChargesError>>;
  timesheetDay?: Maybe<TimesheetDay>;
};

export enum SaveUserPreferencesError {
  INVALID_LANGUAGE = 'INVALID_LANGUAGE',
  INVALID_UOM = 'INVALID_UOM',
  SAVING_USER_PREFERENCE_FAILED = 'SAVING_USER_PREFERENCE_FAILED'
}

export type SaveUserPreferencesInput = {
  language: Scalars['String']['input'];
  unitOfMeasure: UnitOfMeasure;
};

export type SaveUserPreferencesPayload = {
  errors: Array<Maybe<SaveUserPreferencesError>>;
  user?: Maybe<User>;
};

export enum SaveWeldProgramConfigError {
  NOT_FOUND = 'NOT_FOUND'
}

export type SaveWeldProgramConfigInput = {
  /** Manage Fit-Up request workflow before completion of welds? */
  fitUpWorkflowEnabled: Scalars['Boolean']['input'];
  /** How are welders organized in your project? */
  weldOrganization: WeldOrganization;
};

export type SaveWeldProgramConfigPayload = {
  error?: Maybe<SaveWeldProgramConfigError>;
  projectConfig?: Maybe<ProjectConfig>;
};

export type Schedule = {
  duration: Scalars['Float']['output'];
  hourTypes: Array<ScheduleHourType>;
  id: Scalars['ID']['output'];
};

export type ScheduleHourType = {
  description?: Maybe<Scalars['String']['output']>;
  hourCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxHours: Scalars['Float']['output'];
  order?: Maybe<Scalars['Float']['output']>;
};

export type SearchCostCodeInput = {
  /** Commodity Tag */
  commodityTag?: InputMaybe<Scalars['String']['input']>;
  /** Cost code string */
  costCode?: InputMaybe<Scalars['String']['input']>;
  /** A list of code code values to search for. Should match the full cost code value, partial search is not supported with this attribute */
  costCodeValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Mandatory parameter for search cost code */
  crewId: Scalars['ID']['input'];
  /** Crew member Id for whom the cost codes are associated. This field is mandatory if the search scope is assigned */
  crewMemberId?: InputMaybe<Scalars['ID']['input']>;
  /** Workpackage Number */
  workPackageNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SearchCrewChangeRequestInput = {
  /** End date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by term */
  filterBy: CrewChangeRequestFilterByTerm;
  /** Sort by term */
  sortBy: Array<CrewChangeRequestSortByTerm>;
  /** Start date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SearchCrewInput = {
  /** Foreman identifier for the crew */
  foremanId?: InputMaybe<Scalars['ID']['input']>;
  /** General Foreman identfier. Provide this value to get a list of all General Foreman crews */
  generalForemanId?: InputMaybe<Scalars['ID']['input']>;
  /** Partial name of employees to search for */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  /** Superintendent identfier. Provide this value to get a list of all Superintendent crews */
  superintendentId?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchCrewMemberInput = {
  /** Requested App Type ID to get users based on this app type id */
  appTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Specific crew member ID to filter by */
  crewMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Employee discipline (WELDING, etc) */
  discipline?: InputMaybe<CrewMemberDiscipline>;
  /** Employee role (FOREMAN, SUPERINTENDENT, etc) */
  persona?: InputMaybe<PersonaType>;
  personas?: InputMaybe<Array<PersonaType>>;
  /** Partial name of employees to search for */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  /** Sort by term */
  sortBy?: InputMaybe<CrewMemberSortByTerm>;
  /** Sort Order, ascending or descending, defaults to ascending */
  sortOrder?: InputMaybe<SortOrder>;
  /** eTrack ID of the employee's Supervisor */
  supervisorId?: InputMaybe<Scalars['String']['input']>;
};

/** Error while saving user profile */
export enum SetUserDefaultProjectError {
  INVALID_PROJECT_ID = 'INVALID_PROJECT_ID'
}

export type SetUserDefaultProjectInput = {
  projectId: Scalars['ID']['input'];
};

/** Save user profile payload */
export type SetUserDefaultProjectPayload = {
  error?: Maybe<SetUserDefaultProjectError>;
  user?: Maybe<User>;
};

export type Shift = {
  /** Shift Schedule for the timesheet day */
  dayShiftSchedule: Schedule;
  /** Shift Description */
  description: Scalars['String']['output'];
  /** Effective Date */
  effectiveDate: Scalars['Datetime']['output'];
  /** Primary identifier/Short Name */
  id: Scalars['ID']['output'];
  /** Period in which overtime is paid - For example, per day or per period. */
  overTimeMode?: Maybe<Scalars['String']['output']>;
  /** Increment in minutes in which timesheet entries should be rounded off */
  roundingIncrement?: Maybe<Scalars['Float']['output']>;
  /** Shift Schedule */
  shiftSchedule: Array<Schedule>;
  /** Shift (day/night) */
  shiftType?: Maybe<CrewMemberShiftType>;
};


export type ShiftDayShiftScheduleArgs = {
  forDate: Scalars['Date']['input'];
  lobCrewNumber: Scalars['String']['input'];
};

/**
 * Provides details about the scheduled hours for a shift on a particular day of the week.
 * Applicable time types can change day on a day to day basis depending on config in eTrack.
 * Usually they dont change.
 */
export type ShiftTimeHourType = {
  /** Day of the week */
  dayOfWeek: Scalars['Int']['output'];
  /** Precendence Order of the hour type */
  order: Scalars['Int']['output'];
  /** Maximum hours that can be entered for each hour type */
  thresholdHours: Scalars['Float']['output'];
  /** Type of time ST, OT or DT */
  timeType: TimeType;
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum SortOrderByEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type State = {
  /** Country Id */
  countryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** State name */
  name: Scalars['String']['output'];
};

export type Subscription = {
  blockCreated?: Maybe<BlockCreatedPayload>;
  blockUpdated?: Maybe<BlockUpdatedPayload>;
  caddyUpdated?: Maybe<CaddySubscriptionPayload>;
  commoditiesUpdated?: Maybe<CommoditiesUpdatedPayload>;
  crewChangeRequest?: Maybe<CrewChangeRequestPayload>;
  crewUpdated?: Maybe<CrewUpdatedPayload>;
  employeeUpdated: Array<EmployeeUpdatedPayload>;
  milestonesUnplanned?: Maybe<MilestonesUnplannedPayload>;
  notificationUpdated?: Maybe<NotificationUpdatedPayload>;
  planningAiCompleted?: Maybe<PlanningAiCompletedPayload>;
  planningWeekSaved?: Maybe<PlanningWeekSavedPayload>;
  rodFillerMaterialUpdated?: Maybe<RodFillerMaterialSubscriptionPayload>;
  rodRequestsCreated?: Maybe<RodRequestsSubscriptionPayload>;
  rodRequestsUpdated?: Maybe<RodRequestsSubscriptionPayload>;
  usersImport?: Maybe<UsersImportPayload>;
  void?: Maybe<Scalars['Boolean']['output']>;
  weldProcedureUpdated?: Maybe<WeldProcedureSubscriptionPayload>;
  workPackagesImport?: Maybe<WorkPackagesImportPayload>;
  workPackagesUpdated: WorkPackagesUpdatedPayload;
};


export type SubscriptionCommoditiesUpdatedArgs = {
  workPackageId?: InputMaybe<Scalars['ID']['input']>;
};

export type SyncEventNotificationError = {
  error: SyncEventNotificationErrorCode;
  id?: Maybe<Scalars['ID']['output']>;
};

export enum SyncEventNotificationErrorCode {
  EVENT_NOTIFICATION_ALREADY_PROCESSED = 'EVENT_NOTIFICATION_ALREADY_PROCESSED',
  EVENT_NOTIFICATION_ENTITY_NOT_CONFIGURED = 'EVENT_NOTIFICATION_ENTITY_NOT_CONFIGURED',
  EVENT_NOTIFICATION_NOT_FOUND = 'EVENT_NOTIFICATION_NOT_FOUND',
  EVENT_NOTIFICATION_PUB_SUB_NOT_CONFIGURED = 'EVENT_NOTIFICATION_PUB_SUB_NOT_CONFIGURED',
  FILTER_VALUES_MISSING = 'FILTER_VALUES_MISSING',
  FILTER_VALUE_MISSING = 'FILTER_VALUE_MISSING',
  INVALID_ENTITY_TYPE_VALUE = 'INVALID_ENTITY_TYPE_VALUE',
  INVALID_ERROR_TYPE_VALUE = 'INVALID_ERROR_TYPE_VALUE',
  INVALID_FILTER_OPERATOR = 'INVALID_FILTER_OPERATOR',
  INVALID_FILTER_VALUE = 'INVALID_FILTER_VALUE',
  INVALID_NOTIFICATION_TYPE_ID_VALUE = 'INVALID_NOTIFICATION_TYPE_ID_VALUE',
  INVALID_STATUS_VALUE = 'INVALID_STATUS_VALUE',
  INVALID_SYNC_SCHEDULE_VALUE = 'INVALID_SYNC_SCHEDULE_VALUE',
  PENDING_EVENT_NOTIFICATION_FOUND = 'PENDING_EVENT_NOTIFICATION_FOUND',
  SYNC_EVENT_NOTIFICATION_FAILED = 'SYNC_EVENT_NOTIFICATION_FAILED',
  SYNC_EVENT_NOTIFICATION_SCHEDULE_FAILED = 'SYNC_EVENT_NOTIFICATION_SCHEDULE_FAILED'
}

export type SyncEventNotificationsInput = {
  complexFilter: EventNotificationFilterInput;
  syncScheduledAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SyncEventNotificationsPayload = {
  errors?: Maybe<Array<SyncEventNotificationError>>;
};

export type TargetHoursCalculation = {
  compositeUnitRate: UnitRate;
  crewHeadCount: Scalars['Int']['output'];
  crewHours: Scalars['Int']['output'];
  crewQuantity: Quantity;
  indirectHours: Scalars['Int']['output'];
  indirectQuantity: Quantity;
  indirectTax: Scalars['Float']['output'];
  projectAdjustmentFactor: Scalars['Float']['output'];
  projectAdjustmentHours: Scalars['Int']['output'];
  projectAdjustmentQuantity: Quantity;
  weeklyHours: Scalars['Int']['output'];
};

export type TargetHoursCalculationInput = {
  crewMemberId: Scalars['ID']['input'];
  persona: PersonaType;
};

export type TestMutationInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TestMutationPayload = {
  commodityMilestoneIds: Array<Scalars['ID']['output']>;
  /** Impacted milestones */
  commodityMilestones?: Maybe<Array<CommodityMilestone>>;
  id: Scalars['ID']['output'];
};

/** Minimum unit of time entry which may or may not have a comment. */
export type TimeEntryInput = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  /** Mandatory cost code to enter time against */
  costCodeId: Scalars['ID']['input'];
  crewMemberId: Scalars['ID']['input'];
  hourCode: Scalars['String']['input'];
  hours: Scalars['Float']['input'];
  /** Id is mandatory only in case of updates */
  id?: InputMaybe<Scalars['ID']['input']>;
  otherCommentDescription?: InputMaybe<Scalars['String']['input']>;
  /** Non-mandatory work package if cost code was selected under a work package */
  workPackageId?: InputMaybe<Scalars['ID']['input']>;
};

export type TimeSheetChargeInput = {
  /** Operation Type for the charge, i.e Insert or Update or Delete */
  operationType: TimesheetOperationType;
  /** Entered time & comment against time type for selected crew member */
  timeEntryInput: TimeEntryInput;
};

export type TimeType = {
  id: Scalars['ID']['output'];
  /** Eg. Straight | Double | Overtime */
  name: Scalars['String']['output'];
  /** Order of Precedence */
  order: Scalars['Int']['output'];
  /** Whether time entry is required for this time type. Configurable. */
  required: Scalars['Boolean']['output'];
  /** Value to be sent to eTrack Eg.ST,OT,DT */
  value: Scalars['String']['output'];
};

/** Which crew and which date to return timesheet data for. Not implemented yet. */
export type TimesheetByCrewInput = {
  crewId: Scalars['ID']['input'];
  forDate: Scalars['Date']['input'];
};

/** Which crew and which date to return timesheet data for. Not implemented yet. */
export type TimesheetByForemanInput = {
  forDate: Scalars['Date']['input'];
  foremanId: Scalars['ID']['input'];
};

/** Not implemented yet. */
export type TimesheetCostCode = {
  /** Did the crew claim a milestone related to a commodity that is related to this cost code on the timesheet day */
  claimedOnTimesheetDay: Scalars['Boolean']['output'];
  costCode: CostCode;
  id: Scalars['ID']['output'];
};

/** Each day consists of a list of relevant crew members and their timesheet entries. Not implemented yet. */
export type TimesheetDay = {
  /**
   * Crew details. They may or may not contain timesheet entries depending on
   * if time has been logged by crew.
   */
  crewMembers: Array<TimesheetDayCrewMember>;
  /** Is Timesheet in editable state */
  editable: Scalars['Boolean']['output'];
  error?: Maybe<TimesheetDayError>;
  /** The date of this particular timesheet information */
  forDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  lobCrewNumber?: Maybe<Scalars['String']['output']>;
  /** Timesheet Status of this crew's timesheet */
  timesheetStatus: TimesheetStatus;
};

/** Each Day by CrewMember reference includes punch in / punch out data as well as specific per-cost code entry. Not implemented yet. */
export type TimesheetDayCrewMember = {
  /** eTrackId of the crew member */
  eTrackId: Scalars['String']['output'];
  /** When this crew member punched in for the day. */
  shiftPunchIn?: Maybe<Scalars['Datetime']['output']>;
  /** When this crew member punched out for the day. */
  shiftPunchOut?: Maybe<Scalars['Datetime']['output']>;
  /** Timesheet entries */
  timeEntries: Array<TimesheetEntry>;
};

export enum TimesheetDayError {
  CREW_MEMBER_NOT_FOUND = 'CREW_MEMBER_NOT_FOUND',
  CREW_NOT_FOUND = 'CREW_NOT_FOUND',
  TIMESHEET_DAY_ERRORED = 'TIMESHEET_DAY_ERRORED'
}

export type TimesheetEntry = {
  /** Timesheet Comments */
  comment?: Maybe<TimesheetReason>;
  /** Costcode against which the charge is made. This could be a non-work package charge code */
  costCode: CostCode;
  /** Time type */
  hourCode: Scalars['String']['output'];
  /** Hours entered for a crew member for particular workpackage, costcode on the given timesheet day  */
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Workpackage against which the charge is made */
  workPackage?: Maybe<WorkPackage>;
};

export enum TimesheetOperationType {
  DELETE = 'DELETE',
  INSERT = 'INSERT',
  UPDATE = 'UPDATE'
}

/** Reason to be entered when entering time. */
export type TimesheetReason = {
  id: Scalars['ID']['output'];
  /**
   * This is the localization key related to this timesheet comment.
   * Some examples:
   * OTHER
   * ABSENT
   * NOT_ON_CREW
   * NO_LONGER_ON_PROJECT
   * BADGE_SCANNER_ERROR
   * APPRENTICE_TRAINING
   * NON_MANDATORY_WORKDAY
   * ABSENT_RTO
   * This list is configurable on project level
   */
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Status to indicate where in timesheet workflow a user/ crew is */
export enum TimesheetStatus {
  /** Timesheet has bee approved by supervisor in eTrack */
  APPROVED = 'APPROVED',
  /** Crew has started working on timesheet for the day and have saved at least once */
  IN_PROGRESS = 'IN_PROGRESS',
  /** GF do not have a timesheet hence this is a GF's status when looking at a hierarchy */
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  /** Crew has not started working on timesheet for the day */
  NOT_STARTED = 'NOT_STARTED',
  /** All crew members have done their timesheet for the day */
  SUBMITTED = 'SUBMITTED'
}

/** Not implemented yet. */
export type TimesheetWorkPackage = {
  /** Which cost codes from the above work package do we have information for. */
  associatedCostCodes: Array<TimesheetCostCode>;
  /** Which workpackage this section of the timesheet is related to. */
  workPackage: WorkPackage;
};

export enum UnApproveFitupError {
  EIS_ERROR = 'EIS_ERROR',
  INVALID_WELD = 'INVALID_WELD',
  MILESTONE_APPROVED_BY_SOME_OTHER_USER = 'MILESTONE_APPROVED_BY_SOME_OTHER_USER',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_NOT_APPROVED = 'MILESTONE_IS_NOT_APPROVED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  UNAPPROVE_FITUP_MILESTONE_ERRORED = 'UNAPPROVE_FITUP_MILESTONE_ERRORED'
}

export type UnApproveFitupPayload = {
  error?: Maybe<UnApproveFitupError>;
  weld?: Maybe<Weld>;
};

/** Available error for unapproveMilestone */
export enum UnApproveMilestoneError {
  EIS_ERROR = 'EIS_ERROR',
  MILESTONE_APPROVED_BY_SOME_OTHER_USER = 'MILESTONE_APPROVED_BY_SOME_OTHER_USER',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_NOT_APPROVED = 'MILESTONE_IS_NOT_APPROVED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  UNAPPROVE_MILESTONE_ERRORED = 'UNAPPROVE_MILESTONE_ERRORED'
}

/** Payload returned on call to unapproveMilestone. */
export type UnApproveMilestonePayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<UnApproveMilestoneError>;
  milestone?: Maybe<CommodityMilestone>;
  workPackage?: Maybe<WorkPackage>;
};

export enum UnApproveWeldError {
  EIS_ERROR = 'EIS_ERROR',
  MILESTONE_APPROVED_BY_SOME_OTHER_USER = 'MILESTONE_APPROVED_BY_SOME_OTHER_USER',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_NOT_APPROVED = 'MILESTONE_IS_NOT_APPROVED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  UNAPPROVE_WELD_MILESTONE_ERRORED = 'UNAPPROVE_WELD_MILESTONE_ERRORED'
}

export type UnApproveWeldPayload = {
  error?: Maybe<UnApproveWeldError>;
  weld?: Maybe<Weld>;
};

/** Available error for unclaimMilestone */
export enum UnclaimMilestoneError {
  EIS_ERROR = 'EIS_ERROR',
  MILESTONE_CLAIMED_BY_SOME_OTHER_USER = 'MILESTONE_CLAIMED_BY_SOME_OTHER_USER',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MILESTONE_NOT_CLAIMED = 'MILESTONE_NOT_CLAIMED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  UNCLAIM_MILESTONE_ERRORED = 'UNCLAIM_MILESTONE_ERRORED'
}

/** Payload returned on call to unclaimMilestone. */
export type UnclaimMilestonePayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<UnclaimMilestoneError>;
  milestone?: Maybe<CommodityMilestone>;
  workPackage?: Maybe<WorkPackage>;
};

export enum UnclaimWeldError {
  EIS_ERROR = 'EIS_ERROR',
  MILESTONE_CLAIMED_BY_SOME_OTHER_USER = 'MILESTONE_CLAIMED_BY_SOME_OTHER_USER',
  MILESTONE_CONFIG_NOT_FOUND = 'MILESTONE_CONFIG_NOT_FOUND',
  MILESTONE_IS_APPROVED = 'MILESTONE_IS_APPROVED',
  MILESTONE_IS_BLOCKED = 'MILESTONE_IS_BLOCKED',
  MILESTONE_IS_REJECTED = 'MILESTONE_IS_REJECTED',
  MILESTONE_NOT_CLAIMED = 'MILESTONE_NOT_CLAIMED',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  UNCLAIM_WELD_MILESTONE_ERRORED = 'UNCLAIM_WELD_MILESTONE_ERRORED'
}

export type UnclaimWeldPayload = {
  error?: Maybe<UnclaimWeldError>;
  weld?: Maybe<Weld>;
};

export enum UnitOfMeasure {
  EACH = 'EACH',
  HOURS = 'HOURS',
  HOURS_PER_FOOT = 'HOURS_PER_FOOT',
  LINEAR_FEET = 'LINEAR_FEET',
  LINEAR_METERS = 'LINEAR_METERS'
}

export type UnitRate = {
  unitRate: Scalars['Float']['output'];
  uom: Uom;
};

export type UnitRateInput = {
  unitRate: Scalars['Float']['input'];
  uomId: Scalars['ID']['input'];
};

export enum UnpinCostCodesError {
  INVALID_COST_CODES = 'INVALID_COST_CODES'
}

export type UnpinCostCodesInput = {
  timesheetCostCodeIds: Array<Scalars['ID']['input']>;
};

export type UnpinCostCodesPayload = {
  error?: Maybe<UnpinCostCodesError>;
  /** Cost Code Ids that were deleted. Use this to update your UI */
  timesheetCostCodeIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type UnplanInput = {
  commodityMilestoneIds: Array<Scalars['ID']['input']>;
};

export type Uom = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  project: Project;
  uom: Scalars['String']['output'];
  uomTypeId: UnitOfMeasure;
};

export enum UomType {
  IMPERIAL = 'IMPERIAL',
  METRIC = 'METRIC'
}

/** Error while updating a block */
export type UpdateBlockError = {
  errorCode?: Maybe<UpdateBlockErrorCode>;
  milestone?: Maybe<CommodityMilestone>;
};

/** Error code while updating a block */
export enum UpdateBlockErrorCode {
  COMMENT_TOO_LARGE = 'COMMENT_TOO_LARGE',
  EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT = 'EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT',
  MILESTONE_ALREADY_APPROVED = 'MILESTONE_ALREADY_APPROVED',
  MILESTONE_ALREADY_BLOCKED = 'MILESTONE_ALREADY_BLOCKED',
  MILESTONE_ALREADY_CLAIMED = 'MILESTONE_ALREADY_CLAIMED',
  MILESTONE_NOT_FOUND = 'MILESTONE_NOT_FOUND',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  UPDATE_BLOCK_ERRORED = 'UPDATE_BLOCK_ERRORED'
}

/** Input details required for updating a block */
export type UpdateBlockInput = {
  /** List of attachment inputs for this block. */
  attachmentMetadata?: InputMaybe<Array<AttachmentMetadataInput>>;
  /** The Block Type Id  */
  blockTypeId: Scalars['ID']['input'];
  /** Comments made about this block. */
  comments?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** A list of milestones that a block applies to. Any previous milestone references will be replaced with this list. */
  milestoneIds: Array<Scalars['ID']['input']>;
  /** Work Package Id associated to this block.-TO BE REMOVED, DO NOT USE */
  workPackageId?: InputMaybe<Scalars['ID']['input']>;
};

/** Updated block response payload */
export type UpdateBlockPayload = {
  block?: Maybe<Block>;
  error?: Maybe<Array<Maybe<UpdateBlockError>>>;
};

/** Update block status error */
export enum UpdateBlockStatusError {
  INVALID_STATUS = 'INVALID_STATUS'
}

/** Update block status input */
export type UpdateBlockStatusInput = {
  blockId: Scalars['ID']['input'];
  statusCode: BlockStatusCode;
};

/** Update block status payload */
export type UpdateBlockStatusPayload = {
  block?: Maybe<Block>;
  error?: Maybe<UpdateBlockStatusError>;
};

/** Error code while updating a caddy */
export enum UpdateCaddyErrorCode {
  CADDY_ALREADY_ISSUED = 'CADDY_ALREADY_ISSUED',
  INVALID_CADDY_ID = 'INVALID_CADDY_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  STENCILS_NOT_IN_ROD_REQUEST = 'STENCILS_NOT_IN_ROD_REQUEST',
  UPDATE_CADDY_MUTATION_ERROR = 'UPDATE_CADDY_MUTATION_ERROR'
}

/** Input details required for updating a caddy */
export type UpdateCaddyInput = {
  /** Caddy Id */
  caddyId: Scalars['ID']['input'];
  /** Rod diameter and heat lot number */
  fillerMaterialDiameterDetailId: Array<Scalars['ID']['input']>;
  /** Filler material for the caddy */
  fillerMaterialId: Scalars['ID']['input'];
  /** Id */
  id: Scalars['ID']['input'];
  /** Stencils for the request */
  issuedToStencilIds: Array<Scalars['ID']['input']>;
  /** Picked up user crewMember id.  */
  pickedUpBy: Scalars['ID']['input'];
};

/** Updated Caddy response payload */
export type UpdateCaddyPayload = {
  caddy?: Maybe<RodRequestCaddy>;
  error?: Maybe<UpdateCaddyErrorCode>;
};

export enum UpdateCommodityError {
  COMMODITY_ALREADY_APPROVED = 'COMMODITY_ALREADY_APPROVED',
  EDIT_WELD_DETAIL_ERRORED = 'EDIT_WELD_DETAIL_ERRORED',
  INVALID_COMMODITY_ID = 'INVALID_COMMODITY_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  STENCILS_ARE_REQUIRED = 'STENCILS_ARE_REQUIRED',
  WELD_PROCEDUREID_REQUIRED = 'WELD_PROCEDUREID_REQUIRED'
}

export type UpdateCommodityInput = {
  commodityId: Scalars['ID']['input'];
  /** The location in latitude and longitude where this was welded. This is not mandatory right now but will be when we do ArcStryker. */
  location?: InputMaybe<CommodityLocationInput>;
  /** An optional comment on where weld is located on the job site. */
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Ids of the welders that participated in the welding. */
  stencilIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Which weld procedure was used for installation. Must match one of the applicable weld procedures of the weld. */
  weldProcedureIds: Array<Scalars['ID']['input']>;
};

export enum UpdateCommodityLocationDescriptionError {
  COMMODITY_ALREADY_APPROVED = 'COMMODITY_ALREADY_APPROVED',
  INVALID_COMMODITY_ID = 'INVALID_COMMODITY_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  UPDATE_LOCATION_DESCRIPTION_ERRORED = 'UPDATE_LOCATION_DESCRIPTION_ERRORED'
}

export type UpdateCommodityLocationDescriptionInput = {
  commodityId: Scalars['ID']['input'];
  locationDescription: Scalars['String']['input'];
};

export type UpdateCommodityLocationDescriptionPayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<UpdateCommodityLocationDescriptionError>;
};

export type UpdateCommodityPayload = {
  commodity?: Maybe<CommodityWrapper>;
  error?: Maybe<UpdateCommodityError>;
};

/** Input details required for updating commodity */
export type UpdateCommodityProgressInput = {
  /** Progressed by user id */
  progressedByUserId: Scalars['ID']['input'];
  /** Stencil request */
  progressedWelds: Array<CommodityProgressDetailInput>;
  /** Stencil Id */
  stencilId: Scalars['ID']['input'];
};

export enum UpdateDataflowEntityMappingError {
  DUPLICATE_MAPPING_FOUND = 'DUPLICATE_MAPPING_FOUND',
  ENTITY_MAPPINGS_NOT_FOUND = 'ENTITY_MAPPINGS_NOT_FOUND',
  INVALID_ENTITY_REGISTRY = 'INVALID_ENTITY_REGISTRY',
  INVALID_PROJECT_ID = 'INVALID_PROJECT_ID',
  INVALID_RECEIVER_CODE_DATA_TYPE = 'INVALID_RECEIVER_CODE_DATA_TYPE',
  INVALID_SENDER_CODE_DATA_TYPE = 'INVALID_SENDER_CODE_DATA_TYPE',
  MAPPING_ID_NOT_FOUND = 'MAPPING_ID_NOT_FOUND',
  UPDATE_DATAFLOW_ENTITY_MAPPING_ERRORED = 'UPDATE_DATAFLOW_ENTITY_MAPPING_ERRORED'
}

export type UpdateDataflowEntityMappingInput = {
  dataflowDirection?: InputMaybe<DataflowDirection>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFilter?: InputMaybe<Scalars['Boolean']['input']>;
  isReceiverFieldKey?: InputMaybe<Scalars['Boolean']['input']>;
  isSenderFieldKey?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  projectsDataflowEntityRegistryId?: InputMaybe<Scalars['ID']['input']>;
  receiverFieldDataType?: InputMaybe<Scalars['String']['input']>;
  receiverFieldDescription?: InputMaybe<Scalars['String']['input']>;
  receiverFieldPath?: InputMaybe<Scalars['String']['input']>;
  senderFieldDataType?: InputMaybe<Scalars['String']['input']>;
  senderFieldDescription?: InputMaybe<Scalars['String']['input']>;
  senderFieldPath?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDataflowEntityMappingPayload = {
  dataflowEntityMappings?: Maybe<Array<DataflowEntityMapping>>;
  errors?: Maybe<Array<UpdateDataflowEntityMappingsError>>;
};

export type UpdateDataflowEntityMappingsError = {
  DataflowEntityMappingErrorPayload?: Maybe<DataflowEntityMappingErrorPayload>;
  errorCodes?: Maybe<Array<UpdateDataflowEntityMappingError>>;
};

/** Error code while updating a default permission */
export enum UpdateDefaultPermissionError {
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND'
}

export type UpdateDefaultPermissionInput = {
  id: Scalars['ID']['input'];
  permissionScopeId: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

/** Payload returned on call to updateDefaultPermission. */
export type UpdateDefaultPermissionPayload = {
  error?: Maybe<UpdateDefaultPermissionError>;
  permission?: Maybe<DefaultRolePermission>;
};

export enum UpdateModuleError {
  NOT_FOUND = 'NOT_FOUND'
}

export type UpdateModuleInput = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type UpdateModulesPayload = {
  error?: Maybe<UpdateModuleError>;
  modules: Array<AppModule>;
};

export enum UpdatePermissionError {
  NOT_FOUND = 'NOT_FOUND'
}

export type UpdatePermissionInput = {
  moduleId: Scalars['ID']['input'];
  permissionId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  scopeId: Scalars['ID']['input'];
};

export type UpdatePermissionPayload = {
  error?: Maybe<UpdatePermissionError>;
  rolePermissions: Array<AuthRole>;
};

export type UpdateProjectCommodityTypeInput = {
  calculationConfig?: InputMaybe<Scalars['String']['input']>;
  /** Project related commodity type */
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  isItrApplicable: Scalars['Boolean']['input'];
  lobCommodityCode: Scalars['String']['input'];
  lobCommodityTypeId: Scalars['String']['input'];
  lobTemplateCode: Scalars['String']['input'];
  lobTemplateTypeId: Scalars['String']['input'];
  /** Commodity material tracking */
  materialTrackingTypeId?: InputMaybe<MaterialTrackingCode>;
  /** Commodity type display name */
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
  unitOfMeasure: UnitOfMeasure;
};

export enum UpdateProjectErrorCode {
  EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT = 'EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT',
  INVALID_COUNTRY = 'INVALID_COUNTRY',
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  INVALID_LANGUAGE = 'INVALID_LANGUAGE',
  INVALID_STATE = 'INVALID_STATE',
  INVALID_SUPPORT_USER = 'INVALID_SUPPORT_USER',
  INVALID_TIME_FORMAT = 'INVALID_TIME_FORMAT',
  INVALID_TIME_ZONE = 'INVALID_TIME_ZONE',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  UPDATE_PROJECT_ERRORED = 'UPDATE_PROJECT_ERRORED'
}

export type UpdateProjectInput = {
  /** Application support information */
  applicationSupportInfo?: InputMaybe<Scalars['String']['input']>;
  /** Project country */
  countryId: Scalars['ID']['input'];
  /** Date format of the project */
  dateFormatId: Scalars['ID']['input'];
  /** ISO Document prefix list */
  isoDocumentPrefixList?: InputMaybe<Scalars['String']['input']>;
  /** Language of the project */
  languageId: Scalars['ID']['input'];
  /** Project location */
  location: Scalars['String']['input'];
  /** List of attachment inputs for this block. */
  logoAttachmentMetadata?: InputMaybe<AttachmentMetadataInput>;
  /** Project name */
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  /** Support users of the project */
  projectSupportUsers?: InputMaybe<Array<ProjectSupportUserInput>>;
  /** Project Configuration */
  projectlocation: ProjectLocationInput;
  /** Project state */
  stateId: Scalars['ID']['input'];
  /** Time format of the project */
  timeFormatId: Scalars['ID']['input'];
  /** Time zone id of the project */
  timeZoneId: Scalars['ID']['input'];
};

export type UpdateProjectMilestoneTypeInput = {
  approvalFieldName: Scalars['String']['input'];
  approvedByFieldName: Scalars['String']['input'];
  calculationConfig?: InputMaybe<Scalars['String']['input']>;
  claimFieldName: Scalars['String']['input'];
  claimedByFieldName: Scalars['String']['input'];
  lobConnectionType?: InputMaybe<Scalars['String']['input']>;
  lobMilestoneTypeId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  planFieldName: Scalars['String']['input'];
  plannedByFieldName: Scalars['String']['input'];
  projectMilestoneTypeId: Scalars['ID']['input'];
};

export type UpdateProjectPayload = {
  error?: Maybe<UpdateProjectErrorCode>;
  project?: Maybe<Project>;
};

/** Error code while updating a project permission */
export enum UpdateProjectPermissionError {
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND'
}

export type UpdateProjectPermissionInput = {
  id: Scalars['ID']['input'];
  moduleTypeId: Scalars['ID']['input'];
  permissionId: Scalars['ID']['input'];
  projectRoleId: Scalars['ID']['input'];
  scopeId: Scalars['ID']['input'];
};

/** Payload returned on call to updateProjectPermission. */
export type UpdateProjectPermissionPayload = {
  error?: Maybe<UpdateProjectPermissionError>;
  roles: Array<AuthRole>;
};

export enum UpdateProjectReportError {
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOTHING_TO_UPDATE = 'NOTHING_TO_UPDATE',
  UPDATE_REPORT_ERRORED = 'UPDATE_REPORT_ERRORED'
}

export type UpdateProjectReportInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  powerbiUrl: Scalars['String']['input'];
};

export type UpdateProjectReportPayload = {
  /** Error in Update */
  error?: Maybe<UpdateProjectReportError>;
  /** Project Report details */
  projectReport?: Maybe<ProjectReport>;
};

/** Error code while updating a rod request */
export enum UpdateRodRequestErrorCode {
  COMMENT_TOO_LARGE = 'COMMENT_TOO_LARGE',
  FILLER_MATERIAL_CANNOT_REMOVED_CADDY_ALREADY_ISSUED = 'FILLER_MATERIAL_CANNOT_REMOVED_CADDY_ALREADY_ISSUED',
  FILLER_MATERIAL_MISSING = 'FILLER_MATERIAL_MISSING',
  INVALID_ROD_REQUEST_ID = 'INVALID_ROD_REQUEST_ID',
  INVALID_ROD_ROOM_ID = 'INVALID_ROD_ROOM_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  ROD_REQUEST_ALREADY_CLOSED = 'ROD_REQUEST_ALREADY_CLOSED',
  ROD_REQUEST_ALREADY_DELETED = 'ROD_REQUEST_ALREADY_DELETED',
  ROD_ROOM_CANNOT_MODIFY_CADDY_ALREADY_ISSUED = 'ROD_ROOM_CANNOT_MODIFY_CADDY_ALREADY_ISSUED',
  STENCIL_CANNOT_UNASSIGN_CADDY_ALREADY_ISSUED = 'STENCIL_CANNOT_UNASSIGN_CADDY_ALREADY_ISSUED',
  UPDATE_ROD_REQUEST_ERRORED = 'UPDATE_ROD_REQUEST_ERRORED',
  WELD_PROCEDURE_NOT_APPLICABLE = 'WELD_PROCEDURE_NOT_APPLICABLE'
}

/** Input details required for updating a rod request */
export type UpdateRodRequestInput = {
  /** Comments can be updated only by the owner of either the Weld or Rod Request */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Filler Materials for the request */
  fillerMaterialDiameterIds: Array<Scalars['ID']['input']>;
  /** Pickup time of the request */
  pickUpTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Rod Request Id */
  rodRequestId: Scalars['ID']['input'];
  /** Pickup location */
  rodRoomId?: InputMaybe<Scalars['ID']['input']>;
  /** Stencils for the request */
  stencilIds: Array<Scalars['ID']['input']>;
  /** Weld Ids */
  weldIds: Array<Scalars['ID']['input']>;
  /** Weld Procedure Id, can be updated only by the owner of either the Weld or Rod Request */
  weldProcedureId?: InputMaybe<Scalars['ID']['input']>;
};

/** Created rod request */
export type UpdateRodRequestPayload = {
  error?: Maybe<UpdateRodRequestErrorCode>;
  rodRequest?: Maybe<RodRequest>;
};

/** Error code while updating a rod request */
export enum UpdateRodRoomErrorCode {
  INVALID_ELEVATION_VALUE = 'INVALID_ELEVATION_VALUE',
  INVALID_LATITUDE_VALUE = 'INVALID_LATITUDE_VALUE',
  INVALID_LONGITUDE_VALUE = 'INVALID_LONGITUDE_VALUE',
  INVALID_ROD_ROOM_ID = 'INVALID_ROD_ROOM_ID',
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOTHING_TO_UPDATE = 'NOTHING_TO_UPDATE',
  UPDATE_ROD_ROOM_ERRORED = 'UPDATE_ROD_ROOM_ERRORED'
}

export type UpdateRodRoomInput = {
  /** Elevation for Rod Room */
  elevation?: InputMaybe<Scalars['Float']['input']>;
  /** Flag that indicates if this rodRoom is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Latitude for Rod Room */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude for Rod Room */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Description for Rod Room */
  rodRoomDescription?: InputMaybe<Scalars['String']['input']>;
  /** rod room id */
  rodRoomId: Scalars['ID']['input'];
  /** rom room name */
  rodRoomName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRodRoomPayload = {
  error?: Maybe<UpdateRodRoomErrorCode>;
  rodRoom?: Maybe<RodRoom>;
};

export enum UpdateRoleError {
  DEFAULT_ROLE_CAN_NOT_BE_MODIFIED = 'DEFAULT_ROLE_CAN_NOT_BE_MODIFIED',
  NOT_FOUND = 'NOT_FOUND',
  ROLE_ALREADY_EXISTS = 'ROLE_ALREADY_EXISTS'
}

export type UpdateRoleInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateRolePayload = {
  error?: Maybe<UpdateRoleError>;
  role?: Maybe<AuthRole>;
};

/** Error code while updating stencil progress */
export enum UpdateStencilErrorCode {
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR'
}

export enum UpdateUserError {
  INVALID_DISCIPLINE_ID = 'INVALID_DISCIPLINE_ID',
  INVALID_ROLE_ID = 'INVALID_ROLE_ID',
  MISSING_ROLE_ID = 'MISSING_ROLE_ID',
  MISSING_USER_BECIMSID = 'MISSING_USER_BECIMSID',
  NOT_FOUND = 'NOT_FOUND',
  UPDATE_USER_ERRORED = 'UPDATE_USER_ERRORED'
}

export type UpdateUserInput = {
  /** BECIMS ID */
  becImsId?: InputMaybe<Scalars['String']['input']>;
  /** Company Id */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** Facilities/Areas */
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Is user active */
  isActive: Scalars['Boolean']['input'];
  /** The roles to assign to the specified user */
  roleIds: Array<Scalars['ID']['input']>;
  /** The user to assign roles to */
  userId: Scalars['ID']['input'];
  /** The disciplines to assign to the specified user */
  workPackageDisciplineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateUserPayload = {
  /** Error in update */
  error?: Maybe<UpdateUserError>;
  /** User details */
  user?: Maybe<User>;
};

export enum UpdateUserStatusError {
  NOT_FOUND = 'NOT_FOUND',
  UPDATE_USER_STATUS_ERRORED = 'UPDATE_USER_STATUS_ERRORED'
}

export type UpdateUserStatusInput = {
  isActive: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateUserStatusPayload = {
  /** Error in update */
  error?: Maybe<UpdateUserStatusError>;
  /** User details */
  user?: Maybe<User>;
};

export enum UpdateWorkPackageDisciplineError {
  INVALID_DISCIPLINE_PROVIDED = 'INVALID_DISCIPLINE_PROVIDED',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  UPDATE_WORK_PACKAGE_DISCIPLINE_ERRORED = 'UPDATE_WORK_PACKAGE_DISCIPLINE_ERRORED'
}

export type UpdateWorkPackageDisciplineInput = {
  id: Scalars['ID']['input'];
  status: Scalars['Boolean']['input'];
};

export type UpdateWorkPackageDisciplinesPayload = {
  disciplines?: Maybe<Array<WorkPackageDiscipline>>;
  error?: Maybe<UpdateWorkPackageDisciplineError>;
};

export type UpdateWorkPackageScheduleError = {
  errorCode?: Maybe<UpdateWorkPackageScheduleErrorCode>;
  workPackageId: Scalars['ID']['output'];
};

export enum UpdateWorkPackageScheduleErrorCode {
  EIS_ERROR = 'EIS_ERROR',
  INVALID_DATES = 'INVALID_DATES',
  INVALID_WORK_PACKAGE_ID = 'INVALID_WORK_PACKAGE_ID',
  SERVICE_PROXY_ERROR = 'SERVICE_PROXY_ERROR',
  UPDATE_WORK_PACKAGE_SCHEDULE_ERRORED = 'UPDATE_WORK_PACKAGE_SCHEDULE_ERRORED'
}

export type UpdateWorkPackageScheduleInput = {
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  workPackageFilterInput?: InputMaybe<WorkPackageFilterInput>;
  workPackageIds: Array<Scalars['ID']['input']>;
};

export type UpdateWorkPackageSchedulePayload = {
  erroredWorkPackages?: Maybe<Array<Maybe<UpdateWorkPackageScheduleError>>>;
  unplannedMilestones?: Maybe<Array<CommodityMilestone>>;
  workPackages?: Maybe<Array<WorkPackage>>;
};

export type User = {
  appTypeId?: Maybe<Scalars['String']['output']>;
  becImsId?: Maybe<Scalars['String']['output']>;
  /** BUN of the user */
  bun?: Maybe<Scalars['String']['output']>;
  /** can user emulate with other users */
  canEmulate?: Maybe<Scalars['Boolean']['output']>;
  /** Company of the user */
  company?: Maybe<Company>;
  /** User record created by */
  createdBy?: Maybe<User>;
  /** Crew Member */
  crewMember: CrewMember;
  /** List of disciplines assigned to this user. */
  disciplines?: Maybe<Array<WorkPackageDiscipline>>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** eTrackId of the user if the user is present in eTrack */
  etrackId?: Maybe<Scalars['String']['output']>;
  /** List of facilities assigned to this user. */
  facilities?: Maybe<Array<Facility>>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Is user active */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Mobile carrier of user's phone */
  mobileCarrier?: Maybe<Scalars['String']['output']>;
  /**
   * Employee firstname from EIP
   * @deprecated Field is deprecated!
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * List of all permissions(with scope) assigned to this user.
   * @deprecated This field is deprecated, use appPermissions instead!
   */
  permissionScopes: Array<PermissionScope>;
  /** App Permissions for this user */
  permissions: Array<AuthPermissionScope>;
  /** Phone number of the user */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Default Project Id */
  project?: Maybe<Project>;
  /** Blocks assigned for the user */
  relatedBlocks?: Maybe<BlockList>;
  /** List of roles assigned to this user. */
  roles: Array<AuthRole>;
  /** Supervisor of the user */
  supervisor?: Maybe<User>;
  /** User record last updated at */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User preferences */
  userPreference?: Maybe<UserPreference>;
};


export type UserRelatedBlocksArgs = {
  paging?: InputMaybe<PagingInput>;
};

export type UserFilterInput = {
  /** Company Ids */
  filterByCompanyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Facility Ids */
  filterByFacilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Role Ids */
  filterByRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search Keyword */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  /** Sort By Term */
  sortBy: UserSortByTerm;
  /** Sort Order */
  sortOrder?: InputMaybe<SortOrder>;
  userStatus?: InputMaybe<UserStatus>;
};

export type UserList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<User>;
  total: Scalars['Int']['output'];
};

export type UserPreference = {
  language?: Maybe<Scalars['String']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
};

export enum UserSortByTerm {
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME'
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type UsersImportPayload = {
  crewCount?: Maybe<Scalars['Int']['output']>;
  importStatus: Scalars['String']['output'];
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type WeeklyCrewStat = {
  crewMember: CrewMember;
  /** Number of blocks the crew member is associated with */
  numBlocks: Scalars['Int']['output'];
  /** Total head count */
  numCrewMembers: Scalars['Int']['output'];
  /** Number of work packaged assigned */
  numWorkPackages: Scalars['Int']['output'];
  /** Weekly milestone stats */
  weeklyMilestoneStats: Array<WeeklyMilestoneStats>;
};

export type WeeklyCrewStatInput = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  /**
   * The user for whom the crew level look ahead data to be loaded(to support drilling down).
   * Leave empty if it's for the logged in user.
   */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type WeeklyLookAheadStats = {
  /** Approved milestone stats for the planning week(in plan & out of plan) */
  approvedMilestoneStats: MilestoneStats;
  /** Claimed In Plan milestone stats for the planning week */
  claimedInPlanMilestoneStats: MilestoneStats;
  /** Claimed milestone stats for the planning week(in plan & out of plan) */
  claimedMilestoneStats: MilestoneStats;
  /**
   * Locked in plan from beginning of the week
   * @deprecated no longer needed for FE
   */
  committedMilestoneStats: MilestoneStats;
  earningsInPlan: Scalars['Int']['output'];
  /** The end date of this planning week */
  endDate: Scalars['Date']['output'];
  /** Internal ID for Planning Week */
  id: Scalars['ID']['output'];
  /** Planned milestone stats for the planning week. */
  plannedMilestoneStats: MilestoneStats;
  planningInTarget: Scalars['Int']['output'];
  /** The starting date of this planning week */
  startDate: Scalars['Date']['output'];
  /** Target  stats for the planning week. */
  target: MilestoneStats;
  /** Week number of year */
  weekNumber: Scalars['Int']['output'];
  /** The Calendar Year */
  year: Scalars['Int']['output'];
};

export type WeeklyLookAheadStatsByPersona = {
  crewMember: CrewMember;
  weeklyLookAheadStats?: Maybe<Array<WeeklyLookAheadStats>>;
};

export type WeeklyMilestoneAnalysis = {
  cumulativeMilestoneHours: Scalars['Int']['output'];
  cumulativeMilestoneQuantity: Scalars['Float']['output'];
  dailyAverage: Scalars['Int']['output'];
  dailyAverageQuantity: Scalars['Float']['output'];
  earningsInPlan: Scalars['Int']['output'];
  targetHours: Scalars['Int']['output'];
  targetQuantity: Quantity;
};

export type WeeklyMilestoneProgress = {
  milestoneProgress: Array<DailyMilestoneProgress>;
  weeklyMilestoneAnalysis: WeeklyMilestoneAnalysis;
};

export type WeeklyMilestoneProgressInput = {
  /** CrewMemberId of the selected persona */
  crewMemberId?: InputMaybe<Scalars['ID']['input']>;
  /** Check to get data for All Crew members of the persona input */
  isAllCrewMembers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Selected Persona type */
  persona: PersonaType;
  /** Planning week Id */
  planningWeekId: Scalars['ID']['input'];
  /** Milestone status */
  status: MilestoneStatusCode;
};

export type WeeklyMilestoneStats = {
  /** Claimed in this week */
  claimed?: Maybe<MilestoneStats>;
  /** End of the week */
  endDate: Scalars['Date']['output'];
  pctPlanned: Scalars['Int']['output'];
  /** Planned for this week */
  planned?: Maybe<MilestoneStats>;
  /** Start of the week */
  startDate: Scalars['Date']['output'];
  target?: Maybe<MilestoneStats>;
  unclaimed?: Maybe<MilestoneStats>;
};

export type WeeklyWorkInput = {
  crewMemberId: Scalars['ID']['input'];
  /** End date of the week, leave empty only for pending approval list */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Array of Project commodity type ids */
  filterByCommodityTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Milestone status code */
  filterByMilestoneStatus: MilestoneStatusCode;
  /** Array of milestone type ids */
  filterByMilestoneTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter By In Plan & Out Of Plan Milestones */
  filterByPlanStatus?: InputMaybe<Array<InputMaybe<WeeklyWorkListFilterByPlanStatus>>>;
  ownershipLevel: OwnershipLevel;
  personaType: PersonaType;
  /** Text search by workpackage/tag or cost code */
  searchByField?: InputMaybe<WeeklyWorkListSearchBy>;
  /** Search text value */
  searchValue?: InputMaybe<Scalars['String']['input']>;
  /** Sort by term */
  sortBy: WeeklyWorkListSortByTerm;
  /** Sort Order By */
  sortOrder: SortOrder;
  /** Start date of the week, leave empty only for pending approval list */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Leave empty when data for all work packages are needed */
  workPackageIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WeeklyWorkList = {
  items: Array<CommodityMilestone>;
  /** Row number of the last record in the list */
  rowNumber: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WeeklyWorkListBulk = {
  items: Array<WeeklyWorkListBulkItem>;
  rowNumber: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WeeklyWorkListBulkItem = {
  commodityType: Scalars['String']['output'];
  costCodeId?: Maybe<Scalars['String']['output']>;
  fieldEngineer?: Maybe<Scalars['String']['output']>;
  foreman?: Maybe<Scalars['String']['output']>;
  generalForeman?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  milestoneType: Scalars['String']['output'];
  planWeekNumber?: Maybe<Scalars['Int']['output']>;
  quantityHours: Scalars['Int']['output'];
  superintendent?: Maybe<Scalars['String']['output']>;
  tag: Scalars['String']['output'];
  workPackageNumber: Scalars['String']['output'];
};

export enum WeeklyWorkListFilterByPlanStatus {
  IN_PLAN = 'IN_PLAN',
  OUT_OF_PLAN = 'OUT_OF_PLAN'
}

export enum WeeklyWorkListSearchBy {
  TAG_ID = 'TAG_ID',
  USER_ID = 'USER_ID',
  WORKPACKAGE = 'WORKPACKAGE'
}

export enum WeeklyWorkListSortByTerm {
  MILESTONE_TYPE = 'MILESTONE_TYPE',
  TAG = 'TAG',
  WP_NUMBER = 'WP_NUMBER'
}

export type WeeklyWorkStats = {
  /** Total hours approved */
  approvedHours: Scalars['Int']['output'];
  /** Total hours claimed */
  claimedHours: Scalars['Int']['output'];
  crewMemberId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Counts of milestones by type */
  milestoneCountsByType?: Maybe<Array<MilestoneTypeCount>>;
  /** Number of approved milestones */
  numApproved: Scalars['Int']['output'];
  /** Number of claimed milestones */
  numClaimed: Scalars['Int']['output'];
  /** Number of pending milestones */
  numPlanned?: Maybe<Scalars['Int']['output']>;
  ownershipLevel: OwnershipLevel;
  personaType: PersonaType;
  /** Total hours un-claimed */
  unclaimedHours?: Maybe<Scalars['Int']['output']>;
};

export type WeeklyWorkSummary = {
  /** Total hours claimed */
  claimedHours: Scalars['Int']['output'];
  /** Total quantity claimed */
  claimedQuantity: Quantity;
  /** Counts of milestones by type(resolved only for 'FOREMAN' persona) */
  milestoneCountsByType?: Maybe<Array<MilestoneTypeCount>>;
  /** Number of claimed milestones */
  numClaimed: Scalars['Int']['output'];
  /** Number of pending milestones */
  numPlanned: Scalars['Int']['output'];
  /** Total quantity un-claimed */
  unClaimedQuantity: Quantity;
  /** Total hours un-claimed */
  unclaimedHours: Scalars['Int']['output'];
};

export type Weld = {
  /** The list of applicable weld procedures that can be used to install this weld. Weld Claim must choose from these only. */
  applicableWeldProcedures: Array<WeldProcedure>;
  /** Area number for this commodity */
  areaNumber?: Maybe<Scalars['String']['output']>;
  /** Reference of Spool/BulkPipe of which it is weld of (equivalent TeamWorks filed name). */
  associatedCommodityId?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  /** List of personas assigned to Weld */
  commodityAssignees?: Maybe<Array<CommodityAssignee>>;
  /** Cost Code of the Commodity */
  costCodeId?: Maybe<Scalars['String']['output']>;
  /**
   * Current milestone status, is determined by the latest status change on a milestone within the commodity
   * @deprecated Use currentMilestoneType to determine latest milestone status
   */
  currentMilestoneStatus?: Maybe<MilestoneStatus>;
  /** Current milestone type */
  currentMilestoneType: ProjectMilestoneType;
  /** Total sum of approved hours for all milestones in this commodity. */
  earnedHours: Scalars['Float']['output'];
  /** Total sum of approved LF/LM for all milestones in this commodity. */
  earnedQuantity: Scalars['Float']['output'];
  /** Forecast end date of the commodity */
  endDate?: Maybe<Scalars['Datetime']['output']>;
  /** Expired RodRequest Count */
  expiredRodRequestCount?: Maybe<Scalars['Int']['output']>;
  /** Facility of this commodity */
  facility?: Maybe<Facility>;
  /** Fitup request of the weld */
  fitupRequest?: Maybe<FitupRequest>;
  /** Commodity Assignment Status */
  hasAssignedForeman?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier of the commodity */
  id: Scalars['ID']['output'];
  /** Fitup Required flag of latest fitup request for weld irrespective of fitup is active or not */
  isFitupRequired?: Maybe<Scalars['Boolean']['output']>;
  /** NDE Required */
  isNDERequired?: Maybe<Scalars['Boolean']['output']>;
  /** PriorityWeld, determines this weld is priority weld */
  isPriority?: Maybe<Scalars['Boolean']['output']>;
  /** Iso Document of the Weld */
  isoDocument?: Maybe<IsoDocument>;
  /** Boolean flag when true indicates that this Weld requires Inspection and Test record aka Pipe Cleanliness self certification before Fitup/Installation requested/claimed/reclaimed */
  itrRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Geo Location of the weld that can be used to plot the weld on a map. */
  location?: Maybe<GeoLocation>;
  /** Location description of the Commodity */
  locationDescription?: Maybe<Scalars['String']['output']>;
  /** Material status for the commodity */
  materialStatusI18n?: Maybe<MaterialStatus>;
  /** List of milestones for the commodity */
  milestones: Array<CommodityMilestone>;
  /** History of status changes on the milestones. */
  milestonesActivityHistory?: Maybe<CommodityMilestoneActivityList>;
  /** The pipe diameter on which the weld has to be performed. */
  pipeDiameter?: Maybe<Scalars['Float']['output']>;
  /** The pipe material for the weld. */
  pipeMaterial?: Maybe<Scalars['String']['output']>;
  /** milestone planned end date */
  plannedEndDate?: Maybe<Scalars['Datetime']['output']>;
  /** milestone planned start date */
  plannedStartDate?: Maybe<Scalars['Datetime']['output']>;
  /** Commodity spec reference data */
  sections: Array<CommoditySection>;
  /** Forecast start date of this commodity */
  startDate?: Maybe<Scalars['Datetime']['output']>;
  /** Startup number for this commodity */
  startupNumber?: Maybe<Scalars['String']['output']>;
  /** Current status at commodity level */
  status?: Maybe<CommodityStatus>;
  /** Tag number of the commodity */
  tag: Scalars['String']['output'];
  /** Total sum of hours for all milestones in this commodity. */
  totalEarnableHours: Scalars['Float']['output'];
  /** Total sum of hours for all milestones in this commodity along with unit of measure */
  totalEarnableQuantity: Quantity;
  /** Name of the commodity */
  type: CommodityType;
  /** The weld procedure that was used to finish this weld's installation */
  weldedWithProcedure: Array<WeldProcedure>;
  /** Workpackage of the commodity */
  workPackage?: Maybe<WorkPackage>;
};


export type WeldAttachmentsArgs = {
  attachmentType?: InputMaybe<AttachmentType>;
};


export type WeldMilestonesActivityHistoryArgs = {
  paging?: InputMaybe<PagingInput>;
};

export type WeldForemanInput = {
  /** commodity id for weld commodity */
  commodityId: Scalars['ID']['input'];
  /** eTrack id of the foreman (leave it empty to unassign) */
  foremanId?: InputMaybe<Scalars['ID']['input']>;
  /** Weld commodity type ID */
  typeId: Scalars['ID']['input'];
};

export enum WeldOrganization {
  /** Project has dedicated welding crews and welders embedded in Piping crews */
  HYBRID = 'HYBRID',
  /** Welders are embedded in Piping Crews */
  PIPING_CREW_WELDERS = 'PIPING_CREW_WELDERS',
  /** Project has a pool of dedicated welding crews led by a welding foreman */
  WELD_POOL = 'WELD_POOL'
}

export type WeldProcedure = {
  /** Unique Identifier */
  id: Scalars['ID']['output'];
  procedure: Scalars['String']['output'];
  rodFillerMaterials?: Maybe<Array<RodFillerMaterial>>;
};

export type WeldProcedureInput = {
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  weldProcedureIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WeldProcedureList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<WeldProcedure>;
  total: Scalars['Int']['output'];
};

export type WeldProcedureSubscriptionPayload = {
  weldProcedureIds: Array<Scalars['ID']['output']>;
};

/** All configuration related to weld program management in a project */
export type WeldProgramConfig = {
  /** Manage Fit-Up request workflow before completion of welds? */
  fitUpWorkflowEnabled: Scalars['Boolean']['output'];
  /** How are welders organized in your project? */
  weldOrganization: WeldOrganization;
};

export type WeldProgressStatusStats = {
  stats: Scalars['Int']['output'];
  status: RodRequestWeldStatus;
};

export type WeldProgressStatusStatsSummary = {
  numWelds: Scalars['Int']['output'];
  weldStatSummary: Array<WeldProgressStatusStats>;
};

export enum WeldSetupType {
  NO_TEMPLATE_CODE = 'NO_TEMPLATE_CODE',
  TEMPLATE_CODE = 'TEMPLATE_CODE'
}

export type WeldStatus = {
  codeI18n: MilestoneStatusCode;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<CrewMember>;
  id?: Maybe<Scalars['ID']['output']>;
  rejectionType?: Maybe<ProjectMilestoneTypeRejectionReason>;
};

export type WeldStatusInfo = {
  id: Scalars['ID']['output'];
  status: CommodityStatusCode;
};

export type WorkPackage = {
  /** Rolled up list of documents from all the commodities. */
  allDocuments: Array<IsoDocument>;
  /** List of persisted attachment for this workpackage. */
  attachments: Array<Attachment>;
  /** Commodity types available for the workpackage */
  availableCommodityTypes: Array<CommodityType>;
  /** Book Url */
  bookUrl?: Maybe<Scalars['String']['output']>;
  commodities: CommodityList;
  commodityMilestones?: Maybe<CommodityMilestoneList>;
  /** Total sum of approved hours for all milestones in all commodities. */
  earnedHours: Scalars['Float']['output'];
  /** Total sum of approved LF/LM for all milestones in all commodities. */
  earnedQuantity: Scalars['Float']['output'];
  /** The last date of the week this work package is planned for. */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** Whether this work package's discipline has an active PipeFighter (PF) mapping. */
  existsInPipeFighter: Scalars['Boolean']['output'];
  /** The facilities of this work package */
  facilities?: Maybe<Array<Facility>>;
  id: Scalars['ID']['output'];
  /** The last time this work package was updated */
  lastUpdated: Scalars['Datetime']['output'];
  /** Material for this work package */
  materials?: Maybe<Array<Material>>;
  /** The material on site for this work package. */
  materialsOnSite?: Maybe<Array<MaterialOnSite>>;
  milestoneActivityStats: Array<MilestoneActivityStatsByCommodityType>;
  /** The total number of blocks that are currenly open for this work package. */
  numBlocks: Scalars['Int']['output'];
  /** The total rejections for this work package */
  numRejects: Scalars['Int']['output'];
  /** (Not implemented yet) Other owners of the workpackage(to handle multiple shifts) */
  otherOwners: Array<CrewMemberAssignment>;
  /** Percentage of hours of milestones which are claimed vs total across all commodities in this work package. */
  percentageComplete?: Maybe<Scalars['Float']['output']>;
  /** Total planned hours for a workpackage */
  plannedHours?: Maybe<Scalars['Float']['output']>;
  /** Farthest date any milestone is planned for within a workpackage */
  plannedMilestoneEndDate?: Maybe<Scalars['Date']['output']>;
  /** Earliest date any milestone is planned for within a workpackage */
  plannedMilestoneStartDate?: Maybe<Scalars['Date']['output']>;
  /** Crew members assigned to this work package as primary owners */
  primaryOwners: Array<CrewMemberAssignment>;
  /** Get owner-wise quantity details of specific work package */
  quantityDetails: QuantityDetails;
  /** (Not implemented yet) Crew members assigned to this work package as secondary owners */
  secondaryOwners: Array<CrewMemberAssignment>;
  /** The starting date of the week this work package is planned for. */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** Tag number for the work package. */
  tag: Scalars['String']['output'];
  /** Total sum of hours for all milestones in all commodities. */
  totalEarnableHours: Scalars['Float']['output'];
  /** Total sum of Quantity for all milestones in all commodities along with unit of measure. */
  totalEarnableQuantity: Quantity;
};


export type WorkPackageCommoditiesArgs = {
  input?: InputMaybe<CommodityFilterInput>;
  paging?: InputMaybe<PagingInput>;
};


export type WorkPackageCommodityMilestonesArgs = {
  input: MilestonesFilterInput;
  paging?: InputMaybe<PagingInput>;
};


export type WorkPackageMilestoneActivityStatsArgs = {
  input: MilestonesActivityStatsFilterInput;
};

export type WorkPackageDiscipline = {
  /** Flag to allow any sequence claim config */
  allowAnySequenceClaim: Scalars['Boolean']['output'];
  filterConfig?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  /** Flag that indicates if this Discipline is active */
  isActive: Scalars['Boolean']['output'];
  /** Disipline Id from Lob application. For eg. PIPING-AG-LB */
  lobDisciplineId: Scalars['String']['output'];
  /** Description of the discipline. For eg. PIPING – Above Ground LB */
  name?: Maybe<Scalars['String']['output']>;
  /** Last updated at */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<CrewMember>;
};

export type WorkPackageDisciplineConfigInput = {
  /** work package disciplines config to allow user to claim milestones in any order */
  allowAnySequenceClaim: Scalars['Boolean']['input'];
  /** work package discipline id */
  id: Scalars['ID']['input'];
};

export type WorkPackageError = {
  id: Scalars['ID']['output'];
};

export enum WorkPackageFilterByTerm {
  ACTIVE = 'ACTIVE',
  ALL = 'ALL',
  COMPLETED = 'COMPLETED',
  IN_3WLA = 'IN_3WLA',
  NIGHT_SHIFT = 'NIGHT_SHIFT',
  SCHEDULED = 'SCHEDULED',
  UNSCHEDULED = 'UNSCHEDULED'
}

export type WorkPackageFilterInput = {
  /** Assigned to the signed in user */
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** End date for the date range */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter By Term */
  filterBy?: InputMaybe<WorkPackageFilterByTerm>;
  /** Project Commodity Type Ids */
  filterByCommodityTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter By Discipline Ids */
  filterByDisciplineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by Facility Ids */
  filterByFacilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Project Milestone Type Ids */
  filterByMilestoneTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Milestone Status flags */
  filterByMilestonesStatusFlags?: InputMaybe<Array<MilestoneFilterStatusFlag>>;
  /** Filter by Superintendent/GF/FM selection */
  filterByOwners?: InputMaybe<Array<WorkPackageOwnerFilterByTerm>>;
  /** Search By Term */
  searchBy: Array<WorkPackageSearchByTerm>;
  /** Search Keyword */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  /** Sort By Term */
  sortBy: WorkPackageSortByTerm;
  /** Sort Order */
  sortOrder?: InputMaybe<SortOrder>;
  /** Start date for the date range */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type WorkPackageList = {
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<WorkPackage>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type WorkPackageOwnerFilterByTerm = {
  /** CrewMemberId of the selected persona */
  crewMemberId?: InputMaybe<Scalars['ID']['input']>;
  ownershipType?: InputMaybe<OwnershipType>;
  /** Selected Persona type */
  persona?: InputMaybe<PersonaType>;
  /** Unassigned, if set to true, the crewMemberId would be ignored */
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkPackageProgress = {
  approvedHours: Scalars['Int']['output'];
  approvedQuantity: Quantity;
  claimedHours: Scalars['Int']['output'];
  claimedQuantity: Quantity;
  committedHours: Scalars['Int']['output'];
  committedQuantity: Quantity;
  crewMemberId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  targetHours?: Maybe<Scalars['Int']['output']>;
  targetQuantity?: Maybe<Quantity>;
};

export enum WorkPackageSearchByEnum {
  AREA_NUMBER = 'AREA_NUMBER',
  COMMODITY = 'COMMODITY',
  DRAWING_NUMBER = 'DRAWING_NUMBER',
  PERSONA = 'PERSONA',
  STARTUP_SYSTEM_NUMBER = 'STARTUP_SYSTEM_NUMBER',
  TEST_PACKAGE = 'TEST_PACKAGE',
  WP_NUMBER = 'WP_NUMBER'
}

export type WorkPackageSearchByTerm = {
  /** Commodity Type ID when type is COMMODITY */
  commodityTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** Persona Type when type is PERSONA */
  personaType?: InputMaybe<PersonaType>;
  /** Search by specific field */
  type?: InputMaybe<WorkPackageSearchByEnum>;
};

export enum WorkPackageSortByTerm {
  END_DATE = 'END_DATE',
  PERCENTAGE_COMPLETE = 'PERCENTAGE_COMPLETE',
  START_DATE = 'START_DATE',
  WP_NUMBER = 'WP_NUMBER'
}

export type WorkPackageStats = {
  /** Approved this week */
  approvedMilestones?: Maybe<MilestoneStats>;
  /** Comitted plan for the week(as of begining of the week) */
  committedMilestones?: Maybe<MilestoneStats>;
  crew?: Maybe<CrewStats>;
  crewMemberId: Scalars['String']['output'];
  /** Earned this week */
  earnedMilestones?: Maybe<MilestoneStats>;
  id: Scalars['ID']['output'];
  /** The total number of blocks of all milestones in all commodities in all assigned work packages. */
  numBlocks: Scalars['Int']['output'];
  /** The total rejections of  all milestones in all commodities in all assigned work packages. */
  numRejects: Scalars['Int']['output'];
  /** The total number of assigned work packages */
  numWorkPackages: Scalars['Int']['output'];
  /** Current plan for the week */
  plannedMilestones: MilestoneStats;
  /** Planned to go milestones */
  plannedToGoMilestones: MilestoneStats;
  /** WorkPackage progress stats */
  progress: WorkPackageProgress;
};

export type WorkPackageStatsInput = {
  crewMemberId: Scalars['ID']['input'];
  endDate: Scalars['Date']['input'];
  ownershipLevel: OwnershipLevel;
  personaType: PersonaType;
  startDate: Scalars['Date']['input'];
};

export type WorkPackagesImportPayload = {
  importStatus: Scalars['String']['output'];
  workPackageCount?: Maybe<Scalars['Int']['output']>;
};

export type WorkPackagesUpdatedPayload = {
  affectedOwnerIds: Array<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  workPackageIds: Array<Scalars['ID']['output']>;
};

/** Response from SaveDeviceRegistration */
export type SaveDeviceRegistrationPayload = {
  error?: Maybe<DeviceRegistrationError>;
  success: Scalars['Boolean']['output'];
};
